import React from 'react';
import PropTypes from 'prop-types';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var IcoMoonType = "selection";
var icons = [
	{
		icon: {
			width: 943,
			paths: [
				"M65.016 107.683h101.587v812.698h-101.587v-812.698zM217.397 158.476v406.349h634.717l-203.175-203.175 203.175-203.175h-634.717z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"flag"
			],
			grid: 32
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 3565,
			id: 0,
			name: "flag",
			prevSize: 32,
			code: 59666
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 0
	},
	{
		icon: {
			width: 971,
			paths: [
				"M970.589 748.525v275.475h-970.589v-275.475h121.362v137.737h728.018v-137.737h121.209z",
				"M485.294 757.555l-275.475-413.212h206.606v-344.343h137.737v344.343h206.606l-275.475 413.212z"
			],
			attrs: [
				{
				},
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"download"
			],
			grid: 32
		},
		attrs: [
			{
			},
			{
			}
		],
		properties: {
			order: 3564,
			id: 1,
			name: "download",
			prevSize: 32,
			code: 60628
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 1
	},
	{
		icon: {
			width: 971,
			paths: [
				"M970.589 748.525v275.475h-970.589v-275.475h121.362v137.737h728.018v-137.737h121.209z",
				"M485.294 0l275.475 413.212h-206.606v344.343h-137.737v-344.343h-206.606l275.475-413.212z"
			],
			attrs: [
				{
				},
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"upload"
			],
			grid: 32
		},
		attrs: [
			{
			},
			{
			}
		],
		properties: {
			order: 3563,
			id: 2,
			name: "upload",
			prevSize: 32,
			code: 60629
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 2
	},
	{
		icon: {
			width: 1058,
			paths: [
				"M819.2 0v136.48h-682.72v751.040h682.72v136.48h-750.88c-0.336 0.006-0.732 0.009-1.129 0.009-37.114 0-67.2-30.086-67.2-67.2 0-0.397 0.003-0.793 0.010-1.189l-0.001 0.059v-887.36c-0.006-0.336-0.009-0.732-0.009-1.129 0-37.114 30.086-67.2 67.2-67.2 0.397 0 0.793 0.003 1.189 0.010l-0.059-0.001zM1058.080 512l-307.2-307.2v204.8h-477.76v204.8h477.76v204.8z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"leave"
			],
			grid: 32
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 3562,
			id: 3,
			name: "leave",
			prevSize: 32,
			code: 59667
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 3
	},
	{
		icon: {
			width: 953,
			paths: [
				"M671.695 0l277.005 277.005-277.005 277.005v-183.217q-121.293-3.006-182.916 33.517c-37.188 20.124-65.866 51.961-81.485 90.487l-0.429 1.196c-7.678 21.381-12.116 46.050-12.116 71.756 0 17.515 2.061 34.549 5.952 50.873l-0.299-1.486c9.585 45.686 25.177 86.203 46.187 123.243l-1.097-2.101c-47.051-49.816-82.978-110.662-103.476-178.219l-0.833-3.194c-9.511-29.131-14.995-62.654-14.995-97.458 0-30.899 4.323-60.789 12.397-89.098l-0.558 2.287c18.713-59.456 56.486-108.382 106.025-140.825l0.989-0.608q81.764-56.213 226.954-52.605z",
				"M953.208 753.458v270.542h-953.208v-270.542h119.189v135.271h714.981v-135.271h119.038z"
			],
			attrs: [
				{
				},
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"export"
			],
			grid: 32
		},
		attrs: [
			{
			},
			{
			}
		],
		properties: {
			order: 3561,
			id: 4,
			name: "export",
			prevSize: 32,
			code: 59668
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 4
	},
	{
		icon: {
			width: 1536,
			paths: [
				"M549.4 187c0.6 0 1.2 0 2 0 13.4 0 26.2 2.4 38 6.6l-0.8-0.2c11.6 3.8 21.6 9.6 30.2 17.2h-0.2c8 7 14.4 15.6 18.6 25.4l0.2 0.4c4.4 9.2 6.8 19.8 6.8 31.2 0 0.2 0 0.4 0 0.8v0c0 0.4 0 1 0 1.4 0 9-1.2 17.6-3.6 25.8l0.2-0.6c-2.2 7.6-5.4 14.2-9.8 20l0.2-0.2c-4.4 5.6-9.6 10.4-15.4 14.4l-0.2 0.2c-6 3.6-13 7-20.2 9.4l-0.8 0.2c17.2 5 31.6 15 42 28.2l0.2 0.2c8.8 11.8 14 26.6 14 42.6 0 1.2 0 2.2 0 3.2v-0.2c0 0.6 0 1.4 0 2.2 0 27.8-12.4 52.8-32 69.6l-0.2 0.2c-9.8 7.8-21.2 14.2-33.6 18.2l-0.8 0.2c-12 4-25.6 6.2-40 6.2-0.4 0-1 0-1.4 0v0c-0.8 0-1.8 0-2.8 0-13.6 0-26.8-2-39.4-5.6l1 0.2c-11.8-3.8-22-9.2-31-16l0.2 0.2c-8.8-7.8-16.2-17-22-27l-0.2-0.6c-5.8-10.2-11.2-22-15.2-34.4l-0.4-1.4 23.8-9.6c3.6-1.6 7.8-2.6 12.2-2.6 0 0 0 0 0 0v0c3.8 0 7.2 0.8 10.4 2.4h-0.2c2.8 1.8 5.2 4.2 6.8 7v0c3 5.8 5.8 10.8 8.8 15.4l-0.4-0.6c3.2 5 6.8 9.4 11 13.4v0c4.4 3.6 9.4 6.8 15 9.2l0.4 0.2c6 2.2 12.8 3.4 19.8 3.4 0.4 0 0.8 0 1.2 0v0c0.4 0 1 0 1.6 0 8 0 15.8-1.6 22.8-4.8l-0.4 0.2c6.6-2.8 12.4-6.6 17-11.4v0c4.4-4.6 7.8-10 10.2-15.8l0.2-0.4c2.2-5.2 3.4-11.2 3.4-17.6v0c0 0 0 0 0-0.2 0-7.2-0.8-14.2-2.4-21l0.2 0.6c-1.8-6.4-5.4-11.8-10-16v0c-6.2-4.8-13.6-8.2-21.6-10.2h-0.4c-10.6-2.4-22.8-3.8-35.4-3.8-1 0-2 0-3 0h0.2v-38.2c0.8 0 1.8 0 2.8 0 10.6 0 21-1.2 31-3.6l-1 0.2c8-2 14.8-5.4 21-9.8l-0.2 0.2c4.8-3.8 8.6-9 10.8-14.8v-0.2c2-5.6 3.2-12 3.2-18.6 0-0.2 0-0.4 0-0.4v0c0-0.8 0-1.8 0-2.8 0-12-4.6-23-12.4-31v0c-8-6.6-18.4-10.6-29.8-10.6-1.2 0-2.4 0-3.6 0.2h0.2c-0.6 0-1.2 0-1.8 0-11.4 0-21.8 3.8-30.2 10.4h0.2c-8.2 6.6-14.4 15.4-17.6 25.6v0.4c-1.2 4.6-3.6 8.6-7 11.6v0c-3 2.4-6.8 3.8-11 3.8-0.4 0-0.6 0-1 0v0h-7.4l-28.4-5.2c1.6-15.2 6-29 12.6-41.6l-0.4 0.6c6-11.2 13.8-20.6 23.2-28.4l0.2-0.2c9.6-7.6 20.6-13.4 32.8-17.2l0.8-0.2c11.4-3.8 24.6-5.8 38.2-6v0 0z",
				"M811.6 308.6c0 0 0 0 0 0 12.4 0 24.4 2.2 35.4 6.2l-0.8-0.2c22.8 8.2 40.8 25.2 50.2 46.6l0.2 0.6c4.8 11.6 7.8 25 7.8 39 0 1 0 2.2 0 3.2v-0.2c0 0.2 0 0.6 0 0.8 0 14.6-3 28.4-8.2 41l0.2-0.8c-5.6 13-13 24.2-22.4 33.6v0c-9.8 9.4-21.6 17-34.6 22.2l-0.8 0.2c-12.8 5.2-27.6 8.2-43 8.2-0.8 0-1.6 0-2.2 0h0.2c-0.8 0-1.6 0-2.6 0-15.4 0-30-3-43.4-8.2l0.8 0.2c-13.4-5.4-24.8-13-34.4-22.4v0c-9.2-9.8-16.6-21.4-21.4-34.2l-0.2-0.6c-4.6-13-7.4-28-7.4-43.6 0-0.4 0-1 0-1.4v0c0.2-16.4 3.6-32 9.4-46.4l-0.4 0.8c7.8-18.6 17.4-34.6 28.8-49l-0.4 0.4 73.4-100.2c3-4 6.8-7 11.2-9h0.2c4.8-2.4 10.4-3.8 16.4-3.8 0.4 0 0.8 0 1 0v0h47.8l-99.2 120.8-5.4 6.8c12.4-6.2 27.2-9.8 42.6-10v0l1.2-0.6zM736.2 406.4c0 8.6 1.4 16.8 3.8 24.4l-0.2-0.6c2.4 7 6 13.2 10.6 18.2v0c4.6 5.2 10.2 9.2 16.4 12.2l0.4 0.2c6.8 2.8 14.6 4.2 22.8 4.2 0.4 0 1 0 1.4 0v0c0.4 0 0.8 0 1.2 0 8 0 15.8-1.6 22.6-4.8l-0.4 0.2c7.2-2.8 13.4-6.8 18.4-12v0c5-5.2 9-11.4 11.8-18.2l0.2-0.4c2.8-6.6 4.2-14.4 4.2-22.6 0-0.2 0-0.4 0-0.6v0c0-0.4 0-1 0-1.6 0-8-1.4-15.8-4.2-23l0.2 0.4c-2.6-7.2-6.6-13.2-11.6-18.2v0c-5-5-11.2-8.8-18.2-11.2l-0.4-0.2c-6.8-2.6-14.8-4-23-4-0.2 0-0.2 0-0.4 0v0c-0.2 0-0.4 0-0.8 0-8.2 0-16 1.6-23 4.4l0.4-0.2c-7 3-13 7.2-18 12.2v0c-5 5-9 11.2-11.6 17.8l-0.2 0.4c-2 6-3.2 13-3.2 20.2 0.8 1.4 0.8 2 0.8 2.8v0 0z",
				"M1168.6 350c0 1.4 0 3.2 0 5 0 23.6-3.2 46.6-9.2 68.2l0.4-1.8c-5.2 19.2-13.4 36-24.4 50.8l0.2-0.4c-9.8 12-22 21.6-36 28.2l-0.6 0.2c-13.4 6-29.2 9.6-45.8 9.6s-32.4-3.6-46.6-10l0.8 0.2c-14.6-6.8-26.6-16.4-36.2-28.2l-0.2-0.2c-10.4-14.2-18.6-30.6-23.6-48.4l-0.2-1c-5.4-20-8.6-43.2-8.6-67 0-1.6 0-3.2 0-4.8v0.2c0-1.4 0-3.2 0-4.8 0-23.6 3.2-46.6 9-68.4l-0.4 1.8c5.2-19.2 13.6-35.8 24.4-50.4l-0.2 0.4c9.6-12 21.8-21.6 35.8-28.2l0.6-0.2c13.4-6 29.2-9.6 45.8-9.6s32.4 3.6 46.6 10l-0.8-0.2c14.6 6.8 27 16.4 36.6 28.2l0.2 0.2c10.8 14.2 19 31 24 49l0.2 1c5.4 19.6 8.6 42 8.6 65.2 0 2 0 3.8 0 5.6l-0.4-0.2zM1113.4 350c0-1.6 0-3.4 0-5.2 0-18.4-1.8-36.2-5.4-53.4l0.2 1.6c-2.6-13.4-7.2-25.4-13.6-36l0.2 0.6c-4.8-8-11.2-14.2-19-18.6l-0.2-0.2c-5-1.8-10.8-2.8-17-2.8-2 0-3.8 0.2-5.8 0.4h0.2c-8.2 0-15.8 2-22.8 5.2l0.4-0.2c-8 4.6-14.4 11-19 18.6l-0.2 0.2c-5.6 9.6-10.2 20.6-13 32.2l-0.2 0.8c-3 15.8-4.8 33.8-4.8 52.4 0 1.6 0 3.2 0 4.8v-0.2c0 1.4 0 3 0 4.4 0 18.6 1.8 36.6 5.2 54.2l-0.2-1.8c2.8 13.4 7.2 25.2 13.4 36.2l-0.4-0.6c4.6 8 11 14.2 18.8 18.6l0.2 0.2c6.6 3.2 14.2 5.2 22.4 5.4v0c8.2-0.2 16-2 22.8-5.6l-0.4 0.2c8.2-4.4 14.8-10.8 19.2-18.6l0.2-0.2c6-10.2 10.8-22.2 13.2-34.8l0.2-0.8c3.2-15.6 5.2-33.4 5.2-51.8 0-1.8 0-3.6 0-5.4l0.2 0.2z",
				"M1194.2 209.2c-32 0-57.8-26-57.8-57.8 0-32 26-57.8 57.8-57.8 32 0 57.8 26 57.8 57.8s-26 57.8-57.8 57.8zM1194.2 116.4c-19.2 0-34.8 15.6-34.8 34.8s15.6 34.8 34.8 34.8 34.8-15.6 34.8-34.8-15.6-34.8-34.8-34.8z",
				"M656.2 721c-246.2-18.8-455-99.2-455-187.4 0-56.8 85.4-100.4 211.4-128.6v-63.2c-188.6 39-323.4 108-323.4 196.8 0 123.8 263.2 244 568.8 271.4v120.4l251.4-159.8-253.2-174.6v125z",
				"M1201.2 362v68c85.4 28.4 140 67.4 140 111.2 0 73.2-151.6 136.8-345 166.4v94.4c257.4-35.8 450.6-134 450.6-245.8 0-79.8-97.4-149-245.6-194.2v0z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"360"
			],
			defaultCode: 59655,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3560,
			id: 5,
			name: "360",
			prevSize: 32,
			code: 59655,
			ligatures: "360"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 5
	},
	{
		icon: {
			width: 1536,
			paths: [
				"M621.045 649.909c0.369 0 0.738 0 1.108 0 9.046 0 17.723 1.662 25.477 4.985l-0.554-0.185c14.954 5.354 26.585 16.615 32.492 30.831l0.185 0.369c2.769 6.646 4.431 14.4 4.431 22.523 0 0.369 0 0.738 0 1.108v0c0 0.185 0 0.369 0 0.554 0 6.646-0.738 13.108-2.215 19.2l0.185-0.554c-1.477 5.538-3.692 10.523-6.646 14.954l0.185-0.185c-2.954 4.062-6.462 7.569-10.338 10.338h-0.185c-4.062 2.769-8.677 5.169-13.477 7.015l-0.369 0.185c11.446 3.692 21.231 10.708 28.062 19.754l0.185 0.185c6.277 9.046 9.969 20.123 9.969 32.123 0 0.554 0 1.108 0 1.662v0c0 0.554 0 1.108 0 1.662 0 10.338-2.215 20.308-5.908 29.169l0.185-0.554c-7.569 16.431-21.6 28.985-38.585 34.523l-0.369 0.185c-7.938 2.954-17.17 4.8-26.954 4.8-0.185 0-0.554 0-0.738 0v0c-0.185 0-0.185 0-0.369 0-9.231 0-18.092-1.477-26.585-4.062l0.554 0.185c-7.938-2.585-14.769-6.646-20.492-11.815v0c-5.908-5.354-10.892-11.631-14.585-18.831l-0.185-0.369c-4.062-7.569-7.754-16.246-10.338-25.292l-0.185-0.923 15.692-7.015c2.4-1.108 5.169-1.846 8.309-1.846 0 0 0.185 0 0.185 0v0c0.185 0 0.185 0 0.369 0 2.215 0 4.431 0.738 6.277 1.846v0c2.215 1.108 3.877 2.769 4.615 4.985v0c2.031 4.431 3.877 8.123 6.092 11.446l-0.369-0.554c2.031 3.692 4.615 6.831 7.385 9.785v0c2.954 2.769 6.277 4.985 9.969 6.646l0.185 0.185c4.431 1.846 9.6 2.954 14.954 2.954s10.523-1.108 15.138-3.137l-0.185 0.185c4.431-2.031 8.123-4.8 11.262-8.309v0c2.954-3.323 5.354-7.2 6.831-11.631v-0.185c1.477-3.877 2.4-8.309 2.4-12.923v0c0-0.185 0-0.369 0-0.554 0-5.169-0.554-10.338-1.662-15.138v0.554c-1.108-4.615-3.508-8.492-6.831-11.631v0c-4.062-3.508-8.862-6.092-14.215-7.385h-0.185c-6.831-1.662-14.585-2.769-22.523-2.769-1.292 0-2.585 0-3.877 0h0.185v-28.062c0.738 0 1.477 0 2.215 0 7.015 0 13.662-0.923 20.123-2.769l-0.554 0.185c5.354-1.292 10.154-3.692 14.031-7.2v0c3.323-2.769 5.724-6.462 7.015-10.523v-0.185c1.292-3.877 2.031-8.123 2.031-12.738 0-0.369 0-0.738 0-1.108v0c0.185-1.108 0.185-2.585 0.185-3.877 0-8.492-3.137-16.431-8.492-22.338v0c-5.354-5.169-12.554-8.492-20.677-8.492-0.554 0-0.923 0-1.477 0v0c-0.369 0-0.738 0-1.108 0-7.754 0-14.769 2.954-20.123 7.569v0c-5.538 4.985-9.785 11.262-11.815 18.646v0.185c-0.738 3.508-2.4 6.462-4.8 8.677v0c-2.031 1.662-4.615 2.585-7.385 2.585-0.185 0-0.369 0-0.554 0v0h-4.985l-18.831-3.692c1.292-10.708 4.246-20.492 8.677-29.354l-0.185 0.554c4.062-8.123 9.231-15.138 15.692-20.862v0c5.908-5.354 13.108-9.6 20.862-12.554l0.369-0.185c7.2-2.215 15.323-3.508 23.815-3.508 0.923-0.185 1.477 0 2.031 0v0 0z",
				"M795.876 738.893c8.309 0 16.246 1.662 23.446 4.615l-0.369-0.185c7.754 2.954 14.4 7.2 19.754 12.923v0c5.908 6.092 10.523 13.108 13.846 21.046l0.185 0.369c3.323 9.046 5.354 19.385 5.354 30.277s-2.031 21.231-5.538 30.831l0.185-0.554c-3.508 9.6-8.492 17.723-14.954 24.738v0c-13.108 13.846-31.569 22.523-52.062 22.523-0.185 0-0.369 0-0.369 0v0c-0.738 0-1.846 0-2.769 0-10.338 0-20.308-2.215-29.169-6.092l0.554 0.185c-9.046-4.062-16.615-9.415-22.892-16.246v0c-6.277-7.385-11.262-16.062-14.215-25.662l-0.185-0.554c-3.137-9.231-4.985-19.938-4.985-31.015 0-0.554 0-1.292 0-1.846v0c0.185-12 2.4-23.446 6.277-33.969l-0.185 0.738c4.985-13.662 11.262-25.477 19.015-36.185l-0.369 0.369 49.846-73.846c2.031-2.769 4.615-4.985 7.569-6.462h0.185c3.137-1.662 7.015-2.585 10.892-2.585 0.185 0 0.369 0 0.554 0v0h32.123l-66.646 88.615c0 1.662-2.4 3.137-3.323 4.985 3.692-2.215 8.123-4.062 12.923-5.169h0.369c4.246-1.108 9.231-1.846 14.215-1.846 0.185 0 0.369 0 0.738 0v0 0zM745.661 810.523c0 0.185 0 0.369 0 0.554 0 5.908 0.923 11.631 2.4 17.17l-0.185-0.369c1.477 5.169 3.877 9.6 7.2 13.477v0c3.137 3.877 7.015 6.831 11.631 8.677h0.185c4.431 2.031 9.6 3.137 15.138 3.137 0.369 0 0.554 0 0.923 0v0c0.185 0 0.369 0 0.554 0 5.538 0 10.708-1.108 15.508-3.323l-0.185 0.185c4.8-2.031 9.046-5.169 12.369-8.862v0c3.323-3.692 6.092-8.123 7.754-13.108v-0.185c1.846-4.615 2.954-10.154 2.954-15.692 0-0.369 0-0.738 0-1.108v0c0-0.369 0-0.738 0-1.108 0-5.908-0.923-11.815-2.769-17.17l0.185 0.369c-1.846-5.169-4.431-9.6-7.938-13.477v0c-3.323-3.508-7.385-6.462-11.815-8.309h-0.185c-4.431-1.662-9.6-2.585-14.769-2.585-0.369 0-0.738 0-0.923 0v0c-0.185 0-0.369 0-0.554 0-5.354 0-10.523 1.108-15.138 3.323l0.185-0.185c-4.8 2.215-8.677 4.985-12 8.677v0c-3.137 3.877-5.724 8.309-7.569 13.108l-0.185 0.369c-1.662 4.8-2.585 10.338-2.585 16.062-0.185-0.185-0.185 0.185-0.185 0.369v0 0z",
				"M1027.938 767.692c0 0.923 0 1.846 0 2.954 0 17.538-2.215 34.708-6.277 50.954l0.369-1.477c-3.323 14.031-9.046 26.215-16.431 37.108l0.185-0.369c-12 17.17-31.569 28.246-53.908 28.431v0c-1.292 0-2.585 0.185-4.062 0.185-9.969 0-19.385-2.215-27.877-6.092l0.369 0.185c-9.785-5.354-17.908-12.554-24-21.231l-0.185-0.185c-7.2-10.523-12.923-22.708-16.062-36l-0.185-0.738c-3.692-15.692-5.724-33.969-5.724-52.431s2.031-36.738 6.092-54.092l-0.369 1.662c3.323-14.031 9.046-26.215 16.431-37.108l-0.185 0.369c6.277-9.046 14.4-16.246 23.815-21.415l0.369-0.185c9.046-4.985 19.938-8.123 31.569-8.123v0c0.185 0 0.554 0 0.738 0 22.338 0 42.092 11.262 53.908 28.431l0.185 0.185c7.2 10.523 12.923 22.708 16.062 36l0.185 0.738c3.323 13.662 5.169 29.354 5.169 45.415 0 2.4 0 4.985-0.185 7.385v-0.554zM991.015 767.692c0-1.292 0-2.769 0-4.431 0-13.108-1.292-26.031-3.692-38.4l0.185 1.292c-1.662-9.785-4.8-18.646-9.231-26.769l0.185 0.554c-2.954-5.724-7.385-10.338-12.738-13.477h-0.185c-4.431-2.4-9.415-3.692-14.954-3.692s-10.708 1.292-15.138 3.692h0.185c-5.354 3.323-9.6 7.938-12.554 13.477l-0.185 0.185c-4.062 7.569-7.015 16.431-8.862 25.662v0.554c-2.031 11.262-3.137 24.369-3.137 37.662 0 1.292 0 2.769 0 4.062v-0.185c0 1.108 0 2.4 0 3.692 0 13.292 1.108 26.215 3.323 38.954l-0.185-1.292c1.846 9.785 4.985 18.646 9.231 26.769l-0.185-0.554c2.954 5.724 7.2 10.338 12.369 13.477h0.185c4.431 2.4 9.415 3.692 14.954 3.692s10.708-1.292 15.138-3.692h-0.185c5.538-3.323 9.785-7.938 12.738-13.477v-0.185c4.062-7.569 7.2-16.431 8.862-25.662v-0.554c2.215-11.077 3.508-24 3.508-36.923 0-1.477 0-2.954 0-4.431h0.369z",
				"M1062.091 668.924c-21.046 0-38.4-18.646-38.4-41.538s17.17-41.538 38.4-41.538 38.4 18.646 38.4 41.538-17.354 41.538-38.4 41.538zM1062.091 601.723c-12.369 0-22.523 11.631-22.523 25.662s10.154 25.662 22.523 25.662 22.523-11.631 22.523-25.662-10.154-25.662-22.523-25.662z",
				"M1132.246 343.262v41.169c180.923 40.615 300.555 110.769 300.555 190.708 0 84.369-133.846 157.477-332.677 197.169v39.877c257.908-42.462 435.877-132.554 435.877-236.308 0-101.169-164.123-188.308-403.754-232.615v0z",
				"M513.414 789.846l-160.615-159.692-13.846 118.154c-143.815-41.723-236.308-105.046-236.308-173.539 0-78.831 119.815-149.908 300.555-190.708v-40.985c-239.077 44.492-403.2 131.632-403.2 231.878 0 89.723 131.262 169.108 333.786 216.554l-12 96.554 191.631-98.215z",
				"M1101.784 204.984h-44.862c-0.369 0-0.923 0-1.292 0-4.8 0-9.046 1.846-12.185 4.985v0c-5.169 6.092-8.677 19.2-13.477 19.2h-15.508c-3.323-7.385-7.569-15.508-12.369-23.631-7.2-11.815-13.846-21.6-21.046-31.015l0.554 0.923c0 0-11.077-12.369-17.354-17.908-8.862-8.309-20.308-13.846-33.046-15.508h-0.369c-18.092-2.4-41.538-4.246-41.538-4.246l-52.431-1.846h-133.662l-51.138 1.846c0 0-23.631 1.846-41.538 4.246-13.108 1.662-24.554 7.2-33.6 15.508v0c-6.277 5.538-16.985 17.908-16.985 17.908-6.831 8.677-13.662 18.646-19.754 28.8l-0.738 1.292c-4.246 6.646-8.309 14.4-11.815 22.523l-0.554 1.108h-21.6c-4.8 0-8.123-13.108-13.477-19.2-3.137-3.137-7.385-4.985-12-4.985-0.369 0-0.554 0-0.738 0v0h-44.862c-0.554 0-1.292-0.185-2.031-0.185-8.677 0-15.876 7.015-16.062 15.692v14.215c0 8.677 18.646 21.785 35.631 22.338h59.631c-6.831 4.985-17.354 12.554-23.815 17.908-19.938 15.508-33.785 20.677-33.785 48.554 0 0.554 0 1.108 0 1.846 0 31.569 1.662 62.769 4.8 93.416l-0.369-3.877 3.877 33.415c0.554 4.615 1.292 8.677 2.585 12.554l-0.185-0.554v58.523c0.554 9.231 8.123 16.615 17.538 16.615 0.369 0 0.738 0 1.108 0v0h84.555c0.369 0 0.738 0 1.108 0 9.415 0 16.985-7.385 17.538-16.615v0-29.354h365.539v29.354c0.554 9.231 8.123 16.615 17.538 16.615 0.369 0 0.738 0 1.108 0v0h83.815c0.369 0 0.738 0 1.108 0 9.415 0 16.985-7.385 17.538-16.615v0-47.262c2.954-6.831 5.354-14.585 6.462-22.892v-0.554l3.692-33.415c2.954-26.954 4.8-57.969 4.8-89.538 0-0.554 0-1.292 0-1.846v0.185c0-27.877-13.846-33.046-34.154-48.554-6.646-5.169-16.985-12.923-23.815-17.908h53.354c16.985 0 35.631-13.662 35.631-22.338v-14.215c-0.185-8.677-7.385-15.508-16.062-15.508-0.738 0-1.108 0-1.292 0v0 0zM557.907 228.985c6.277-12.185 13.108-22.708 20.862-32.492l-0.369 0.369c5.354-6.831 11.446-12.738 18.092-17.908l0.185-0.185c12.185-5.354 26.585-8.862 41.538-9.785h0.369c37.108-3.323 96.923-3.323 96.923-3.323h66.092c0 0 60.185 0 97.108 3.323 15.323 0.738 29.538 4.246 42.462 9.969l-0.738-0.369c6.831 5.354 12.923 11.446 18.277 17.908l0.185 0.185c7.015 9.231 13.477 19.754 18.646 30.831l0.554 1.108c9.231 18.092-6.646 22.892-14.4 23.077l-390.277-0.185c-7.754 0.369-23.631-4.431-15.508-22.523v0zM567.69 440.923c-21.231 0-37.846 0-54.277 0s-17.908-15.138-17.908-21.6 4.985-7.385 12.923-7.385h46.523c6.277 0 12.369 1.292 17.908 3.508l-0.369-0.185c4.062 1.846 7.385 4.431 10.154 7.569v0c2.4 2.954 4.246 6.462 5.169 10.338v0.185c0.738 4.246-1.662 7.385-19.385 7.385l-0.738 0.185zM614.214 358.954c-14.585 2.585-31.569 4.062-48.738 4.062-3.877 0-7.754 0-11.631-0.185h0.554c-2.954 0.369-6.462 0.554-9.785 0.554-12.923 0-25.292-3.137-36-8.677l0.369 0.185c-11.262-5.908-18.831-16.985-19.754-30.092v-0.185c-1.662-15.508 0-23.446 21.969-23.631 0.738 0 1.477 0 2.215 0 25.477 0 49.662 5.724 71.262 15.876l-0.923-0.369c15.508 5.538 28.8 13.846 39.692 24.738v0c1.108 1.662 1.846 3.877 1.846 6.092 0 5.908-4.431 10.708-10.154 11.446v0l-0.923 0.185zM842.030 433.169h-145.662c-19.385 0-54.831-3.137-54.831-26.215 0.185-9.046 2.769-17.354 7.2-24.369l-0.185 0.185c7.754-17.354 24.554-29.169 44.308-29.909v0c21.231-2.954 45.785-4.8 70.708-4.8 1.846 0 3.692 0 5.724 0h-0.369c1.662 0 3.508 0 5.538 0 24.923 0 49.662 1.662 73.662 4.985l-2.769-0.369c19.2 0.738 35.631 11.631 44.308 27.508l0.185 0.369c4.246 6.831 7.015 15.138 7.015 24.185v0c0 24.554-35.446 28.431-54.831 28.431v0zM1022.953 441.662c-16.615 0-32.862 0-54.092 0s-20.308-3.137-20.308-7.385c0.923-4.062 2.769-7.569 5.354-10.523v0c2.769-3.137 6.092-5.724 9.785-7.569h0.185c5.354-2.215 11.446-3.323 17.908-3.323h46.523c7.569 0 12.923 1.292 12.923 7.385s-4.8 20.677-18.092 20.677l-0.185 0.738zM1047.322 325.538c-1.292 12.554-8.862 23.262-19.569 28.8l-0.185 0.185c-10.338 5.354-22.708 8.492-35.631 8.492-3.508 0-7.015-0.185-10.523-0.738h0.369c-3.323 0.185-7.015 0.185-10.892 0.185-17.354 0-34.154-1.477-50.769-4.431l1.662 0.185c-5.908-0.554-10.708-5.538-10.708-11.446 0-2.215 0.554-4.431 1.846-6.092v0c10.892-10.708 24-19.015 38.585-24.369l0.738-0.185c19.938-9.046 43.2-14.215 67.754-14.215 1.662 0 3.508 0 5.169 0h-0.185c23.077 0 23.631 7.385 21.969 22.892l0.369 0.738z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"exterior"
			],
			defaultCode: 59652,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3559,
			id: 6,
			name: "360-exterior",
			prevSize: 32,
			code: 59652,
			codes: [
				59652,
				59673,
				59674,
				59675,
				59676,
				59677,
				59678
			],
			ligatures: "360-exterior"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 6
	},
	{
		icon: {
			width: 1536,
			paths: [
				"M616.432 672.061c0.186 0 0.554 0 0.923 0 9.046 0 17.723 1.662 25.846 4.615l-0.554-0.186c7.754 3.138 14.4 7.385 19.938 12.554v0c5.354 5.169 9.6 11.446 12.554 18.462l0.186 0.369c2.769 6.462 4.431 14.215 4.431 22.154 0 0.369 0 0.923 0 1.292v0c0 0.186 0 0.369 0 0.738 0 6.646-0.738 13.108-2.215 19.385l0.186-0.554c-1.477 5.538-3.692 10.338-6.646 14.585l0.186-0.186c-2.769 4.246-6.277 7.569-10.338 10.338h-0.186c-4.062 2.769-8.677 5.169-13.477 7.2l-0.554 0.186c11.631 3.323 21.231 10.338 28.062 19.569l0.186 0.186c5.723 8.862 9.232 19.569 9.232 31.2 0 0.923 0 1.662 0 2.585v-0.186c0 0.554 0 1.292 0 1.846 0 10.338-2.215 20.123-5.908 28.985l0.186-0.554c-3.692 8.862-8.862 16.246-15.508 22.338v0c-6.462 5.908-14.031 10.523-22.338 13.477l-0.554 0.186c-7.754 2.769-16.8 4.431-26.215 4.431-0.554 0-0.923 0-1.477 0v0c-0.186 0-0.186 0-0.369 0-9.232 0-18.092-1.477-26.585-4.062l0.554 0.186c-7.938-2.585-14.769-6.646-20.492-11.815v0c-5.908-5.354-10.708-11.631-14.585-18.462l-0.186-0.369c-4.062-7.569-7.754-16.246-10.338-25.292l-0.186-0.923 15.692-7.015c2.4-1.292 5.354-2.031 8.308-2.031v0c2.4 0 4.615 0.738 6.646 1.846v0c2.031 1.292 3.692 2.954 4.615 5.169v0c1.846 4.246 3.877 7.754 5.908 11.077l-0.186-0.369c2.031 3.692 4.615 6.831 7.385 9.785v0c2.769 2.954 6.277 5.169 9.969 6.831h0.186c3.877 1.662 8.308 2.585 12.923 2.585 0.369 0 0.738 0 1.108 0v0c0.369 0 0.738 0 1.108 0 5.354 0 10.523-1.108 15.139-3.323l-0.186 0.186c4.431-2.215 8.123-4.985 11.262-8.677v0c2.954-3.138 5.354-7.015 6.831-11.262v-0.186c1.477-3.877 2.4-8.492 2.4-13.108v0c0-0.186 0-0.369 0-0.738 0-4.985-0.554-9.969-1.662-14.769v0.369c-1.108-4.615-3.508-8.492-6.831-11.446v0c-4.062-3.508-8.862-6.277-14.215-7.569h-0.186c-7.2-1.662-15.323-2.585-23.815-2.585-0.923 0-1.662 0-2.585 0h0.186v-27.323c0.738 0 1.477 0 2.215 0 7.015 0 13.662-0.923 19.938-2.769l-0.554 0.186c5.723-1.477 10.523-4.062 14.4-7.938v0c3.323-2.954 5.723-6.462 7.385-10.523v-0.186c1.108-4.062 1.846-8.492 1.846-13.292 0-0.369 0-0.554 0-0.923v0c0-0.738 0.186-1.846 0.186-2.769 0-8.492-3.138-16.062-8.308-21.969v0c-5.354-5.169-12.554-8.492-20.677-8.492-0.554 0-0.923 0-1.477 0v0c-0.369 0-0.738 0-1.292 0-7.754 0-14.769 2.769-20.123 7.385v0c-5.538 4.985-9.6 11.446-11.815 18.831v0.369c-0.738 3.508-2.4 6.462-4.8 8.677v0c-2.215 1.662-4.8 2.585-7.754 2.585 0 0 0 0 0 0h-4.985l-18.831-3.692c1.292-10.892 4.246-20.677 8.677-29.723l-0.186 0.554c4.062-8.123 9.415-14.954 15.692-20.677v0c5.908-5.354 13.108-9.6 20.862-12.554l0.369-0.186c7.938-2.769 16.615-4.431 25.477-4.615v0 0z",
				"M791.078 761.045c0.186 0 0.369 0 0.369 0 8.123 0 15.877 1.477 23.077 4.431l-0.369-0.186c7.754 2.954 14.4 7.385 19.754 13.108v0c5.538 6.093 9.969 13.108 12.738 21.046l0.186 0.369c3.323 8.862 5.354 19.2 5.354 30.092s-2.031 21.046-5.538 30.646l0.186-0.554c-3.323 9.6-8.492 17.908-14.954 24.738v0c-6.462 7.015-14.215 12.554-22.892 16.431l-0.369 0.186c-8.492 3.877-18.278 6.093-28.8 6.093-0.554 0-0.923 0-1.477 0v0c-0.369 0-0.923 0-1.477 0-10.338 0-20.123-2.215-29.169-5.908l0.554 0.186c-9.046-4.062-16.615-9.6-22.708-16.431v0c-6.277-7.385-11.262-16.062-14.215-25.662l-0.186-0.554c-2.769-8.677-4.246-18.646-4.246-29.169 0-1.292 0-2.4 0-3.692v0.186c0.186-12 2.4-23.446 6.277-34.154l-0.186 0.738c4.985-13.477 11.262-25.292 19.015-35.815l-0.369 0.369 49.846-73.846c2.031-2.769 4.615-4.985 7.569-6.462h0.186c3.323-1.846 7.385-2.954 11.446-2.954 0 0 0 0 0 0h31.754l-62.215 83.815-3.877 4.985-3.323 4.985c3.692-2.031 8.123-3.877 12.738-5.169l0.369-0.186c4.062-1.108 8.677-1.662 13.292-1.662 0.554 0 1.108 0 1.662 0v0 0zM741.786 832.492c0 0.186 0 0.554 0 0.738 0 5.908 0.923 11.815 2.4 17.169l-0.186-0.369c1.477 5.169 3.877 9.6 7.2 13.477v0c3.138 3.692 7.2 6.646 11.631 8.492h0.186c4.431 2.031 9.6 3.138 15.139 3.138 0.369 0 0.554 0 0.923 0v0c0.186 0 0.554 0 0.923 0 10.708 0 20.492-4.615 27.138-12v0c3.323-3.877 6.093-8.308 7.754-13.292v-0.369c1.846-4.615 2.954-9.969 2.954-15.508 0-0.554 0-0.923 0-1.477v0c0-0.369 0-0.738 0-1.108 0-5.908-0.923-11.446-2.769-16.8l0.186 0.369c-1.846-5.169-4.431-9.6-7.938-13.477v0c-3.323-3.692-7.385-6.462-11.815-8.308h-0.186c-4.615-1.846-9.969-2.954-15.508-2.954 0 0-0.186 0-0.186 0v0c-10.523 0.186-19.754 4.8-26.215 12v0c-3.323 3.692-5.908 8.308-7.569 13.108v0.369c-2.4 4.985-3.692 10.708-4.062 16.8v0 0z",
				"M1023.324 789.662c0 0.923 0 2.215 0 3.323 0 17.538-2.215 34.523-6.462 50.585l0.369-1.477c-3.323 14.031-9.046 26.215-16.431 37.108l0.186-0.369c-6.277 9.046-14.4 16.431-24 21.416l-0.369 0.186c-8.862 4.431-19.2 7.015-30.092 7.015-0.186 0-0.186 0-0.369 0v0c-0.186 0-0.554 0-0.923 0-22.338 0-42.092-11.446-53.538-28.615l-0.186-0.186c-7.385-10.523-12.923-22.708-16.062-36l-0.186-0.738c-3.692-14.954-5.723-32.123-5.723-49.662 0-0.923 0-2.031 0-2.954v0.186c0-0.738 0-1.477 0-2.4 0-17.723 2.031-35.077 6.093-51.693l-0.369 1.477c3.323-13.846 9.046-26.031 16.431-36.923l-0.186 0.369c12.369-17.354 32.308-28.615 55.015-28.615 10.892 0 21.231 2.585 30.462 7.2l-0.369-0.186c9.969 5.169 18.278 12.369 24.185 21.231l0.186 0.186c7.2 10.338 12.923 22.523 16.062 35.815l0.186 0.738c3.877 14.954 6.093 31.938 6.093 49.662 0 1.292 0 2.4 0 3.323v0 0zM986.216 789.662c0-1.477 0-3.138 0-4.8 0-13.292-1.292-26.215-3.692-38.769l0.186 1.292c-1.662-9.785-4.8-18.646-9.232-26.769l0.186 0.554c-2.954-5.723-7.385-10.338-12.738-13.662h-0.186c-4.246-2.4-9.415-3.877-14.954-3.877s-10.708 1.477-15.139 4.062h0.186c-5.354 3.323-9.6 7.938-12.554 13.477v0.186c-4.062 7.569-7.015 16.431-8.862 25.662l-0.186 0.554c-2.031 12.554-3.138 26.769-3.138 41.538s1.108 28.985 3.323 43.015l-0.186-1.477c1.846 9.785 4.985 18.646 9.232 26.769l-0.186-0.554c2.954 5.723 7.2 10.338 12.369 13.662h0.186c4.246 2.4 9.415 3.877 14.954 3.877s10.708-1.477 15.139-4.062h-0.186c5.538-3.323 9.969-7.938 12.738-13.477v-0.186c4.062-7.569 7.2-16.431 8.862-25.662v-0.554c2.215-11.262 3.508-24 3.508-37.292 0.369-1.292 0.369-2.4 0.369-3.508v0 0z",
				"M792.001 593.968h-48l-12.923-1.846c-19.569-2.031-37.477-5.538-54.462-10.708l2.031 0.554c-31.754-9.415-59.446-22.523-84.554-39.508l1.108 0.738c-19.2-12.923-35.815-27.323-50.4-43.569l-0.186-0.186c-13.662-15.139-25.477-32.492-34.892-51.138l-0.554-1.292c-8.862-17.538-15.323-37.846-18.278-59.446l-0.186-0.923c0-3.692-1.662-7.015-2.031-10.523v-42.277c1.292-7.938 2.585-15.692 4.246-23.446 4.246-20.492 11.077-38.585 20.123-55.385l-0.554 1.108c16.431-30.277 38.031-55.754 63.508-76.246l0.554-0.369c4.246-3.138 9.232-6.277 14.4-9.232l0.738-0.369c13.662-8.492 26.215-16.985 41.723-24.369 20.308-10.338 43.938-18.462 68.862-22.892l1.477-0.186c12.923-2.769 28.246-4.985 43.938-5.908h0.923c18.462 0 37.108 0 55.754 1.846 19.385 1.662 37.292 5.169 54.277 10.523l-1.846-0.554c31.938 9.232 59.815 22.338 85.108 39.508l-1.108-0.738c19.2 12.923 35.815 27.508 50.4 43.938l0.186 0.186c13.662 15.139 25.477 32.492 34.892 51.138l0.554 1.292c10.892 21.416 18.092 46.523 20.123 73.108v0.738c0.554 5.538 0.738 11.815 0.738 18.278 0 13.292-1.292 26.4-3.692 38.954l0.186-1.292c-4.246 21.785-11.077 41.169-20.308 58.892l0.554-1.292c-17.723 33.415-41.538 61.292-70.338 83.077l-0.554 0.369c-14.585 10.708-31.015 20.492-48.369 28.431l-1.662 0.738c-28.8 14.215-62.4 24.185-97.663 28.062l-1.292 0.186-12.554 2.031zM768.001 174.707l-31.569 2.585c-19.569 2.4-37.292 7.015-53.908 13.846l1.292-0.554c-26.031 9.969-48.369 24-67.386 41.538l0.186-0.186c-13.846 12.185-25.662 26.215-35.262 41.723l-0.369 0.738c-0.923 1.662-1.477 3.877-1.477 5.908 0 3.877 1.846 7.385 4.615 9.785v0c2.585 2.4 5.908 4.062 9.785 4.062 2.585 0 4.985-0.738 7.015-2.031v0c27.323-11.815 59.262-21.785 92.308-28.062l2.954-0.554c19.015-3.692 41.354-6.277 64.062-6.831h0.554c8.492 0 16.985 0 26.215 0 10.338 0.186 20.308 0.923 30.277 2.215l-1.292-0.186c21.046 3.877 42.277 7.569 62.954 13.108s36.739 12.554 55.201 19.2c8.492 2.954 13.662 2.954 18.646-1.292s6.831-8.677 2.4-16.615c-12.185-20.308-27.508-37.292-45.6-51.138l-0.369-0.369c-11.446-9.232-24.555-17.354-38.4-24.185l-1.292-0.554c-29.723-14.4-64.615-22.892-101.354-22.892 0 0.738-0.186 0.738-0.186 0.738v0 0zM812.862 516.061v4.985c0 6.646 5.538 9.415 12.554 7.569l13.477-4.431c36.185-11.631 67.016-31.385 91.569-57.231v0c16.062-17.169 29.169-37.477 38.215-59.815l0.369-1.292c2.585-7.015 0-12-9.785-11.631-10.708 0.186-21.046 1.108-31.2 2.769l1.292-0.186c-26.954 4.246-50.769 15.139-70.338 31.2l0.186-0.186c-13.108 10.523-24 23.262-31.938 37.662l-0.369 0.554c-7.938 14.031-13.292 30.462-14.769 48.185v0.369l0.738 1.477zM584.308 394.584h-6.646c-7.569 0-11.815 4.8-9.232 10.708 4.062 10.708 7.938 19.385 12.185 27.692l-0.738-1.477c11.631 21.231 26.954 39.138 45.6 52.985l0.369 0.369c7.569 5.723 15.508 11.631 23.631 16.8 17.354 10.523 37.477 19.015 58.892 24.369l1.477 0.369c7.569 1.846 12.923 0 13.108-7.938s0-7.385 0-11.077c-1.108-16.431-6.093-31.569-13.846-44.862l0.186 0.369c-12.369-21.785-30.277-39.323-51.877-50.769l-0.738-0.369c-20.862-10.892-45.6-17.354-71.815-17.354 0 0-0.369 0-0.554 0.186v0 0zM768.001 304.675c-1.108 0-2.4-0.186-3.692-0.186-28.062 0-51.323 21.416-54.092 48.738v0.186c4.431 28.246 28.431 49.477 57.6 49.477s53.169-21.416 57.6-49.292v-0.369c-2.954-27.692-26.215-48.924-54.277-48.924-1.108 0.369-2.215 0.369-3.138 0.369v0 0z",
				"M1132.247 344.367v41.169c180.923 40.615 300.554 110.769 300.554 190.708 0 84.369-133.847 157.477-332.678 197.169v39.878c257.908-42.277 435.877-132.554 435.877-236.308 0-101.169-164.123-188.308-403.755-232.615v0z",
				"M513.416 790.953l-160.615-159.692-13.846 118.338c-143.815-41.723-236.308-105.046-236.308-173.539 0-78.831 119.815-149.909 300.554-190.708v-41.169c-239.077 44.492-403.2 131.631-403.2 232.063 0 90.092 131.262 169.292 333.786 216.554l-12 96.554 191.631-98.4z",
				"M1057.293 691.261c-21.046 0-38.4-18.646-38.4-41.538s17.169-41.538 38.4-41.538 38.4 18.646 38.4 41.538-17.169 41.538-38.4 41.538zM1057.293 624.061c-12.369 0-22.523 11.631-22.523 25.662s10.154 25.662 22.523 25.662 22.523-11.631 22.523-25.662-9.969-25.662-22.523-25.662z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"360-interior-front"
			],
			defaultCode: 59661,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3558,
			id: 7,
			name: "360-interior-front",
			prevSize: 32,
			code: 59661,
			codes: [
				59661,
				59679,
				59680,
				59681,
				59682,
				59684,
				59688
			],
			ligatures: "360-interior-front"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 7
	},
	{
		icon: {
			width: 1536,
			paths: [
				"M632.865 347.624v0c5.169 0.184 11.076 0.184 16.983 0.184 14.585 0 28.985-0.552 43.2-1.661l-1.845 0.184c7.753-2.586 13.661-9.046 15.506-16.983v-0.184c0-21.786-3.138-43.568-3.879-65.354 0-14.218-6.646-20.677-20.677-20.493l-97.663-0.739c-12.924 0-19.753 4.983-19.937 18.46 0 22.522-2.029 45.418-3.879 67.94-1.293 14.401 5.54 18.46 18.648 17.908 18.092 0.739 35.815 0.739 53.538 0.739v0z",
				"M557.912 375.13c-4.247 23.447-5.724 47.262-8.494 72.555h171.138c-3.138-26.217-4.983-49.66-9.786-73.291 0-4.983-11.264-11.632-17.355-11.632-39.878 0-78.831 0-119.261 0-7.017 1.109-13.108 5.908-16.246 12.368v0 0z",
				"M598.159 131.809c22.522 0 45.418 0 67.94 0s30.275-9.786 30.462-31.2c0-45.601-1.661-47.999-47.262-47.815h-48.555c-28.062 0-31.568 4.247-31.752 33.045 0 5.54 0 11.264 0 16.799-0.552 19.937 8.678 29.723 29.171 29.171v0z",
				"M1056.926 460.792c0-0.552 0-1.293 0-1.845 0-12.924-10.523-23.447-23.447-23.447-2.216 0-4.247 0.368-6.276 0.925h0.184c-16.983 7.385-31.568 16.246-44.861 26.585l0.368-0.368h-163.385l-26.217-22.522v-8.123c4.431-59.814 9.414-118.708 12.924-177.414 0-19.384 7.937-27.508 27.878-26.217 34.706 0 69.601 0 105.049 0s32.126 1.661 34.338 32.309c4.247 57.045 9.786 113.91 15.138 175.569 19.753-10.155 42.276-14.77 47.815-26.217 2.029-8.678 3.322-18.46 3.322-28.614s-1.109-19.937-3.506-29.539l0.184 0.925c0-11.076-4.799-21.97-6.646-33.415-7.385-42.832-14.954-85.847-21.23-128.864-0.552-26.217-21.97-47.262-48.371-47.262-1.477 0-2.954 0-4.431 0.184h0.184c-43.568 0-87.508 0-131.26 0-35.999 0-52.43 17.908-55.94 52.43-1.845 19.384-4.799 38.769-7.569 57.969-3.322-21.23-7.017-42.464-10.155-63.877-0.368-26.032-21.601-47.078-47.815-47.078-1.661 0-3.322 0-4.983 0.184h0.184c-43.568 0-87.508 0-131.26 0-35.999 0-52.43 18.092-55.94 52.43s-9.414 68.86-13.845 103.199-9.414 68.492-12.368 103.199c0.739 8.123 4.983 14.954 11.264 19.384v0c11.264 4.247 24.555 7.937 38.217 10.155l1.109 0.184c4.431-59.814 9.414-118.708 12.924-177.414 0-19.384 7.937-26.217 27.878-26.217 34.706 0 69.601 0 105.049 0s32.126 1.661 34.338 32.309c4.247 56.492 9.786 112.985 15.138 173.908v7.385l-18.832 21.23h-183.879c-0.925-15.694-13.845-28.062-29.539-28.062-3.506 0-7.017 0.552-10.155 1.845h0.184c-23.815 4.799-22.522 23.815-22.522 42.091 0 18.092 0 30.648 0 46.154 0 0.739-0.184 1.845-0.184 2.77 0 16.062 13.108 29.171 29.171 29.171 0.925 0 1.845 0 2.954-0.184h-0.184c89.722 0 179.816 0 269.723-1.845v0l256.061-1.661c2.216 0.552 4.615 0.925 7.017 0.925 14.218 0 25.845-11.264 26.217-25.292v0c0.552-10.155 0.925-21.97 0.925-33.786s-0.368-23.815-1.109-35.447l0.184 1.293z",
				"M889.111 345.778v0c8.678 0.552 18.832 0.739 29.171 0.739s20.493-0.368 30.462-0.925h-1.477c7.753-2.77 13.477-9.23 15.506-17.171v-0.184c0-21.601-3.138-43.384-3.879-65.17 0-14.218-6.646-20.677-20.677-20.677-32.493 0-65.17 0-97.106 0-12.924 0-19.753 4.983-19.937 18.648 0 22.522-1.293 45.23-3.879 67.757 0 14.401 5.54 18.648 18.648 18.092 17.723-1.293 35.447-0.925 53.17-1.109v0z",
				"M813.79 373.841c-4.247 23.631-5.724 47.447-8.494 72.555h171.138c-3.138-26.217-4.983-49.66-9.786-72.923 0-4.983-11.264-11.632-17.355-11.816-39.878 0-78.831 0-119.261 0-7.017 1.293-13.108 5.724-16.246 12.184v0 0z",
				"M854.404 130.148c22.522 0 45.418 0 67.94 0s29.355-10.155 29.355-31.752c0-45.97-1.661-47.999-47.262-47.999h-47.447c-28.062 0-31.568 4.247-31.752 33.045 0 5.54 0 11.264 0 16.799-0.552 20.861 8.678 30.462 29.171 29.907v0z",
				"M338.771 749.531c-143.817-41.723-236.308-105.049-236.308-173.54 0-78.831 119.818-149.908 300.553-190.707v-41.171c-238.895 44.677-403.015 131.633-403.015 231.877 0 90.095 131.26 169.293 333.788 216.556l-12 96.922 190.707-98.583-159.88-159.692-13.845 118.341z",
				"M646.526 782.948c5.357-2.029 9.97-4.431 14.218-7.201l-0.184 0.184c4.063-2.954 7.569-6.46 10.339-10.707v-0.184c2.954-4.063 5.169-8.862 6.46-14.030v-0.368c1.293-5.54 2.029-12.184 2.029-18.832 0-0.184 0-0.552 0-0.739v0c0-0.368 0-0.739 0-1.109 0-8.123-1.661-15.694-4.615-22.707l0.184 0.368c-2.954-7.385-7.017-13.661-12-18.832v0c-5.54-5.357-12.184-9.598-19.569-12.368l-0.368-0.184c-7.569-2.77-16.246-4.431-25.292-4.431-0.368 0-0.739 0-0.925 0v0c-0.184 0-0.552 0-0.925 0-9.046 0-17.908 1.477-26.032 4.431l0.552-0.184c-8.309 2.954-15.322 7.201-21.414 12.741v0c-6.46 5.908-11.816 12.741-15.506 20.677l-0.184 0.368c-4.063 8.309-7.201 18.092-8.309 28.43v0.368l18.832 3.691h4.983c0 0 0 0 0 0 2.954 0 5.724-0.925 7.753-2.586v0c2.402-2.216 4.063-5.169 4.615-8.494v-0.184c2.216-7.569 6.276-14.030 11.816-19.2v0c5.54-4.615 12.741-7.385 20.493-7.385 0.184 0 0.552 0 0.739 0v0c0.368 0 0.925 0 1.477 0 8.123 0 15.322 3.138 20.677 8.494v0c5.169 5.908 8.309 13.661 8.309 22.154 0 0.925 0 1.845-0.184 2.586v-0.184c0 0.368 0 0.739 0 1.109 0 4.615-0.739 9.23-1.845 13.477v-0.368c-1.661 4.247-4.063 7.937-7.385 10.707v0c-3.879 3.322-8.494 5.908-13.661 7.017h-0.184c-5.908 1.661-12.553 2.586-19.569 2.586-0.739 0-1.661 0-2.402 0h0.184v28.062c0.925 0 1.845 0 2.954 0 8.309 0 16.431 1.109 23.999 3.138l-0.739-0.184c5.54 1.293 10.523 3.879 14.401 7.385v0c3.322 2.954 5.724 7.017 6.834 11.447v0.184c0.925 4.247 1.661 9.23 1.661 14.401 0 0.368 0 0.552 0 0.925v0c0 4.615-0.925 9.046-2.402 13.108v-0.184c-3.138 9.046-9.598 16.246-17.908 20.125h-0.184c-4.431 2.029-9.598 3.138-14.954 3.138-0.368 0-0.739 0-1.109 0v0c-0.368 0-0.739 0-0.925 0-4.615 0-9.046-0.925-13.108-2.77h0.184c-4.063-1.661-7.385-3.879-10.155-6.834v0c-2.77-2.77-5.169-5.908-7.201-9.23l-0.184-0.184c-1.845-2.954-3.691-6.646-5.54-10.339l-0.368-0.739c-0.925-2.216-2.586-4.063-4.615-5.169v0c-1.845-0.925-4.063-1.661-6.276-1.661 0 0-0.184 0-0.184 0v0c0 0-0.184 0-0.184 0-2.954 0-5.908 0.739-8.309 1.845h0.184l-15.694 7.017c2.77 9.97 6.46 18.832 10.891 26.953l-0.368-0.739c3.879 7.385 8.862 13.661 14.585 19.2v0c5.724 4.983 12.553 8.862 20.125 11.447l0.368 0.184c8.309 2.77 17.723 4.431 27.508 4.431s19.384-1.661 28.246-4.615l-0.552 0.184c8.862-3.138 16.431-7.753 22.891-13.661v0c6.46-6.092 11.816-13.477 15.322-21.601l0.184-0.368c3.691-8.494 5.724-18.46 5.724-28.985 0-0.552 0-1.109 0-1.661v0c0-0.739 0-1.661 0-2.586 0-11.447-3.506-22.154-9.414-31.2l0.184 0.184c-7.201-9.598-17.171-16.615-28.798-19.937l-0.184 0.184z",
				"M833.91 778.15c-5.357-5.724-12-10.155-19.384-12.924l-0.368-0.184c-6.834-2.586-14.77-4.247-23.078-4.247-5.357 0-10.707 0.739-15.878 1.845l0.368-0.184c-4.983 1.477-9.414 3.138-13.477 5.357l0.368-0.184 3.322-4.799 3.879-5.169 62.768-83.077h-32.126c-0.184 0-0.368 0-0.552 0-4.063 0-7.753 0.925-11.076 2.77h0.184c-2.954 1.661-5.54 3.879-7.569 6.46v0l-49.848 73.848c-7.385 10.523-13.661 22.522-18.276 35.447l-0.368 1.109c-3.691 9.97-5.908 21.414-6.092 33.229v0c0 0.552 0 1.109 0 1.845 0 11.264 1.845 21.97 5.169 32.126l-0.184-0.739c3.138 10.155 8.123 18.832 14.585 26.401v-0.184c6.276 7.017 13.845 12.553 22.338 16.431l0.368 0.184c8.678 3.879 18.648 6.092 29.171 6.092 0.368 0 0.739 0 0.925 0v0c0.184 0 0.368 0 0.552 0 10.707 0 20.861-2.216 30.091-6.276l-0.552 0.184c9.23-4.247 16.983-9.786 23.263-16.799v0c6.46-6.834 11.632-14.954 14.77-23.999l0.184-0.552c3.322-9.046 5.357-19.384 5.357-30.275s-2.029-21.23-5.54-30.832l0.184 0.552c-2.77-9.046-7.385-16.983-13.477-23.447v0 0zM814.158 849.596c-1.845 5.169-4.615 9.598-7.937 13.477v0c-3.138 4.063-7.201 7.385-11.816 9.598h-0.184c-4.431 2.029-9.786 3.138-15.138 3.138-0.184 0-0.368 0-0.552 0v0c-0.184 0-0.552 0-0.925 0-5.54 0-10.707-1.109-15.322-3.322l0.184 0.184c-4.615-2.029-8.678-4.983-11.816-8.678v0c-3.138-3.691-5.54-8.309-7.017-13.108v-0.184c-1.477-4.983-2.402-10.891-2.402-16.799 0-0.368 0-0.552 0-0.925v0c0-0.184 0-0.368 0-0.552 0-5.724 0.925-11.264 2.77-16.246l-0.184 0.368c3.138-9.97 10.339-17.908 19.384-22.154l0.184-0.184c4.431-2.029 9.598-3.138 14.954-3.138 0.184 0 0.368 0 0.552 0v0c5.54 0 10.707 1.109 15.506 2.954l-0.368-0.184c4.799 2.029 8.678 4.799 12 8.309v0c3.322 3.691 6.092 8.123 7.753 13.108v0.184c1.661 4.983 2.586 10.707 2.586 16.799 0 0.368 0 0.739 0 1.109v0c0 0.368 0 0.552 0 0.925 0 5.357-0.925 10.523-2.77 15.322h0.552z",
				"M1000.991 700.423c-6.276-9.046-14.401-16.431-23.999-21.414l-0.368-0.184c-8.862-4.431-19.2-7.017-30.091-7.017-0.184 0-0.184 0-0.368 0v0c-0.368 0-0.739 0-1.109 0-22.154 0-41.723 11.264-53.354 28.43l-0.184 0.184c-7.201 10.523-12.924 22.707-16.062 35.999l-0.184 0.739c-3.691 14.954-5.724 32.126-5.724 49.66 0 0.925 0 2.029 0 2.954v-0.184c0 0.739 0 1.477 0 2.402 0 17.723 2.029 35.080 6.092 51.693l-0.368-1.477c3.322 13.845 8.862 26.032 16.431 36.924l-0.184-0.368c6.276 9.046 14.401 16.431 23.815 21.601l0.368 0.184c8.678 4.431 19.016 7.017 29.907 7.017 0.184 0 0.368 0 0.552 0v0c0.184 0 0.184 0 0.368 0 10.891 0 21.414-2.586 30.462-7.201l-0.368 0.184c9.97-5.169 18.276-12.553 24.183-21.601l0.184-0.184c7.385-10.339 12.924-22.522 16.062-35.815l0.184-0.739c3.879-14.954 6.092-31.939 6.092-49.66 0-0.925 0-2.029 0-2.954v0.184c0-0.925 0-2.216 0-3.322 0-17.539-2.216-34.522-6.46-50.585l0.368 1.477c-3.322-14.030-9.046-26.217-16.431-37.108l0.184 0.184zM982.71 831.688c-1.661 9.786-4.799 18.648-9.23 26.769l0.184-0.368c-2.954 5.724-7.385 10.339-12.741 13.661h-0.184c-4.247 2.402-9.414 3.879-14.954 3.879s-10.707-1.477-15.138-4.063h0.184c-5.357-3.322-9.598-7.937-12.553-13.477v-0.184c-4.063-7.569-7.201-16.431-8.862-25.66v-0.552c-2.029-11.447-3.138-24.368-3.138-37.846 0-1.293 0-2.586 0-3.879v0.184c0-1.109 0-2.402 0-3.691 0-13.293 1.109-26.217 3.322-38.953l-0.184 1.293c1.845-9.786 4.983-18.648 9.23-26.769l-0.184 0.552c2.954-5.724 7.201-10.339 12.368-13.661h0.184c4.247-2.402 9.414-3.879 14.954-3.879s10.707 1.477 15.138 4.063h-0.184c5.54 3.322 9.97 7.937 12.741 13.477v0.184c4.063 7.569 7.201 16.431 8.862 25.66v0.552c2.216 11.076 3.506 23.999 3.506 36.924 0 1.477 0 2.954 0 4.431v-0.184c0 1.109 0 2.216 0 3.506 0 13.108-1.293 26.032-3.691 38.401l0.184-1.293 0.184 0.925z",
				"M1132.25 344.117v41.171c180.925 40.987 300.553 110.771 300.553 190.707 0 84.37-133.846 157.477-332.679 197.172v39.878c257.909-42.276 435.876-132.553 435.876-236.308 0-100.985-164.122-187.938-403.757-232.617v0z",
				"M1057.299 717.039c-21.045 0-38.401-18.648-38.401-41.539s17.171-41.539 38.401-41.539 38.401 18.648 38.401 41.539c0 22.891-17.171 41.539-38.401 41.539zM1057.299 649.838c-12.368 0-22.522 11.632-22.522 25.66 0 14.218 10.155 25.66 22.522 25.66s22.522-11.632 22.522-25.66c0.184-14.218-9.97-25.66-22.522-25.66z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"360-interior-rear"
			],
			defaultCode: 59654,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3557,
			id: 8,
			name: "360-interior-rear",
			prevSize: 32,
			code: 59654,
			codes: [
				59654,
				59656,
				59662,
				59663,
				59664,
				59665,
				59666,
				59667,
				59668,
				59669,
				59670,
				59671,
				59672
			],
			ligatures: "360-interior-rear"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 8
	},
	{
		icon: {
			paths: [
				"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
				"M704 512h-128v-128h-128v128h-128v128h128v128h128v-128h128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"alarm-add",
				"alarm",
				"alarm-plus",
				"clock"
			],
			defaultCode: 59988,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3556,
			id: 9,
			prevSize: 32,
			code: 59988,
			ligatures: "alarm-add",
			name: "alarm-add"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 9
	},
	{
		icon: {
			paths: [
				"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
				"M512 576v-256h-64v320h256v-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"alarm",
				"time",
				"clock"
			],
			defaultCode: 59987,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 10,
			order: 3555,
			prevSize: 32,
			code: 59987,
			ligatures: "alarm-clock",
			name: "alarm-clock"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 10
	},
	{
		icon: {
			paths: [
				"M512 128c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM512 936c-198.824 0-360-161.178-360-360 0-198.824 161.176-360 360-360 198.822 0 360 161.176 360 360 0 198.822-161.178 360-360 360zM934.784 287.174c16.042-28.052 25.216-60.542 25.216-95.174 0-106.040-85.96-192-192-192-61.818 0-116.802 29.222-151.92 74.596 131.884 27.236 245.206 105.198 318.704 212.578v0zM407.92 74.596c-35.116-45.374-90.102-74.596-151.92-74.596-106.040 0-192 85.96-192 192 0 34.632 9.174 67.122 25.216 95.174 73.5-107.38 186.822-185.342 318.704-212.578z",
				"M704 416l-256 256-96-96-64 64 160 160 320-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"alarm-check",
				"alarm",
				"alarm-tick",
				"clock"
			],
			defaultCode: 59989,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3554,
			id: 11,
			prevSize: 32,
			code: 59989,
			ligatures: "alarm-set",
			name: "alarm-set"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 11
	},
	{
		icon: {
			paths: [
				"M877.254 621.254l-320 320c-24.992 24.994-65.514 24.994-90.508 0l-320-320c-24.994-24.994-24.994-65.516 0-90.51 24.994-24.996 65.516-24.996 90.51 0l210.744 210.746v-613.49c0-35.346 28.654-64 64-64s64 28.654 64 64v613.49l210.746-210.746c12.496-12.496 28.876-18.744 45.254-18.744s32.758 6.248 45.254 18.746c24.994 24.994 24.994 65.514 0 90.508z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"arrow-down"
			],
			defaultCode: 61027,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3553,
			id: 12,
			prevSize: 32,
			ligatures: "arrow-down8, down8",
			name: "arrow-down",
			code: 61027
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 12
	},
	{
		icon: {
			paths: [
				"M402.746 877.254l-320-320c-24.994-24.992-24.994-65.516 0-90.51l320-320c24.994-24.992 65.516-24.992 90.51 0 24.994 24.994 24.994 65.516 0 90.51l-210.746 210.746h613.49c35.346 0 64 28.654 64 64s-28.654 64-64 64h-613.49l210.746 210.746c12.496 12.496 18.744 28.876 18.744 45.254s-6.248 32.758-18.744 45.254c-24.994 24.994-65.516 24.994-90.51 0z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"arrow-left"
			],
			defaultCode: 61029,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3552,
			id: 13,
			prevSize: 32,
			ligatures: "arrow-left8, left11",
			name: "arrow-left",
			code: 61029
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 13
	},
	{
		icon: {
			paths: [
				"M621.254 877.254l320-320c24.994-24.992 24.994-65.516 0-90.51l-320-320c-24.994-24.992-65.516-24.992-90.51 0-24.994 24.994-24.994 65.516 0 90.51l210.746 210.746h-613.49c-35.346 0-64 28.654-64 64s28.654 64 64 64h613.49l-210.746 210.746c-12.496 12.496-18.744 28.876-18.744 45.254s6.248 32.758 18.744 45.254c24.994 24.994 65.516 24.994 90.51 0z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"arrow-right"
			],
			defaultCode: 61025,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3551,
			id: 14,
			prevSize: 32,
			ligatures: "arrow-right8, right10",
			name: "arrow-right",
			code: 61025
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 14
	},
	{
		icon: {
			paths: [
				"M877.254 402.746l-320-320c-24.992-24.994-65.514-24.994-90.508 0l-320 320c-24.994 24.994-24.994 65.516 0 90.51 24.994 24.996 65.516 24.996 90.51 0l210.744-210.746v613.49c0 35.346 28.654 64 64 64s64-28.654 64-64v-613.49l210.746 210.746c12.496 12.496 28.876 18.744 45.254 18.744s32.758-6.248 45.254-18.746c24.994-24.994 24.994-65.514 0-90.508z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"arrow-up"
			],
			defaultCode: 61023,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3550,
			id: 15,
			prevSize: 32,
			ligatures: "arrow-up8, up8",
			name: "arrow-up",
			code: 61023
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 15
	},
	{
		icon: {
			paths: [
				"M704 608v-224h-704v-128h704v-224l288 288-288 288zM320 640h704v128h-704v224l-288-288 288-288v224z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"transmission",
				"arrows"
			],
			defaultCode: 60999,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 16,
			order: 3549,
			prevSize: 32,
			code: 60999,
			ligatures: "arrows-left-right",
			name: "arrows-left-right"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 16
	},
	{
		icon: {
			paths: [
				"M697.831 327.048l-64.952-64.922-324.81 324.742c-53.814 53.792-53.814 141.048 0 194.844 53.804 53.792 141.060 53.792 194.874 0l389.772-389.708c89.714-89.662 89.714-235.062 0-324.726-89.666-89.704-235.112-89.704-324.782 0l-409.23 409.178c-0.29 0.304-0.612 0.576-0.876 0.846-125.102 125.096-125.102 327.856 0 452.906 125.054 125.056 327.868 125.056 452.988 0 0.274-0.274 0.516-0.568 0.82-0.876l0.032 0.034 279.332-279.292-64.986-64.92-279.33 279.262c-0.296 0.268-0.564 0.57-0.846 0.844-89.074 89.058-233.98 89.058-323.076 0-89.062-89.042-89.062-233.922 0-322.978 0.304-0.304 0.604-0.582 0.888-0.846l-0.046-0.060 409.28-409.166c53.712-53.738 141.144-53.738 194.886 0 53.712 53.734 53.712 141.148 0 194.84l-389.772 389.7c-17.936 17.922-47.054 17.922-64.972 0-17.894-17.886-17.894-47.032 0-64.92l324.806-324.782z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"attachment",
				"paperclip"
			],
			defaultCode: 60585,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 17,
			order: 3548,
			prevSize: 32,
			code: 60585,
			ligatures: "attach",
			name: "attach"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 17
	},
	{
		icon: {
			paths: [
				"M928 192l-192-192-512 512 512 512 192-192-320-320zM96 0v1024h128v-1024z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"first",
				"player"
			],
			defaultCode: 60850,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 18,
			order: 3547,
			prevSize: 32,
			code: 60850,
			ligatures: "back-to-start",
			name: "back-to-start"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 18
	},
	{
		icon: {
			paths: [
				"M0 192h128v640h-128zM192 192h64v640h-64zM320 192h64v640h-64zM512 192h64v640h-64zM768 192h64v640h-64zM960 192h64v640h-64zM640 192h32v640h-32zM448 192h32v640h-32zM864 192h32v640h-32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"barcode"
			],
			defaultCode: 59894,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 19,
			order: 3546,
			ligatures: "barcode",
			prevSize: 32,
			code: 59894,
			name: "barcode"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 19
	},
	{
		icon: {
			paths: [
				"M899.714 860.807c-87.115-192.069-65.666-419.193-65.666-422.178 0-155.974-98.915-287.445-233.996-328.191 1.437-6.042 2.271-12.984 2.291-20.117v-0.013c0-49.837-40.401-90.239-90.239-90.239s-90.239 40.401-90.239 90.239v0c0.032 7.003 0.84 13.801 2.341 20.334l-0.12-0.62c-135.983 40.469-235.592 172.286-235.592 328.746 0.012 14.493 0.869 28.772 2.525 42.807l-0.165-1.714c2.846 68.928 0.208 233.787-66.568 380.946h224.555c0 90.091 73.033 163.124 163.124 163.124s163.124-73.033 163.124-163.124v0h224.625zM584.851 860.807c0 40.253-32.632 72.885-72.885 72.885s-72.885-32.632-72.885-72.885v0h145.77z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bell"
			],
			defaultCode: 59992,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 20,
			order: 3545,
			ligatures: "bell",
			prevSize: 32,
			code: 59992,
			name: "bell"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 20
	},
	{
		icon: {
			paths: [
				"M834.048 438.698c0-155.974-98.915-287.445-233.996-328.191 1.437-6.042 2.271-12.984 2.291-20.117v-0.013c0-49.837-40.401-90.239-90.239-90.239s-90.239 40.401-90.239 90.239v0c0.032 7.003 0.84 13.801 2.341 20.334l-0.12-0.62c-135.983 40.33-235.592 172.148-235.592 328.607 0.012 14.493 0.869 28.772 2.525 42.807l-0.165-1.714c2.846 68.928 0.208 233.787-66.568 380.946h224.555c0 90.091 73.033 163.124 163.124 163.124s163.124-73.033 163.124-163.124v0h224.625c-87.115-191.931-65.666-419.054-65.666-422.039zM511.272 194.36c123.419 0 223.861 108.009 225.597 241.215-1.447 21.267-2.271 46.096-2.271 71.117 0 91.183 10.95 179.808 31.607 264.632l-1.57-7.628h-504.85c18.4-74.14 28.956-159.254 28.956-246.834 0-14.282-0.281-28.499-0.837-42.645l0.064 2.034c0-2.499 0-4.928-0.555-7.427-1.103-9.040-1.733-19.508-1.735-30.123v-0.002c0-134.664 101.206-244.338 225.597-244.338zM511.966 933.623c-40.237-0.040-72.846-32.648-72.885-72.881v-0.004h145.77c0 0.021 0 0.045 0 0.069 0 40.267-32.623 72.915-72.881 72.954h-0.004z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bell-o"
			],
			defaultCode: 59687,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 21,
			order: 3544,
			ligatures: "bell-o",
			prevSize: 32,
			code: 59687,
			name: "bell-o"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 21
	},
	{
		icon: {
			paths: [
				"M874.040 149.96c-96.706-96.702-225.28-149.96-362.040-149.96s-265.334 53.258-362.040 149.96c-96.702 96.706-149.96 225.28-149.96 362.040s53.258 265.334 149.96 362.040c96.706 96.702 225.28 149.96 362.040 149.96s265.334-53.258 362.040-149.96c96.702-96.706 149.96-225.28 149.96-362.040s-53.258-265.334-149.96-362.040zM896 512c0 82.814-26.354 159.588-71.112 222.38l-535.266-535.268c62.792-44.758 139.564-71.112 222.378-71.112 211.738 0 384 172.262 384 384zM128 512c0-82.814 26.354-159.586 71.112-222.378l535.27 535.268c-62.794 44.756-139.568 71.11-222.382 71.11-211.738 0-384-172.262-384-384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"blocked"
			],
			defaultCode: 60775,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 22,
			order: 3543,
			ligatures: "blocked",
			prevSize: 32,
			code: 60775,
			name: "blocked"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 22
	},
	{
		icon: {
			paths: [
				"M330.567 991.999l-10.822-5.092c52.202-131.14 103.766-262.282 158.514-401.061h-275.013l487.64-553.846 10.822 8.276-157.878 397.878h276.923l-490.186 553.846z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bolt"
			],
			defaultCode: 59649,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3542,
			id: 23,
			name: "bolt",
			prevSize: 32,
			code: 59649,
			ligatures: "bolt"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 23
	},
	{
		icon: {
			paths: [
				"M512 64c282.77 0 512 186.25 512 416 0 229.752-229.23 416-512 416-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bubble",
				"comment",
				"chat",
				"talk"
			],
			defaultCode: 60097,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 24,
			order: 3541,
			prevSize: 32,
			code: 60097,
			ligatures: "bubble",
			name: "bubble"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 24
	},
	{
		icon: {
			paths: [
				"M426.667 56.889v0c235.641 0 426.667 154.59 426.667 345.287s-191.026 345.287-426.667 345.287c-22.629 0-44.841-1.44-66.519-4.187-91.65 91.284-197.486 107.652-303.259 110.057v-22.341c57.113-27.87 103.111-78.636 103.111-136.652 0-8.094-0.633-16.043-1.804-23.817-96.496-63.301-158.196-159.989-158.196-268.347 0-190.697 191.026-345.287 426.667-345.287zM885.333 830.832c0 49.726 32.279 93.243 81.778 117.131v19.148c-91.668-2.060-175.81-16.091-255.237-94.334-18.791 2.356-38.039 3.591-57.652 3.591-84.862 0-163.029-22.896-225.435-61.369 128.599-0.45 250.009-41.648 342.075-116.153 46.407-37.557 83.017-81.623 108.812-130.976 27.348-52.325 41.214-108.073 41.214-165.694 0-9.287-0.4-18.521-1.118-27.705 64.507 53.275 104.229 125.886 104.229 205.934 0 92.878-53.474 175.753-137.102 230.012-1.015 6.663-1.564 13.476-1.564 20.414z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bubbles"
			],
			defaultCode: 60099,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 25,
			order: 3540,
			ligatures: "bubbles",
			prevSize: 32,
			code: 60099,
			name: "bubbles"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 25
	},
	{
		icon: {
			paths: [
				"M320 512c0-106.039 85.961-192 192-192s192 85.961 192 192c0 106.039-85.961 192-192 192s-192-85.961-192-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"circle-small"
			],
			defaultCode: 60520,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 26,
			order: 3539,
			prevSize: 32,
			code: 60520,
			ligatures: "bullet",
			name: "bullet"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 26
	},
	{
		icon: {
			paths: [
				"M0 960c0 35.348 28.654 64 64 64h896c35.348 0 64-28.652 64-64v-576h-1024v576zM704 448h256v128h-256v-128zM704 640h256v128h-256v-128zM704 832h256v128h-256v-128zM384 448h256v128h-256v-128zM384 640h256v128h-256v-128zM384 832h256v128h-256v-128zM64 448h256v128h-256v-128zM64 640h256v128h-256v-128zM64 832h256v128h-256v-128zM960 128h-128v-91.428c0-20.198-14.326-36.572-32-36.572-17.672 0-32 16.374-32 36.572v91.428h-512v-91.428c0-20.198-14.326-36.572-32-36.572s-32 16.374-32 36.572v91.428h-128c-35.346 0-64 28.654-64 64v128h1024v-128c0-35.346-28.654-64-64-64zM224 288c-35.346 0-64-28.654-64-64 0-23.684 12.876-44.348 32-55.416v55.416c0 17.672 14.328 32 32 32s32-14.328 32-32v-55.416c19.124 11.068 32 31.732 32 55.416 0 35.346-28.654 64-64 64zM800 288c-35.344 0-64-28.654-64-64 0-23.684 12.876-44.348 32-55.416v55.416c0 17.672 14.328 32 32 32 17.674 0 32-14.328 32-32v-55.416c19.126 11.068 32 31.732 32 55.416 0 35.346-28.652 64-64 64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"calendar"
			],
			defaultCode: 59999,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 27,
			order: 3538,
			ligatures: "calendar",
			prevSize: 32,
			code: 59999,
			name: "calendar"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 27
	},
	{
		icon: {
			paths: [
				"M991.595 252.76c-6.481 0-12.962 0-12.962 0-6.481 0-12.962 6.481-12.962 6.481l-181.468 129.62v-103.696c0-25.924-6.481-51.848-25.924-71.291s-51.848-25.924-77.772-25.924h-583.291c-25.924 0-51.848 6.481-71.291 25.924s-25.924 45.367-25.924 71.291v453.671c0 25.924 6.481 51.848 25.924 71.291s45.367 25.924 71.291 25.924h583.291c25.924 0 51.848-6.481 71.291-25.924s25.924-38.886 25.924-71.291v-110.177l181.468 129.62c6.481 6.481 12.962 6.481 12.962 6.481 6.481 0 12.962 0 12.962 0 6.481 0 12.962 0 19.443-6.481s12.962-6.481 12.962-12.962 6.481-12.962 6.481-12.962 0-12.962 0-19.443v-408.304c0-19.443-6.481-32.405-12.962-38.886 0-6.481-6.481-12.962-19.443-12.962z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"camcorder",
				"video"
			],
			defaultCode: 59650,
			grid: 32
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 3537,
			id: 28,
			name: "camcorder",
			prevSize: 32,
			code: 59650
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 28
	},
	{
		icon: {
			paths: [
				"M304 576c0 114.876 93.124 208 208 208s208-93.124 208-208-93.124-208-208-208-208 93.124-208 208zM960 224h-224c-16-64-32-128-96-128h-256c-64 0-80 64-96 128h-224c-35.2 0-64 28.8-64 64v576c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64zM512 860c-156.85 0-284-127.148-284-284 0-156.85 127.15-284 284-284 156.852 0 284 127.15 284 284 0 156.852-127.146 284-284 284zM960 416h-128v-64h128v64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"camera",
				"photo",
				"picture",
				"image"
			],
			defaultCode: 59716,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 29,
			order: 3536,
			prevSize: 32,
			code: 59716,
			ligatures: "camera",
			name: "camera"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 29
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM768 672l-96 96-160-160-160 160-96-96 160-160-160-160 96-96 160 160 160-160 96 96-160 160 160 160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cancel-circle"
			],
			defaultCode: 60771,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 30,
			order: 3535,
			ligatures: "cancel-circle",
			prevSize: 32,
			code: 60771,
			name: "cancel-circle"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 30
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416zM672 256l-160 160-160-160-96 96 160 160-160 160 96 96 160-160 160 160 96-96-160-160 160-160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cancel-circle-o"
			],
			defaultCode: 60770,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 31,
			order: 3534,
			ligatures: "cancel-circle-o",
			prevSize: 32,
			code: 60770,
			name: "cancel-circle-o"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 31
	},
	{
		icon: {
			paths: [
				"M975.505 291.892h-63.205c-0.267-0.011-0.579-0.018-0.894-0.018-7.156 0-13.531 3.349-17.643 8.564l-0.036 0.048c-7.207 9.979-11.92 32.157-18.296 32.157h-21.622c-6.209-16.286-12.084-29.349-18.579-42.040l1.115 2.399c-9.794-20.356-19.025-36.973-29.063-53.033l1.342 2.302s-15.247-20.791-23.841-29.938c-11.664-13.517-27.827-22.869-46.141-25.725l-0.431-0.055c-24.949-4.158-57.66-7.207-57.66-7.207l-71.521-3.604h-186.286l-71.243 3.049s-32.711 3.049-57.66 7.207c-18.248 3.31-33.882 12.696-45.092 25.945l-0.093 0.113c-8.593 9.148-23.841 29.938-23.841 29.938-8.696 13.755-17.927 30.373-26.292 47.49l-1.429 3.24c-5.38 10.292-11.255 23.354-16.471 36.747l-0.993 2.895h-27.721c-6.376 0-11.088-22.177-18.296-32.157-4.148-5.264-10.522-8.612-17.679-8.612-0.314 0-0.627 0.006-0.938 0.019l0.044-0.002h-66.531c-0.173-0.005-0.376-0.007-0.579-0.007-13.626 0-24.672 11.046-24.672 24.672 0 0.392 0.010 0.782 0.027 1.17l-0.002-0.054v23.563c0 14.97 25.78 36.87 49.621 37.423h83.164l-33.265 31.048c-27.721 26.058-47.404 34.929-47.404 83.164 0 87.322 6.376 153.575 6.376 153.575l5.267 55.442c0.809 7.868 1.981 14.854 3.555 21.687l-0.228-1.174v98.411c0 0.014 0 0.032 0 0.051 0 14.725 11.481 26.768 25.979 27.669l0.079 0.005h117.538c14.452-1.044 25.78-13.026 25.78-27.653 0-0.024 0-0.048 0-0.072v0.004-50.176h506.19v49.621c0 0.020 0 0.044 0 0.068 0 14.627 11.328 26.608 25.691 27.648l0.090 0.005h117.815c14.452-1.044 25.78-13.026 25.78-27.653 0-0.024 0-0.048 0-0.072v0.004-79.283c4.182-11.473 7.396-24.881 9.062-38.766l0.086-0.875 5.267-55.442s6.376-66.253 6.376-153.575c0-47.126-19.405-55.442-47.404-83.164l-32.988-30.216h75.401c23.841 0 49.621-22.455 49.621-37.423v-23.841c0.009-0.249 0.014-0.543 0.014-0.838 0-13.626-11.046-24.672-24.672-24.672-0.2 0-0.399 0.003-0.599 0.007l0.030-0.001zM220.933 332.089c8.518-20.755 17.81-38.441 28.529-55.121l-0.808 1.342c7.629-11.373 16.031-21.272 25.419-30.137l0.084-0.079c16.649-9.338 36.326-15.347 57.281-16.614l0.379-0.018c51.284-5.544 134.448-5.544 134.448-5.544h92.035s83.164 0 134.725 5.544c21.43 1.19 41.217 7.211 58.615 16.983l-0.678-0.35c9.568 8.883 17.979 18.793 25.128 29.611l0.375 0.604c9.912 15.338 19.204 33.024 26.897 51.541l0.824 2.238c12.474 30.493-9.148 38.533-20.236 39.087s-174.921 1.663-174.921 1.663l-96.747-1.386-97.301 1.386s-163.278 0-174.367 0-31.602-10.257-19.682-40.75zM234.794 688.86h-75.401c-18.296 0-24.949-25.78-24.949-36.315s7.207-12.198 18.019-12.474h64.313c8.965 0.049 17.444 2.088 25.030 5.698l-0.358-0.154c5.657 3.374 10.371 7.734 14.044 12.889l0.095 0.14c3.446 5.051 5.966 11.019 7.163 17.454l0.044 0.287c0 6.93-3.049 12.474-27.999 12.474zM299.661 550.254c-20.69 4.237-44.47 6.663-68.817 6.663-5.045 0-10.067-0.104-15.062-0.31l0.715 0.024c-3.966 0.583-8.544 0.915-13.201 0.915-18.386 0-35.561-5.188-50.139-14.181l0.412 0.237c-16.408-11.233-27.176-29.668-27.719-50.647l-0.002-0.082c-1.941-26.058 0-39.642 30.771-39.919 0.968-0.017 2.11-0.027 3.254-0.027 35.911 0 69.585 9.576 98.607 26.316l-0.956-0.509c22.083 9.838 40.631 24.032 55.244 41.613l0.199 0.246c1.797 2.987 2.859 6.592 2.859 10.446 0 9.789-6.856 17.977-16.028 20.021l-0.137 0.026zM614.852 673.614h-202.365c-27.721 0-76.234-4.99-76.234-45.74 0.074-14.865 3.65-28.876 9.944-41.276l-0.242 0.526c8.599-27.463 32.526-47.57 61.521-50.43l0.297-0.024c29.919-4.959 64.397-7.793 99.538-7.793 2.235 0 4.468 0.011 6.698 0.034l-0.341-0.003c1.835-0.019 4.004-0.030 6.175-0.030 35.203 0 69.745 2.833 103.41 8.284l-3.689-0.493c29.202 3.105 53.027 23.114 61.675 49.939l0.143 0.514c6.416 12.066 10.364 26.314 10.808 41.441l0.004 0.14c0 40.75-50.452 45.74-77.342 45.74zM866.284 688.029h-75.401c-24.949 0-27.721-5.544-27.721-12.474 1.241-6.722 3.761-12.691 7.311-17.903l-0.104 0.161c3.851-5.217 8.546-9.558 13.926-12.906l0.211-0.123c7.228-3.457 15.707-5.496 24.656-5.544h64.33c10.812 0 18.019 2.217 18.019 12.474s-5.267 37.146-25.227 37.146zM900.104 493.98c-0.546 21.061-11.313 39.497-27.505 50.591l-0.216 0.139c-14.123 8.769-31.259 13.966-49.608 13.966-4.698 0-9.318-0.341-13.834-0.998l0.514 0.061c-4.357 0.192-9.467 0.3-14.603 0.3-24.258 0-47.948-2.43-70.84-7.061l2.28 0.385c-8.789-2.334-15.159-10.217-15.159-19.589 0-3.707 0.998-7.18 2.737-10.168l-0.052 0.096c14.805-17.834 33.355-32.031 54.491-41.478l0.951-0.38c28.113-16.23 61.836-25.805 97.794-25.805 1.094 0 2.186 0.009 3.276 0.027l-0.164-0.002c31.324 0 32.157 13.584 29.938 39.642z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"car"
			],
			defaultCode: 60423,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 32,
			order: 3533,
			ligatures: "car",
			prevSize: 32,
			code: 60423,
			name: "car"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 32
	},
	{
		icon: {
			paths: [
				"M1021.221 570.197s2.943 65.39-38.416 90.238h-52.475c7.014-14.312 11.116-31.147 11.116-48.94 0-62.567-50.721-113.287-113.287-113.287s-113.287 50.721-113.287 113.287c0 17.793 4.102 34.628 11.411 49.61l-0.295-0.67h-420.782c7.014-14.312 11.116-31.147 11.116-48.94 0-62.567-50.721-113.287-113.287-113.287s-113.287 50.721-113.287 113.287c0 17.793 4.102 34.628 11.411 49.61l-0.295-0.67s-60.812 2.779-80.756-17.655-16.347-152.685-16.347-152.685c8.388-3.396 14.913-9.921 18.23-18.090l0.079-0.219c4.741-13.405 13.405-59.504 13.405-59.504s203.688-77.977 310.6-90.401 130.943-6.049 165.926-1.308c97.267 8.664 248.317 105.604 248.317 105.604s171.811 22.069 238.181 76.833c10.873 19.411 18.835 42.032 22.577 66.049l0.146 1.139zM521.808 336.756c-24.41-4.29-52.516-6.743-81.194-6.743-30.699 0-60.742 2.811-89.884 8.188l3.028-0.464s-101.844 18.309-134.539 34.493c-12.587 8.501 0 21.088 0 21.088 27.464 27.464 347.872 49.042 495.489 36.618-2.452-10.789-112.143-76.833-192.899-93.18zM296.215 611.556c-0.001 52.003-42.158 94.159-94.161 94.159s-94.161-42.157-94.161-94.161c0-51.774 41.785-93.788 93.471-94.159h0.036c0.194-0.001 0.424-0.002 0.654-0.002 52.004 0 94.161 42.157 94.161 94.161 0 0.001 0 0.002 0 0.002v0zM201.4 550.089c-33.946 0-61.466 27.52-61.466 61.466s27.52 61.466 61.466 61.466c33.946 0 61.466-27.52 61.466-61.466v0c0-33.946-27.52-61.466-61.466-61.466v0zM922.156 611.556c0 52.004-42.157 94.161-94.161 94.161s-94.161-42.157-94.161-94.161c0-52.004 42.157-94.161 94.161-94.161v0c52.004 0 94.161 42.157 94.161 94.161v0zM827.995 550.089c-33.946 0-61.466 27.52-61.466 61.466s27.52 61.466 61.466 61.466c33.946 0 61.466-27.52 61.466-61.466v0c0-33.946-27.52-61.466-61.466-61.466v0z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"car-side"
			],
			defaultCode: 59659,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 33,
			order: 3532,
			ligatures: "car-side",
			prevSize: 32,
			code: 59659,
			name: "car-side"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 33
	},
	{
		icon: {
			paths: [
				"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM448 794.51l-237.254-237.256 90.51-90.508 146.744 146.744 306.746-306.746 90.508 90.51-397.254 397.256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkbox-checked"
			],
			defaultCode: 61035,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 34,
			order: 3531,
			ligatures: "checkbox-checked",
			prevSize: 32,
			code: 61035,
			name: "checkbox-checked"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 34
	},
	{
		icon: {
			paths: [
				"M896 0h-768c-70.4 0-128 57.6-128 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128v-768c0-70.4-57.6-128-128-128zM896 896h-768v-768h768v768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkbox-unchecked",
				"square"
			],
			defaultCode: 61036,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 35,
			order: 3530,
			ligatures: "checkbox-unchecked",
			prevSize: 32,
			code: 61036,
			name: "checkbox-unchecked"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 35
	},
	{
		icon: {
			paths: [
				"M896 160l-544 544-224-224-96 96 320 320 640-640z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkmark"
			],
			defaultCode: 60782,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 36,
			order: 3529,
			ligatures: "checkmark",
			prevSize: 32,
			code: 60782,
			name: "checkmark"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 36
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM416 770l-180-214 66-66 114 112 330-288 46 46-376 410z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"checkmark-circle",
				"radio-checked-2"
			],
			defaultCode: 61043,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 37,
			order: 3528,
			ligatures: "checkmark-circle",
			prevSize: 32,
			code: 61043,
			name: "checkmark-circle"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 37
	},
	{
		icon: {
			paths: [
				"M1024 352l-128-128-384 384-384-384-128 128 511.998 512 512.002-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-down"
			],
			defaultCode: 60861,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 38,
			order: 3527,
			ligatures: "chevron-down",
			prevSize: 32,
			code: 60861,
			name: "chevron-down"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 38
	},
	{
		icon: {
			paths: [
				"M1024 268.935h-320.168l-191.832 182.761-192.168-182.761h-319.832l512 486.131 512-486.131z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-down-chamfered"
			],
			defaultCode: 59685,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 39,
			order: 3526,
			ligatures: "chevron-down-chamfered",
			prevSize: 32,
			code: 59685,
			name: "chevron-down-chamfered"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 39
	},
	{
		icon: {
			paths: [
				"M1024 352l-96-96-416 416-416-416-96 96 511.998 512 512.002-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-down-light"
			],
			defaultCode: 60866,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 40,
			order: 3525,
			ligatures: "arrow-down",
			prevSize: 32,
			code: 60866,
			name: "chevron-down-light"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 40
	},
	{
		icon: {
			paths: [
				"M704 1024l128-128-384-384 384-384-128-128-512 511.998 512 512.002z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-left"
			],
			defaultCode: 60865,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 41,
			order: 3524,
			ligatures: "chevron-left",
			prevSize: 32,
			code: 60865,
			name: "chevron-left"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 41
	},
	{
		icon: {
			paths: [
				"M720 1024l96-96-416-416 416-416-96-96-512 511.998 512 512.002z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-left-light"
			],
			defaultCode: 60872,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 42,
			order: 3523,
			ligatures: "arrow-left",
			prevSize: 32,
			code: 60872,
			name: "chevron-left-light"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 42
	},
	{
		icon: {
			paths: [
				"M320 0l-128 128 384 384-384 384 128 128 512-511.998-512-512.002z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-right"
			],
			defaultCode: 60857,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 43,
			order: 3522,
			ligatures: "chevron-right",
			prevSize: 32,
			code: 60857,
			name: "chevron-right"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 43
	},
	{
		icon: {
			paths: [
				"M304 0l-96 96 416 416-416 416 96 96 512-511.998-512-512.002z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-right-light"
			],
			defaultCode: 60862,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 44,
			order: 3521,
			ligatures: "arrow-right",
			prevSize: 32,
			code: 60862,
			name: "chevron-right-light"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 44
	},
	{
		icon: {
			paths: [
				"M0 704l128 128 384-384 384 384 128-128-511.998-512-512.002 512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-up"
			],
			defaultCode: 60853,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 45,
			order: 3520,
			ligatures: "chevron-up",
			prevSize: 32,
			name: "chevron-up",
			code: 60853
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 45
	},
	{
		icon: {
			paths: [
				"M0 720l96 96 416-416 416 416 96-96-511.998-512-512.002 512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"chevron-up-light"
			],
			defaultCode: 60858,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 46,
			order: 3519,
			ligatures: "arrow-up",
			prevSize: 32,
			code: 60858,
			name: "chevron-up-light"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 46
	},
	{
		icon: {
			paths: [
				"M256 256h512v-128h-128c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-128v128zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64z",
				"M928 128h-96v160c0 17.672-14.326 32-32 32h-576c-17.672 0-32-14.328-32-32v-160h-96c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"clipboard",
				"board"
			],
			defaultCode: 60496,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 47,
			order: 3518,
			prevSize: 32,
			code: 60496,
			ligatures: "clipboard",
			name: "clipboard"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 47
	},
	{
		icon: {
			paths: [
				"M256 256h512v-128h-128c0-70.692-57.306-128-128-128-70.692 0-128 57.308-128 128h-128v128zM512 64c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64s28.654-64 64-64z",
				"M928 128h-96v160c0 17.672-14.326 32-32 32h-576c-17.672 0-32-14.328-32-32v-160h-96c-17.672 0-32 14.328-32 32v832c0 17.674 14.328 32 32 32h832c17.674 0 32-14.326 32-32v-832c0-17.672-14.326-32-32-32zM448 922.51l-205.254-237.254 58.508-58.51 146.746 114.744 274.742-242.744 58.514 58.508-333.256 365.256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"clipboard",
				"board",
				"signup",
				"register",
				"agreement"
			],
			defaultCode: 60497,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 48,
			order: 3517,
			prevSize: 32,
			code: 60497,
			ligatures: "clipboard-checked",
			name: "clipboard-checked"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 48
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM658.744 749.256l-210.744-210.746v-282.51h128v229.49l173.256 173.254-90.512 90.512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"clock",
				"time",
				"schedule"
			],
			defaultCode: 59982,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 49,
			order: 3516,
			prevSize: 32,
			code: 59982,
			ligatures: "clock",
			name: "clock"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 49
	},
	{
		icon: {
			paths: [
				"M970.589 748.525v275.475h-970.589v-275.475h121.362v137.737h728.018v-137.737h121.209z",
				"M485.294 0l275.475 413.212h-206.606v344.343h-137.737v-344.343h-206.606l275.475-413.212z"
			],
			attrs: [
				{
				},
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cloud-upload"
			],
			defaultCode: 60533,
			grid: 32
		},
		attrs: [
			{
			},
			{
			}
		],
		properties: {
			id: 50,
			order: 3515,
			ligatures: "cloud-upload",
			prevSize: 32,
			code: 60533,
			name: "cloud-upload"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 50
	},
	{
		icon: {
			paths: [
				"M471.52 680.33c6.748 0 6.748 0 13.496 6.748l33.739 33.739c-22.847 29.247-52.352 52.256-86.3 66.932l-1.421 0.548c-29.996 13.272-64.979 20.999-101.766 20.999-6.931 0-13.798-0.274-20.592-0.813l0.897 0.057c-1.050 0.013-2.293 0.020-3.536 0.020-39.95 0-78.162-7.434-113.332-20.994l2.154 0.731c-34.356-14.607-63.555-35.151-87.607-60.608l-0.115-0.122c-27.114-27.692-47.975-61.617-60.227-99.418l-0.505-1.8c-12.826-33.010-20.257-71.217-20.257-111.161 0-1.013 0.005-2.023 0.014-3.034l-0.001 0.154c0.146-43.517 7.547-85.259 21.054-124.143l-0.811 2.681c14.449-36.982 35.037-68.624 60.803-95.219l-0.072 0.075c26.341-25.628 57.749-46.202 92.561-60.061l1.909-0.671c36.203-12.698 77.944-20.098 121.395-20.244h0.067c1.005-0.013 2.19-0.020 3.377-0.020 37.687 0 73.633 7.444 106.452 20.943l-1.864-0.679c31.556 13.035 58.476 31.297 80.958 53.966l0.016 0.016-26.991 33.739-6.748 6.748h-13.496c-6.748 0-6.748 0-13.496-6.748l-6.748-6.748-20.244-13.496c-6.748-6.748-13.496-6.748-26.991-13.496-9.113-2.534-20.532-4.892-32.174-6.563l-1.565-0.184c-11.048-4.58-23.88-7.24-37.332-7.24-3.487 0-6.933 0.179-10.329 0.528l0.426-0.035c-29.642 0.315-57.474 7.768-81.951 20.714l0.976-0.471c-27.122 9.8-49.905 26.062-67.273 46.982l-0.205 0.253c-18.985 19.128-34.811 41.425-46.606 66.022l-0.629 1.457c-7.404 30.146-12.254 65.124-13.472 101.025l-0.023 0.868c0.759 33.903 5.637 66.338 14.152 97.265l-0.656-2.796c12.488 28.487 28.343 52.99 47.482 74.509l-0.247-0.282c19.128 18.985 41.425 34.811 66.022 46.606l1.457 0.629c19.998 8.848 43.32 13.999 67.844 13.999 4.621 0 9.199-0.182 13.727-0.542l-0.598 0.038h47.235c13.496 0 26.991-6.748 40.487-6.748s20.244-6.748 33.739-13.496c12.102-5.414 21.578-14.89 26.858-26.658l0.134-0.333c-6.748-7.423 0-14.17 6.748-14.17z",
				"M640.217 558.869v242.922h-74.226v-580.316h161.949c34.148 1.296 66.535 6.142 97.634 14.191l-3.164-0.695c25.796 7.662 48.256 19.198 68.011 34.124l-0.532-0.385c14.484 16.011 27.835 33.654 39.57 52.411l0.917 1.571c7.316 19.902 12.151 42.913 13.468 66.864l0.027 0.615c0.266 3.172 0.417 6.866 0.417 10.596 0 15.53-2.624 30.448-7.452 44.335l0.287-0.947c-5.148 18.513-14.507 34.427-27.013 47.258l0.022-0.023c-12.593 14.653-28.431 26.156-46.426 33.449l-0.809 0.289c-16.89 12.202-37.884 19.709-60.602 20.241l-0.128 0.003c12.102 5.414 21.578 14.89 26.858 26.658l0.134 0.333 168.696 229.428h-67.478c-13.051-0.248-24.868-5.331-33.776-13.528l0.036 0.033-155.201-215.931c-6.748-6.748-6.748-13.496-13.496-13.496s-13.496-6.748-26.991-6.748zM640.217 498.138h80.974c2.988 0.171 6.484 0.268 10.002 0.268 18.063 0 35.527-2.562 52.049-7.343l-1.32 0.326c15.553-5.964 28.891-12.772 41.384-20.782l-0.897 0.538c12.334-7.994 21.746-19.583 26.84-33.273l0.152-0.467c4.439-11.74 7.010-25.313 7.010-39.486 0-2.727-0.095-5.431-0.282-8.111l0.020 0.361c-1.332-31.213-13.929-59.248-33.799-80.363l0.060 0.064c-26.563-17.032-58.976-27.15-93.753-27.15-2.626 0-5.237 0.058-7.834 0.172l0.37-0.013h-80.974z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"CR"
			],
			defaultCode: 59657,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3514,
			id: 51,
			name: "condition-report",
			prevSize: 32,
			code: 59657,
			ligatures: "condition-report"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 51
	},
	{
		icon: {
			paths: [
				"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM192 768h-64v-128h64v128zM320 768h-64v-128h64v128zM448 768h-64v-128h64v128zM992 512h-960v-192h960v192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"credit-card"
			],
			defaultCode: 59926,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 52,
			order: 3513,
			ligatures: "credit-card",
			prevSize: 32,
			code: 59926,
			name: "credit-card"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 52
	},
	{
		icon: {
			paths: [
				"M893.254 221.254l-90.508-90.508-290.746 290.744-290.746-290.744-90.508 90.506 290.746 290.748-290.746 290.746 90.508 90.508 290.746-290.746 290.746 290.746 90.508-90.51-290.744-290.744z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cross"
			],
			defaultCode: 60778,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 53,
			order: 3512,
			ligatures: "cross",
			prevSize: 32,
			code: 60778,
			name: "cross"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 53
	},
	{
		icon: {
			paths: [
				"M781.256 690.744l-90.512 90.512-178.744-178.746-178.746 178.744-90.51-90.51 178.746-178.744-178.744-178.746 90.508-90.508 178.746 178.744 178.744-178.746 90.512 90.51-178.746 178.746 178.746 178.744z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cross-small"
			],
			defaultCode: 60779,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 54,
			order: 3511,
			ligatures: "cross-small",
			prevSize: 32,
			code: 60779,
			name: "cross-small"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 54
	},
	{
		icon: {
			paths: [
				"M893.023 416.744h-861.271c-17.535 0-31.752 14.217-31.752 31.752 0 96.829 19.749 191.774 57.112 274.563 36.735 81.402 89.376 149 152.229 195.491 5.465 4.042 12.084 6.226 18.883 6.226h-132.967c-17.535 0-31.752 14.215-31.752 31.752s14.217 31.752 31.752 31.752h635.038c17.537 0 31.752-14.215 31.752-31.752s-14.215-31.752-31.752-31.752h-132.967c6.799 0 13.417-2.183 18.883-6.226 57.856-42.794 107.046-103.483 143.155-176.348h6.65c100.615 0 161.25-35.123 194.399-64.589 39.815-35.392 63.585-83.95 63.585-129.891 0-72.221-58.755-130.977-130.977-130.977zM912.95 624.217c-21.389 19.013-59.638 41.283-123.529 45.732 19.621-57.253 31.488-118.798 35.009-181.764h68.594c32.828 0 59.534 26.707 59.534 59.534 0 19.962-10.405 50.537-39.609 76.496z",
				"M285.768 353.24c-17.535 0-31.752-14.217-31.752-31.752v-127.008c0-17.535 14.217-31.752 31.752-31.752s31.752 14.217 31.752 31.752v127.008c0 17.535-14.215 31.752-31.752 31.752z",
				"M412.776 353.24c-17.535 0-31.752-14.217-31.752-31.752v-254.015c0-17.535 14.217-31.752 31.752-31.752s31.752 14.217 31.752 31.752v254.015c0 17.535-14.215 31.752-31.752 31.752z",
				"M539.784 353.24c-17.537 0-31.752-14.217-31.752-31.752v-127.008c0-17.535 14.215-31.752 31.752-31.752s31.752 14.217 31.752 31.752v127.008c0 17.535-14.215 31.752-31.752 31.752z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cup",
				"drink",
				"coffee",
				"break",
				"beverage",
				"hot",
				"breakfast"
			],
			defaultCode: 60358,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 55,
			order: 3510,
			prevSize: 32,
			code: 60358,
			ligatures: "cup",
			name: "cup"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 55
	},
	{
		icon: {
			width: 1536,
			paths: [
				"M1191.908 243.257h-77.22c-0.326-0.012-0.708-0.022-1.091-0.022-8.744 0-16.532 4.091-21.556 10.462l-0.044 0.058c-8.806 12.192-14.563 39.287-22.353 39.287h-26.418c-7.586-19.897-14.763-35.856-22.699-51.362l1.362 2.931c-11.966-24.87-23.243-45.171-35.508-64.792l1.639 2.812s-18.628-25.401-29.127-36.578c-14.25-16.514-33.997-27.94-56.372-31.429l-0.526-0.067c-32.513-5.419-71.123-9.483-71.123-9.483l-87.041-4.064h-227.256l-87.38 4.064s-39.964 3.726-70.445 8.806c-22.901 3.557-42.649 14.984-56.797 31.377l-0.102 0.12c-10.499 11.177-29.127 36.578-29.127 36.578-10.625 16.806-21.902 37.108-32.122 58.020l-1.746 3.958c-6.572 12.573-13.752 28.533-20.125 44.894l-1.213 3.537h-33.867c-7.79 0-13.548-27.094-22.353-39.287-5.068-6.431-12.857-10.521-21.599-10.521-0.384 0-0.766 0.008-1.146 0.023l0.054-0.002h-79.252c-0.23-0.007-0.5-0.010-0.773-0.010-16.46 0-29.804 13.345-29.804 29.804 0 0.838 0.035 1.668 0.103 2.488l-0.008-0.108v28.788c0 18.289 31.159 45.044 60.285 45.722h102.96l-41.997 37.593c-33.867 31.837-57.914 42.674-57.914 101.603 0 106.685 7.79 187.63 7.79 187.63l6.434 67.736c0.988 9.612 2.42 18.147 4.343 26.495l-0.278-1.434v120.232c0 0.018 0 0.038 0 0.062 0 17.991 14.027 32.704 31.739 33.803l0.096 0.005h143.602c17.657-1.276 31.498-15.914 31.498-33.786 0-0.030 0-0.058 0-0.088v0.004-61.302h619.788v60.624c0 0.024 0 0.054 0 0.083 0 17.87 13.84 32.508 31.387 33.778l0.11 0.007h143.94c17.657-1.276 31.498-15.914 31.498-33.786 0-0.030 0-0.058 0-0.088v0.004-96.863c5.11-14.017 9.036-30.399 11.072-47.361l0.105-1.070 6.434-67.736s7.79-80.945 7.79-187.63c0-57.576-23.708-67.736-57.914-101.603l-40.303-36.917h92.122c29.127 0 60.624-27.433 60.624-45.722v-29.127c0.012-0.323 0.019-0.704 0.019-1.086 0-16.647-13.496-30.144-30.144-30.144-0.722 0-1.438 0.025-2.147 0.075l0.095-0.005zM270.692 292.365c10.406-25.358 21.758-46.965 34.855-67.343l-0.987 1.639c9.321-13.894 19.587-25.988 31.056-36.82l0.103-0.096c20.536-11.504 44.825-18.858 70.69-20.302l0.433-0.019c62.656-6.773 164.261-6.773 164.261-6.773h112.444s101.603 0 164.599 6.773c26.183 1.454 50.357 8.81 71.612 20.748l-0.828-0.427c11.689 10.852 21.967 22.96 30.701 36.178l0.458 0.739c12.11 18.739 23.463 40.346 32.862 62.97l1.007 2.735c15.241 37.255-11.177 47.077-24.724 47.754s-213.031 0-213.031 0l-118.2-1.693-119.555 3.726s-199.484 0-213.031 0-39.964-12.531-24.724-49.786zM286.95 728.249h-92.122c-22.353 0-30.481-31.498-30.481-44.368s8.806-14.902 22.014-15.241h78.574c10.954 0.060 21.311 2.551 30.581 6.961l-0.437-0.188c6.911 4.122 12.671 9.449 17.157 15.747l0.115 0.171c4.21 6.171 7.289 13.463 8.751 21.324l0.054 0.351c0 8.467-3.726 15.241-34.207 15.241zM366.201 558.909c-25.239 5.18-54.246 8.148-83.946 8.148-6.21 0-12.391-0.13-18.537-0.386l0.88 0.030c-4.907 0.729-10.571 1.144-16.329 1.144-22.512 0-43.542-6.348-61.396-17.352l0.506 0.29c-20.047-13.724-33.201-36.248-33.867-61.878l-0.002-0.1c-2.371-31.837-1.693-48.433 37.593-48.77 1.182-0.021 2.577-0.033 3.975-0.033 43.874 0 85.014 11.701 120.472 32.151l-1.168-0.621c26.981 12.019 49.639 29.361 67.494 50.841l0.243 0.3c2.22 3.665 3.531 8.094 3.531 12.829 0 11.852-8.227 21.781-19.28 24.392l-0.17 0.034zM751.283 709.622h-247.238c-33.867 0-93.137-6.097-93.137-55.882 0.091-18.161 4.46-35.279 12.149-50.429l-0.296 0.642c10.648-32.754 39.174-56.734 73.775-60.588l0.397-0.036c36.554-6.059 78.677-9.521 121.609-9.521 2.731 0 5.459 0.012 8.183 0.042l-0.416-0.003c2.242-0.023 4.892-0.036 7.544-0.036 43.010 0 85.211 3.462 126.341 10.121l-4.509-0.603c35.678 3.793 64.786 28.24 75.353 61.013l0.174 0.628c7.141 14.554 11.375 31.658 11.515 49.739v0.047c1.354 49.786-58.592 55.882-91.444 55.882zM1058.468 727.234h-92.122c-30.481 0-33.867-6.773-33.867-15.241 1.517-8.213 4.595-15.505 8.932-21.873l-0.127 0.197c4.705-6.374 10.441-11.678 17.015-15.768l0.258-0.15c8.831-4.223 19.19-6.715 30.122-6.773h78.594c13.209 0 22.014 2.709 22.014 15.241s-8.129 45.383-30.82 45.383zM1099.786 490.156c-0.667 25.731-13.821 48.254-33.605 61.809l-0.264 0.17c-17.255 10.713-38.189 17.064-60.607 17.064-5.74 0-11.384-0.416-16.901-1.221l0.628 0.075c-5.323 0.234-11.566 0.366-17.841 0.366-29.637 0-58.58-2.969-86.548-8.627l2.785 0.47c-10.737-2.851-18.521-12.483-18.521-23.933 0-4.529 1.219-8.773 3.344-12.423l-0.065 0.117c18.088-21.789 40.751-39.133 66.574-50.676l1.162-0.465c34.348-19.829 75.547-31.527 119.479-31.527 1.337 0 2.67 0.011 4.003 0.033l-0.201-0.002c38.271 0 39.287 16.595 36.578 48.433z",
				"M1260.322 594.809l122.942 146.988v-65.027l123.957 81.961-154.439-164.938 1.354 64.689-93.815-63.672z",
				"M1260.322 495.237l122.942-146.988v65.365l123.957-82.3-154.439 164.938 1.354-64.689-93.815 63.672z",
				"M1329.413 527.411l98.217 67.736-10.499-39.964 88.396 28.449-119.892-73.494 11.177 39.287-67.398-22.014z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"damages"
			],
			defaultCode: 59658,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3509,
			id: 56,
			name: "damages",
			prevSize: 32,
			code: 59658,
			ligatures: "damages"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 56
	},
	{
		icon: {
			paths: [
				"M1024 64v126.4h-512v-126.4h512zM1024 318.4v126.4h-512v-126.4h512zM1024 576v126.4h-1024v-126.4h1024zM1024 832v128h-1024v-128h1024zM238.4 444.8h-99.2c-76.8 0-139.2-62.4-139.2-139.2v-102.4c0-76.8 62.4-139.2 139.2-139.2h99.2c76.8 0 139.2 62.4 139.2 139.2v102.4c1.6 76.8-62.4 139.2-139.2 139.2z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"details"
			],
			defaultCode: 59648,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 57,
			order: 3508,
			ligatures: "details",
			prevSize: 32,
			code: 59648,
			name: "details"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 57
	},
	{
		icon: {
			paths: [
				"M880 384h-288v128h256v192h-256v320h-128v-320h-352l-96-96 96-96h352v-128h-320v-256h320v-80c0-12.8 4.8-24 14.4-33.6 9.6-11.2 20.8-14.4 33.6-14.4h32c12.8 0 24 4.8 33.6 14.4 9.6 8 14.4 19.2 14.4 33.6v80h288l128 128-128 128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"direction"
			],
			defaultCode: 57598,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 58,
			order: 3507,
			ligatures: "direction",
			prevSize: 32,
			code: 57598,
			name: "direction"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 58
	},
	{
		icon: {
			paths: [
				"M864 0h-832c-17.6 0-32 14.4-32 32v960c0 17.6 14.4 32 32 32h960c17.6 0 32-14.4 32-32v-832l-160-160zM256 32h512v256c0 17.6-14.4 32-32 32h-448c-17.6 0-32-14.4-32-32v-256zM896 992h-768v-416c0-35.348 28.654-64 64-64h640c35.346 0 64 28.652 64 64v416z",
				"M576 64h128v192h-128v-192z",
				"M256 576h512v64h-512v-64z",
				"M256 704h512v64h-512v-64z",
				"M256 832h512v64h-512v-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"floppy-disk",
				"save"
			],
			defaultCode: 60084,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 59,
			order: 3506,
			prevSize: 32,
			code: 60084,
			ligatures: "floppy-disk, save2",
			name: "disk"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 59
	},
	{
		icon: {
			paths: [
				"M512 0c-282.769 0-512 229.231-512 512 0 282.771 229.231 512 512 512 282.771 0 512-229.229 512-512 0-282.769-229.229-512-512-512zM512 921.6c-226.217 0-409.6-183.383-409.6-409.6s183.383-409.6 409.6-409.6c226.217 0 409.6 183.383 409.6 409.6s-183.383 409.6-409.6 409.6zM546.133 477.867v-136.533h136.533v-68.267h-136.533v-68.267h-68.267v68.267h-136.533v273.067h136.533v136.533h-136.533v68.267h136.533v68.267h68.267v-68.267h136.535l-0.002-273.067h-136.533zM477.867 477.867h-68.267v-136.533h68.267v136.533zM614.402 682.667h-68.269v-136.533h68.269v136.533z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"coin-dollar",
				"money",
				"cash",
				"currency-dollar"
			],
			defaultCode: 59915,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3505,
			id: 60,
			prevSize: 32,
			code: 59915,
			ligatures: "dollar-o",
			name: "dollar-o"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 60
	},
	{
		icon: {
			paths: [
				"M767.814 544.496l127.967-127.967v511.867c0.008 0.47 0.013 1.024 0.013 1.578 0 26.138-10.784 49.756-28.145 66.65l-0.021 0.020c-16.443 16.872-39.392 27.337-64.783 27.337-0.919 0-1.834-0.014-2.746-0.041l0.133 0.003h-703.817c-0.922 0.034-2.005 0.052-3.092 0.052-25.512 0-48.579-10.466-65.143-27.339l-0.014-0.014c-17.382-16.913-28.166-40.533-28.166-66.671 0-0.555 0.004-1.109 0.014-1.661l-0.001 0.084v-703.817c-0.008-0.47-0.013-1.024-0.013-1.578 0-26.138 10.784-49.756 28.145-66.65l0.021-0.020c16.43-15.419 38.601-24.89 62.986-24.89 1.851 0 3.691 0.055 5.515 0.163l-0.252-0.011h511.867l-127.967 127.967h-352.336v639.834h639.834zM864.216 0.211c2.368-0.132 5.14-0.207 7.93-0.207 83.866 0 151.854 67.988 151.854 151.854 0 3.073-0.091 6.127-0.272 9.155l0.020-0.418-607.415 607.415h-160.385v-159.532z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"edit"
			],
			defaultCode: 59683,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3504,
			id: 61,
			name: "edit",
			prevSize: 32,
			code: 59683,
			ligatures: "edit"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 61
	},
	{
		icon: {
			paths: [
				"M1024 0h-416l160 160-192 192 96 96 192-192 160 160z",
				"M1024 1024v-416l-160 160-192-192-96 96 192 192-160 160z",
				"M0 1024h416l-160-160 192-192-96-96-192 192-160-160z",
				"M0 0v416l160-160 192 192 96-96-192-192 160-160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"enlarge",
				"expand",
				"maximize",
				"fullscreen"
			],
			defaultCode: 60219,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 62,
			order: 3503,
			prevSize: 32,
			code: 60219,
			ligatures: "enlarge",
			name: "enlarge"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 62
	},
	{
		icon: {
			paths: [
				"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.798 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM896 320l-384 288-384-288v-64l384 192 384-192v64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"envelop5"
			],
			defaultCode: 59956,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 63,
			order: 3502,
			ligatures: "envelope",
			prevSize: 32,
			code: 59956,
			name: "envelope"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 63
	},
	{
		icon: {
			paths: [
				"M960 128h-896c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-640c0-35.2-28.8-64-64-64zM896 256v46l-384 226.286-384-226.286v-46h768zM128 768v-354.572l384 226.286 384-226.286v354.572h-768z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"envelop",
				"mail",
				"email",
				"contact",
				"letter"
			],
			defaultCode: 59955,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 64,
			order: 3501,
			prevSize: 32,
			code: 59955,
			ligatures: "envelope-o, envelope2",
			name: "envelope2"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 64
	},
	{
		icon: {
			paths: [
				"M1009.956 915.76v0l-437.074-871.112c-16.742-29.766-38.812-44.648-60.882-44.648s-44.14 14.882-60.884 44.648l-437.074 871.112c-33.486 59.532-5 108.24 63.304 108.24h869.308c68.302 0 96.792-48.708 63.302-108.24zM512 896c-35.346 0-64-28.654-64-64s28.654-64 64-64c35.348 0 64 28.652 64 64s-28.652 64-64 64zM576 640c0 35.346-28.654 64-64 64s-64-28.654-64-64v-192c0-35.346 28.654-64 64-64s64 28.654 64 64v192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"warning",
				"sign"
			],
			defaultCode: 60753,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 65,
			order: 3500,
			prevSize: 32,
			code: 60753,
			ligatures: "error-triangle",
			name: "error-triangle"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 65
	},
	{
		icon: {
			paths: [
				"M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"eye"
			],
			defaultCode: 60588,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 66,
			order: 3499,
			ligatures: "eye",
			prevSize: 32,
			code: 60588,
			name: "eye"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 66
	},
	{
		icon: {
			paths: [
				"M945.942 14.058c-18.746-18.744-49.136-18.744-67.882 0l-202.164 202.164c-51.938-15.754-106.948-24.222-163.896-24.222-223.318 0-416.882 130.042-512 320 41.122 82.124 100.648 153.040 173.022 207.096l-158.962 158.962c-18.746 18.746-18.746 49.136 0 67.882 9.372 9.374 21.656 14.060 33.94 14.060s24.568-4.686 33.942-14.058l864-864c18.744-18.746 18.744-49.138 0-67.884zM416 320c42.24 0 78.082 27.294 90.92 65.196l-121.724 121.724c-37.902-12.838-65.196-48.68-65.196-90.92 0-53.020 42.98-96 96-96zM110.116 512c38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.862-7.3-9.962 27.328-15.412 56.822-15.412 87.596 0 54.89 17.286 105.738 46.7 147.418l-60.924 60.924c-52.446-36.842-97.202-83.882-131.66-138.342zM768 442c0-27.166-4.256-53.334-12.102-77.898l-321.808 321.808c24.568 7.842 50.742 12.090 77.91 12.090 141.382 0 256-114.618 256-256zM830.026 289.974l-69.362 69.362c1.264 0.786 2.53 1.568 3.786 2.368 60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-38.664 0-76.902-4.76-113.962-14.040l-76.894 76.894c59.718 21.462 123.95 33.146 190.856 33.146 223.31 0 416.876-130.042 512-320-45.022-89.916-112.118-166.396-193.974-222.026z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"eye-blocked"
			],
			defaultCode: 60591,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 67,
			order: 3498,
			ligatures: "eye-blocked",
			prevSize: 32,
			code: 60591,
			name: "eye-blocked"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 67
	},
	{
		icon: {
			paths: [
				"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.984 17.78 50.678 41.878 81.374 72.572zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v624z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-empty",
				"file",
				"document",
				"paper",
				"page",
				"new",
				"empty",
				"blank"
			],
			defaultCode: 59806,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3497,
			id: 68,
			prevSize: 32,
			code: 59806,
			ligatures: "file-empty",
			name: "file-empty"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 68
	},
	{
		icon: {
			paths: [
				"M743.028 384h-135.292l-95.732 141.032-95.742-141.032h-135.29l162.162 242.464-182.972 269.536h251.838v-91.576h-50.156l50.156-74.994 111.396 166.57h140.444l-182.976-269.536 162.164-242.464zM917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-excel"
			],
			defaultCode: 61241,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 69,
			order: 3496,
			ligatures: "file-excel",
			prevSize: 32,
			code: 61241,
			name: "file-excel"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 69
	},
	{
		icon: {
			paths: [
				"M842.012 589.48c-13.648-13.446-43.914-20.566-89.972-21.172-31.178-0.344-68.702 2.402-108.17 7.928-17.674-10.198-35.892-21.294-50.188-34.658-38.462-35.916-70.568-85.772-90.576-140.594 1.304-5.12 2.414-9.62 3.448-14.212 0 0 21.666-123.060 15.932-164.666-0.792-5.706-1.276-7.362-2.808-11.796l-1.882-4.834c-5.894-13.592-17.448-27.994-35.564-27.208l-10.916-0.344c-20.202 0-36.664 10.332-40.986 25.774-13.138 48.434 0.418 120.892 24.98 214.738l-6.288 15.286c-17.588 42.876-39.63 86.060-59.078 124.158l-2.528 4.954c-20.46 40.040-39.026 74.028-55.856 102.822l-17.376 9.188c-1.264 0.668-31.044 16.418-38.028 20.644-59.256 35.38-98.524 75.542-105.038 107.416-2.072 10.17-0.53 23.186 10.014 29.212l16.806 8.458c7.292 3.652 14.978 5.502 22.854 5.502 42.206 0 91.202-52.572 158.698-170.366 77.93-25.37 166.652-46.458 244.412-58.090 59.258 33.368 132.142 56.544 178.142 56.544 8.168 0 15.212-0.78 20.932-2.294 8.822-2.336 16.258-7.368 20.792-14.194 8.926-13.432 10.734-31.932 8.312-50.876-0.72-5.622-5.21-12.574-10.068-17.32zM211.646 814.048c7.698-21.042 38.16-62.644 83.206-99.556 2.832-2.296 9.808-8.832 16.194-14.902-47.104 75.124-78.648 105.066-99.4 114.458zM478.434 199.686c13.566 0 21.284 34.194 21.924 66.254s-6.858 54.56-16.158 71.208c-7.702-24.648-11.426-63.5-11.426-88.904 0 0-0.566-48.558 5.66-48.558v0zM398.852 637.494c9.45-16.916 19.282-34.756 29.33-53.678 24.492-46.316 39.958-82.556 51.478-112.346 22.91 41.684 51.444 77.12 84.984 105.512 4.186 3.542 8.62 7.102 13.276 10.65-68.21 13.496-127.164 29.91-179.068 49.862v0zM828.902 633.652c-4.152 2.598-16.052 4.1-23.708 4.1-24.708 0-55.272-11.294-98.126-29.666 16.468-1.218 31.562-1.838 45.102-1.838 24.782 0 32.12-0.108 56.35 6.072 24.228 6.18 24.538 18.734 20.382 21.332v0zM917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-pdf"
			],
			defaultCode: 61238,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 70,
			order: 3495,
			ligatures: "file-pdf",
			prevSize: 32,
			code: 61238,
			name: "file-pdf"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 70
	},
	{
		icon: {
			paths: [
				"M917.806 229.076c-22.208-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.884 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0 0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.98 17.78 50.678 41.878 81.374 72.572v0 0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.322 32 32 32h224v624zM192 448v448h640v-448h-640zM384 832h-128v-128h128v128zM384 640h-128v-128h128v128zM576 832h-128v-128h128v128zM576 640h-128v-128h128v128zM768 832h-128v-128h128v128zM768 640h-128v-128h128v128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-spreadsheet"
			],
			defaultCode: 59845,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 71,
			order: 3494,
			ligatures: "file-spreadsheet",
			prevSize: 32,
			code: 59845,
			name: "file-spreadsheet"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 71
	},
	{
		icon: {
			paths: [
				"M917.806 229.076c-22.212-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.888 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.984 17.78 50.678 41.878 81.374 72.572zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.326 32 32 32h224v624z",
				"M736 832h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
				"M736 704h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z",
				"M736 576h-448c-17.672 0-32-14.326-32-32s14.328-32 32-32h448c17.674 0 32 14.326 32 32s-14.326 32-32 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"file-text",
				"file",
				"document",
				"list",
				"paper",
				"page"
			],
			defaultCode: 59822,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 72,
			order: 3493,
			prevSize: 32,
			code: 59822,
			ligatures: "file-text",
			name: "file-text"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 72
	},
	{
		icon: {
			paths: [
				"M917.806 357.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-368c-44.114 0-80 35.888-80 80v736c0 44.112 35.886 80 80 80h608c44.112 0 80-35.888 80-80v-496c0-14.332-4.372-39.35-42.194-90.924zM785.374 302.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-608c-8.672 0-16-7.328-16-16v-736c0-8.672 7.328-16 16-16 0 0 367.956-0.002 368 0v224c0 17.672 14.324 32 32 32h224v496zM602.924 42.196c-51.574-37.822-76.592-42.196-90.924-42.196h-368c-44.112 0-80 35.888-80 80v736c0 38.632 27.528 70.958 64 78.39v-814.39c0-8.672 7.328-16 16-16h486.876c-9.646-7.92-19.028-15.26-27.952-21.804z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"files-empty"
			],
			defaultCode: 59807,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 73,
			order: 3492,
			ligatures: "files-empty",
			prevSize: 32,
			code: 59807,
			name: "files-empty"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 73
	},
	{
		icon: {
			paths: [
				"M0 128l384 384v384l256-64v-320l384-384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"filter"
			],
			defaultCode: 61064,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 74,
			order: 3491,
			ligatures: "filter",
			prevSize: 32,
			code: 61064,
			name: "filter"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 74
	},
	{
		icon: {
			paths: [
				"M272 0c-106.040 0-192 100.288-192 224 0 105.924 63.022 194.666 147.706 217.998l-31.788 518.124c-2.154 35.132 24.882 63.878 60.082 63.878h32c35.2 0 62.236-28.746 60.082-63.878l-31.788-518.124c84.684-23.332 147.706-112.074 147.706-217.998 0-123.712-85.96-224-192-224zM917.334 0l-53.334 320h-40l-26.666-320h-26.668l-26.666 320h-40l-53.334-320h-26.666v416c0 17.672 14.326 32 32 32h83.338l-31.42 512.122c-2.154 35.132 24.882 63.878 60.082 63.878h32c35.2 0 62.236-28.746 60.082-63.878l-31.42-512.122h83.338c17.674 0 32-14.328 32-32v-416h-26.666z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"spoon-knife",
				"food",
				"restaurant"
			],
			defaultCode: 60345,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 75,
			order: 3490,
			prevSize: 32,
			code: 60345,
			ligatures: "fork-spoon",
			name: "fork-spoon"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 75
	},
	{
		icon: {
			paths: [
				"M1014.001 214.798l-136.533-136.533c-6.4-6.4-15.083-9.997-24.134-9.997h-68.267c-18.852 0-34.133 15.283-34.133 34.133s15.281 34.133 34.133 34.133h37.060l68.267 68.267h-37.060c-18.852 0-34.133 15.283-34.133 34.133v136.533c0 18.85 15.281 34.133 34.133 34.133h102.4v273.067c0 37.643-30.624 68.267-68.267 68.267s-68.267-30.624-68.267-68.267v-170.667c0-18.852-15.281-34.133-34.133-34.133h-102.4v-375.467c0-56.333-46.067-102.4-102.4-102.4h-409.6c-56.333 0-102.4 46.067-102.4 102.4v853.333h-68.267v68.267h750.933v-68.267h-68.267v-409.6h68.267v136.533c0 75.285 61.248 136.533 136.533 136.533s136.533-61.248 136.533-136.533v-443.733c0-9.054-3.597-17.734-9.999-24.137zM136.533 307.201v-204.8c0-18.767 15.366-34.133 34.133-34.133h409.6c18.799 0 34.133 15.366 34.133 34.133v204.8c0 18.767-15.334 34.133-34.133 34.133h-409.6c-18.767 0-34.133-15.366-34.133-34.133zM887.467 341.334v-68.267h68.267v68.267h-68.267z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"gas",
				"fuel",
				"gas-pump",
				"gas-station",
				"oil"
			],
			defaultCode: 60426,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 76,
			order: 3489,
			prevSize: 32,
			code: 60426,
			ligatures: "fuel",
			name: "fuel"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 76
	},
	{
		icon: {
			paths: [
				"M1010.174 915.75l-548.634-499.458 25.534-25.598c20.894-20.954 32.188-48.030 33.918-75.61 1.002-0.45 2.002-0.912 2.958-1.442l102.99-64.402c13.934-16.392 12.916-42.268-2.284-57.502l-179.12-179.608c-15.19-15.234-40.998-16.262-57.344-2.284l-64.236 103.268c-0.526 0.966-0.99 1.966-1.44 2.974-27.502 1.736-54.5 13.056-75.398 34.006l-97.428 97.702c-20.898 20.956-32.184 48.026-33.918 75.604-1.004 0.45-2.004 0.916-2.964 1.446l-102.986 64.406c-13.942 16.39-12.916 42.264 2.276 57.496l179.12 179.604c15.194 15.238 40.996 16.262 57.35 2.286l64.228-103.27c0.528-0.958 0.988-1.96 1.442-2.966 27.502-1.738 54.504-13.050 75.398-34.004l28.292-28.372 498.122 550.114c14.436 15.944 36.7 18.518 49.474 5.712l50.356-50.488c12.764-12.808 10.196-35.132-5.706-49.614z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"gavel"
			],
			defaultCode: 60385,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 77,
			order: 3488,
			ligatures: "gavel",
			prevSize: 32,
			code: 60385,
			name: "gavel"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 77
	},
	{
		icon: {
			paths: [
				"M1024 608.094v-192.188l-146.774-24.462c-5.958-18.132-13.222-35.668-21.694-52.5l86.454-121.034-135.896-135.898-120.826 86.304c-16.91-8.554-34.538-15.888-52.768-21.902l-24.402-146.414h-192.188l-24.402 146.416c-18.23 6.014-35.858 13.348-52.766 21.902l-120.828-86.304-135.898 135.898 86.454 121.036c-8.47 16.83-15.734 34.366-21.692 52.498l-146.774 24.46v192.188l147.118 24.52c5.96 17.968 13.21 35.348 21.642 52.030l-86.748 121.448 135.898 135.896 121.654-86.894c16.602 8.35 33.89 15.528 51.764 21.434l24.578 147.472h192.188l24.578-147.474c17.874-5.906 35.162-13.084 51.766-21.432l121.652 86.892 135.896-135.896-86.744-121.446c8.432-16.682 15.678-34.062 21.64-52.032l147.118-24.518zM512 640c-70.692 0-128-57.306-128-128 0-70.692 57.308-128 128-128 70.694 0 128 57.308 128 128 0 70.694-57.306 128-128 128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"cog",
				"gear",
				"preferences",
				"settings",
				"generate",
				"control",
				"options"
			],
			defaultCode: 60254,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 78,
			order: 3487,
			prevSize: 32,
			code: 60254,
			ligatures: "gear",
			name: "gear"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 78
	},
	{
		icon: {
			paths: [
				"M448 576v-572.024c-252.562 31.496-448 246.93-448 508.024 0 282.77 229.23 512 512 512 261.094 0 476.53-195.438 508.026-448h-572.026zM809.58 846.888c-82.014 72.942-187.696 113.112-297.58 113.112-60.508 0-119.172-11.836-174.362-35.18-53.34-22.56-101.256-54.874-142.42-96.038-41.166-41.162-73.478-89.080-96.038-142.42-23.344-55.19-35.18-113.854-35.18-174.362 0-109.884 40.17-215.566 113.112-297.578 55.866-62.816 127.634-108.242 206.888-131.85v557.428h557.43c-23.61 79.256-69.036 151.022-131.85 206.888zM512 0c282.77 0 512 229.23 512 512h-512v-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"pie-chart",
				"stats",
				"statistics",
				"graph"
			],
			defaultCode: 60290,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 79,
			order: 3486,
			prevSize: 32,
			code: 60290,
			ligatures: "graph-pie",
			name: "graph-pie"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 79
	},
	{
		icon: {
			paths: [
				"M0 0h448v448h-448zM576 0h448v448h-448zM0 576h448v448h-448zM576 576h448v448h-448z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"grid",
				"icons",
				"apps",
				"squares"
			],
			defaultCode: 60511,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 80,
			order: 3485,
			prevSize: 32,
			code: 60511,
			ligatures: "grid",
			name: "grid"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 80
	},
	{
		icon: {
			paths: [
				"M0 0h256v256h-256zM384 0h256v256h-256zM768 0h256v256h-256zM0 384h256v256h-256zM384 384h256v256h-256zM768 384h256v256h-256zM0 768h256v256h-256zM384 768h256v256h-256zM768 768h256v256h-256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"grid",
				"icons",
				"apps",
				"squares"
			],
			defaultCode: 60506,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 81,
			order: 3484,
			prevSize: 32,
			code: 60506,
			ligatures: "grid-small",
			name: "grid-small"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 81
	},
	{
		icon: {
			paths: [
				"M1024 358.156c0 86.362-37.218 164.030-96.49 217.844h0.49l-320 320c-32 32-64 64-96 64s-64-32-96-64l-319.51-320c-59.272-53.814-96.49-131.482-96.49-217.844 0-162.458 131.698-294.156 294.156-294.156 86.362 0 164.030 37.218 217.844 96.49 53.814-59.272 131.482-96.49 217.844-96.49 162.456 0 294.156 131.698 294.156 294.156z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"heart"
			],
			defaultCode: 60652,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 82,
			order: 3483,
			ligatures: "heart",
			prevSize: 32,
			code: 60652,
			name: "heart"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 82
	},
	{
		icon: {
			paths: [
				"M928 576l-320 320c-16 16-32 30.669-48 44s-32 20-48 20c-16 0-32-6.669-48-20s-32-28-48-44l-320-320c-29.333-26.667-52.667-58.667-70-96-17.333-38-26-78.667-26-122 0-40.667 7.667-78.667 23-114 15.333-36 36.333-67.333 63-94s57.667-47.667 93-63c36-15.334 74.333-23 115-23 43.333 0 83.667 8.667 121 26 20.652 9.42 39.63 20.612 56.935 33.578 14.536 10.89 27.891 23.031 40.065 36.422 12.514-13.765 26.202-26.209 41.065-37.332 16.81-12.58 35.121-23.469 54.935-32.668 38.003-17.333 78.669-26 121.997-26 40.672 0 78.669 7.667 114.003 23 36 15.333 67.334 36.333 93.997 63 26.669 26.667 47.667 58 63.002 94 15.334 35.333 23.002 73.333 23.002 114 0 43.333-8.666 84-25.997 122-17.338 37.333-40.672 69.333-70.003 96zM101.583 445.22c12.833 27.558 29.63 50.349 50.383 69.217l1.465 1.332 321.4 321.402c12.564 12.563 24.956 24.038 37.169 34.47 12.212-10.432 24.605-21.907 37.169-34.47l322.863-322.734c20.755-18.867 37.549-41.657 50.387-69.215 12.128-26.681 18.381-55.443 18.381-87.222 0-29.919-5.574-56.576-16.122-80.879l-0.224-0.518c-11.322-26.579-26.432-48.917-45.286-67.772s-41.19-33.965-67.77-45.285l-0.518-0.221c-24.307-10.547-50.963-16.125-80.883-16.125-31.776 0-60.538 6.255-87.219 18.383-27.557 12.833-50.348 29.63-69.215 50.383l-61.563 67.72-61.563-67.72c-18.682-20.55-41.661-37.359-69.965-50.269l-0.509-0.232c-25.779-11.969-54.079-18.265-85.963-18.265-29.81 0-56.927 5.539-82.14 16.236-25.837 11.249-47.981 26.346-67.029 45.395-18.855 18.855-33.965 41.192-45.285 67.772l-0.221 0.519c-10.547 24.303-16.125 50.959-16.125 80.878 0 31.778 6.255 60.54 18.383 87.22z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"heart-o"
			],
			grid: 32
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 3482,
			id: 83,
			name: "heart-o",
			prevSize: 32,
			code: 59665
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 83
	},
	{
		icon: {
			paths: [
				"M617.468 946.28c0-38.912 0-304.742 0-319.078 0-49.152-47.514-47.923-105.677-47.923s-105.677 0-105.677 47.923v319.078h-219.136c-0.123 0.003-0.268 0.004-0.414 0.004-10.858 0-19.661-8.802-19.661-19.661 0-0.146 0.002-0.291 0.005-0.436v0.022-390.349l-64.307 50.79c-3.584 2.607-8.073 4.171-12.927 4.171-0.64 0-1.274-0.027-1.9-0.080l0.082 0.006c-5.543-0.706-10.305-3.582-13.481-7.734l-0.035-0.048-70.042-88.883c-2.627-3.456-4.209-7.831-4.209-12.575 0-0.764 0.041-1.519 0.121-2.263l-0.008 0.092c0.706-5.543 3.582-10.305 7.734-13.481l0.048-0.035 491.93-385.024c3.334-2.687 7.621-4.313 12.288-4.313s8.954 1.626 12.326 4.343l-0.038-0.029 491.52 386.253c4.822 3.704 7.9 9.472 7.9 15.959 0 4.656-1.586 8.942-4.247 12.348l0.033-0.044-70.042 88.883c-3.212 4.201-7.974 7.077-13.417 7.772l-0.1 0.010c-0.651 0.072-1.406 0.113-2.17 0.113-4.745 0-9.12-1.582-12.627-4.247l0.052 0.038-64.307-50.79v390.349c0.003 0.123 0.004 0.268 0.004 0.414 0 10.858-8.802 19.661-19.661 19.661-0.146 0-0.291-0.002-0.436-0.005h0.022z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"Home"
			],
			defaultCode: 59660,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3481,
			id: 84,
			name: "home",
			prevSize: 32,
			code: 59660,
			ligatures: "home"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 84
	},
	{
		icon: {
			paths: [
				"M959.884 128c0.040 0.034 0.082 0.076 0.116 0.116v767.77c-0.034 0.040-0.076 0.082-0.116 0.116h-895.77c-0.040-0.034-0.082-0.076-0.114-0.116v-767.772c0.034-0.040 0.076-0.082 0.114-0.114h895.77zM960 64h-896c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-768c0-35.2-28.8-64-64-64v0z",
				"M832 288c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96z",
				"M896 832h-768v-128l224-384 256 320h64l224-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"image",
				"picture",
				"photo",
				"graphic"
			],
			defaultCode: 59708,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3480,
			id: 85,
			prevSize: 32,
			code: 59708,
			ligatures: "image",
			name: "image"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 85
	},
	{
		icon: {
			paths: [
				"M967.111 170.667h-56.889v-56.889c0-31.289-25.6-56.889-56.889-56.889h-796.444c-31.289 0-56.889 25.6-56.889 56.889v682.667c0 31.289 25.6 56.889 56.889 56.889h56.889v56.889c0 31.289 25.6 56.889 56.889 56.889h796.444c31.289 0 56.889-25.6 56.889-56.889v-682.667c0-31.289-25.6-56.889-56.889-56.889zM113.778 227.556v568.889h-56.789c-0.037-0.030-0.071-0.069-0.1-0.102v-682.461c0.030-0.037 0.069-0.071 0.1-0.1h796.239c0.037 0.030 0.071 0.069 0.102 0.102v56.787h-682.667c-31.289 0-56.889 25.6-56.889 56.889v0zM967.111 910.121c-0.030 0.037-0.069 0.071-0.102 0.102h-796.239c-0.037-0.030-0.071-0.069-0.1-0.102v-682.461c0.030-0.037 0.069-0.071 0.1-0.1h796.239c0.037 0.030 0.071 0.069 0.102 0.102v682.459zM853.333 369.778c0 47.128-38.205 85.333-85.333 85.333s-85.333-38.205-85.333-85.333 38.205-85.333 85.333-85.333 85.333 38.205 85.333 85.333zM910.222 853.333h-682.667v-113.778l199.111-341.333 227.556 284.444h56.889l199.111-170.667z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"images"
			],
			defaultCode: 59710,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 86,
			order: 3479,
			ligatures: "images",
			prevSize: 32,
			code: 59710,
			name: "images"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 86
	},
	{
		icon: {
			paths: [
				"M1016.988 556.010l-256-320c-11.040-13.798-31.176-16.036-44.978-4.998-13.8 11.040-16.038 31.176-4.998 44.978l248.988 311.234v20.776h-224l-128 128h-192l-128-128h-224v-20.776l248.988-311.234c11.042-13.8 8.804-33.938-4.998-44.978s-33.94-8.804-44.978 4.998l-256 320c-4.538 5.674-7.012 12.724-7.012 19.99v288c0 35.346 28.654 64 64 64h896c35.348 0 64-28.654 64-64v-288c0-7.266-2.472-14.316-7.012-19.99z",
				"M512 640l224-224h-160v-320h-128v320h-160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"drawer-in",
				"box",
				"inbox",
				"archive",
				"category"
			],
			defaultCode: 60032,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 87,
			order: 3478,
			prevSize: 32,
			code: 60032,
			ligatures: "inbox",
			name: "inbox"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 87
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM448 240c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32zM640 832h-256v-64h64v-256h-64v-64h192v320h64v64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"info"
			],
			defaultCode: 60769,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 88,
			order: 3477,
			ligatures: "info",
			prevSize: 32,
			name: "info",
			code: 60769
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 88
	},
	{
		icon: {
			paths: [
				"M448 304c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4 0-48-21.6-48-48v-32zM640 768h-256v-64h64v-192h-64v-64h192v256h64zM512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"info-o"
			],
			defaultCode: 60772,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 89,
			order: 3476,
			ligatures: "info-o",
			prevSize: 32,
			code: 60772,
			name: "info-o"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 89
	},
	{
		icon: {
			paths: [
				"M768 384h-704v-128h704v-160l224 224-224 224zM256 640h704v128h-704v160l-224-224 224-224z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"transmission",
				"arrows"
			],
			defaultCode: 60995,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 90,
			order: 3475,
			prevSize: 32,
			code: 60995,
			ligatures: "left-right",
			name: "left-right"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 90
	},
	{
		icon: {
			paths: [
				"M438.513 638.736c-13.629 0-27.255-5.198-37.652-15.596-97.417-97.419-97.417-255.932 0-353.352l196.608-196.608c47.194-47.192 109.937-73.181 176.675-73.181s129.483 25.989 176.677 73.179c97.415 97.419 97.415 255.932 0 353.352l-89.872 89.872c-20.795 20.795-54.508 20.795-75.305 0-20.793-20.793-20.793-54.51 0-75.305l89.872-89.872c55.894-55.896 55.894-146.846 0-202.742-27.077-27.077-63.078-41.988-101.372-41.988s-74.293 14.911-101.372 41.99l-196.608 196.606c-55.896 55.896-55.896 146.848 0 202.744 20.795 20.793 20.793 54.51 0 75.305-10.394 10.396-24.025 15.596-37.65 15.596z",
				"M249.855 1024c-66.74 0-129.485-25.989-176.675-73.179-97.417-97.419-97.417-255.932 0-353.352l89.87-89.87c20.795-20.793 54.512-20.793 75.305 0 20.795 20.793 20.795 54.51 0 75.305l-89.87 89.87c-55.896 55.896-55.896 146.848 0 202.744 27.075 27.075 63.076 41.986 101.37 41.986s74.293-14.911 101.374-41.99l196.608-196.606c55.894-55.896 55.894-146.848 0-202.744-20.795-20.795-20.793-54.51 0-75.305 20.793-20.793 54.51-20.793 75.305 0.002 97.415 97.417 97.415 255.93 0.002 353.35l-196.61 196.608c-47.196 47.194-109.941 73.181-176.679 73.181z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"link",
				"chain",
				"url",
				"uri",
				"anchor"
			],
			defaultCode: 60566,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3474,
			id: 91,
			prevSize: 32,
			code: 60566,
			ligatures: "link",
			name: "link"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 91
	},
	{
		icon: {
			paths: [
				"M384 64h640v128h-640v-128zM384 448h640v128h-640v-128zM384 832h640v128h-640v-128zM0 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 512c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM0 896c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"list"
			],
			defaultCode: 60503,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 92,
			order: 3473,
			ligatures: "list",
			prevSize: 32,
			code: 60503,
			name: "list"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 92
	},
	{
		icon: {
			paths: [
				"M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"location"
			],
			defaultCode: 59960,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 93,
			order: 3472,
			ligatures: "location",
			prevSize: 32,
			code: 59960,
			name: "location"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 93
	},
	{
		icon: {
			paths: [
				"M512 0c-176.732 0-320 143.268-320 320 0 320 320 576 320 576s320-256 320-576c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192c106.040 0 192 85.96 192 192s-85.96 192-192 192zM786.256 697.63c-14.182 22.274-28.876 43.38-43.656 63.226 2.346 1.102 4.666 2.216 6.942 3.354 48.67 24.338 70.458 51.582 70.458 67.79s-21.788 43.452-70.458 67.79c-61.28 30.638-147.86 48.21-237.542 48.21s-176.262-17.572-237.542-48.21c-48.672-24.338-70.458-51.582-70.458-67.79s21.786-43.452 70.458-67.79c2.276-1.136 4.596-2.252 6.94-3.354-14.78-19.846-29.474-40.954-43.654-63.226-67.874 34.632-109.744 82.052-109.744 134.37 0 106.040 171.922 192 384 192s384-85.96 384-192c0-52.318-41.87-99.738-109.744-134.37z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"location",
				"map-marker",
				"pin"
			],
			defaultCode: 59961,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 94,
			order: 3471,
			prevSize: 32,
			code: 59961,
			ligatures: "location-area",
			name: "location-area"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 94
	},
	{
		icon: {
			paths: [
				"M784 416h-16v-192c0-105.87-86.13-192-192-192h-128c-105.87 0-192 86.13-192 192v192h-16c-26.4 0-48 21.6-48 48v480c0 26.4 21.6 48 48 48h544c26.4 0 48-21.6 48-48v-480c0-26.4-21.6-48-48-48zM384 224c0-35.29 28.71-64 64-64h128c35.29 0 64 28.71 64 64v192h-256v-192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"lock",
				"secure",
				"private",
				"encrypted"
			],
			defaultCode: 60240,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 95,
			order: 3470,
			prevSize: 32,
			code: 60240,
			ligatures: "locked",
			name: "locked"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 95
	},
	{
		icon: {
			paths: [
				"M0 512c0 282.624 229.376 512 512 512s512-229.376 512-512c0-282.624-229.376-512-512-512s-512 229.376-512 512zM58.026 512c0-250.539 203.435-453.974 453.974-453.974s453.974 203.435 453.974 453.974-203.435 453.974-453.974 453.974c-250.539 0-453.974-203.435-453.974-453.974zM152.234 512c0 53.931 11.605 104.448 32.768 150.187l51.883-381.611c-52.565 62.123-84.651 143.36-84.651 231.424zM617.131 167.936c-33.451-10.24-68.267-15.702-105.131-15.702-30.037 0-59.392 4.096-87.382 10.923l98.304 326.315 94.208-321.536zM797.355 293.547l42.325 366.592c20.48-45.056 32.085-94.891 32.085-148.139 0-81.92-27.989-157.696-74.411-218.453zM561.152 846.507l-81.92-1.365-121.514-395.947-32.085 370.006c54.614 32.768 118.102 51.883 186.368 51.883 75.094 0 145.408-23.211 202.752-62.805l-30.037-374.101-123.562 412.331z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"manheim-medallion"
			],
			defaultCode: 59653,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 96,
			order: 3469,
			ligatures: "manheim-medallion",
			prevSize: 32,
			code: 59653,
			name: "manheim-medallion"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 96
	},
	{
		icon: {
			paths: [
				"M842.324 330.323c0-52.271-40.479-95.061-91.799-98.799 33.643-38.933 32.012-97.811-4.951-134.774-36.961-36.963-95.841-38.594-134.77-4.953-3.743-51.318-46.53-91.797-98.804-91.797s-95.059 40.479-98.799 91.797c-38.931-33.641-97.811-32.008-134.774 4.953-36.961 36.963-38.594 95.841-4.953 134.774-51.316 3.741-91.797 46.528-91.797 98.799s40.479 95.059 91.797 98.799c-33.641 38.931-32.008 97.811 4.953 134.772 27.446 27.446 66.971 35.394 101.444 23.901v436.205l132.129-132.129 132.129 132.129v-436.203c34.473 11.489 73.998 3.547 101.444-23.901 36.963-36.961 38.594-95.839 4.951-134.772 51.32-3.741 91.799-46.53 91.799-98.802zM512.001 528.517c-109.461 0-198.194-88.733-198.194-198.194s88.733-198.194 198.194-198.194c109.461 0 198.194 88.733 198.194 198.194s-88.733 198.194-198.194 198.194z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"medal"
			],
			defaultCode: 60317,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 97,
			order: 3468,
			ligatures: "medal",
			prevSize: 32,
			code: 60317,
			name: "medal"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 97
	},
	{
		icon: {
			paths: [
				"M1024 429.257c0-200.926-58.792-363.938-131.482-365.226 0.292-0.006 0.578-0.030 0.872-0.030h-82.942c0 0-194.8 146.336-475.23 203.754-8.56 45.292-14.030 99.274-14.030 161.502s5.466 116.208 14.030 161.5c280.428 57.418 475.23 203.756 475.23 203.756h82.942c-0.292 0-0.578-0.024-0.872-0.032 72.696-1.288 131.482-164.298 131.482-365.224zM864.824 739.253c-9.382 0-19.532-9.742-24.746-15.548-12.63-14.064-24.792-35.96-35.188-63.328-23.256-61.232-36.066-143.31-36.066-231.124 0-87.81 12.81-169.89 36.066-231.122 10.394-27.368 22.562-49.266 35.188-63.328 5.214-5.812 15.364-15.552 24.746-15.552 9.38 0 19.536 9.744 24.744 15.552 12.634 14.064 24.796 35.958 35.188 63.328 23.258 61.23 36.068 143.312 36.068 231.122 0 87.804-12.81 169.888-36.068 231.124-10.39 27.368-22.562 49.264-35.188 63.328-5.208 5.806-15.36 15.548-24.744 15.548zM251.812 429.257c0-51.95 3.81-102.43 11.052-149.094-47.372 6.554-88.942 10.324-140.34 10.324-67.058 0-67.058 0-67.058 0l-55.466 94.686v88.17l55.46 94.686c0 0 0 0 67.060 0 51.398 0 92.968 3.774 140.34 10.324-7.236-46.664-11.048-97.146-11.048-149.096zM368.15 642.173l-127.998-24.51 81.842 321.544c4.236 16.634 20.744 25.038 36.686 18.654l118.556-47.452c15.944-6.376 22.328-23.964 14.196-39.084l-123.282-229.152zM864.824 548.731c-3.618 0-7.528-3.754-9.538-5.992-4.87-5.42-9.556-13.86-13.562-24.408-8.962-23.6-13.9-55.234-13.9-89.078s4.938-65.478 13.9-89.078c4.006-10.548 8.696-18.988 13.562-24.408 2.010-2.24 5.92-5.994 9.538-5.994 3.616 0 7.53 3.756 9.538 5.994 4.87 5.42 9.556 13.858 13.56 24.408 8.964 23.598 13.902 55.234 13.902 89.078 0 33.842-4.938 65.478-13.902 89.078-4.004 10.548-8.696 18.988-13.56 24.408-2.008 2.238-5.92 5.992-9.538 5.992z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bullhorn",
				"megaphone",
				"announcement",
				"advertisement",
				"news"
			],
			defaultCode: 59769,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 98,
			order: 3467,
			prevSize: 32,
			code: 59769,
			ligatures: "megaphone",
			name: "megaphone"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 98
	},
	{
		icon: {
			paths: [
				"M0 146.285h1024v146.286h-1024v-146.286zM0 438.856h1024v146.286h-1024v-146.286zM0 731.428h1024v146.286h-1024v-146.286z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"three-bars"
			],
			defaultCode: 60526,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 99,
			order: 3466,
			ligatures: "menu",
			prevSize: 32,
			code: 60526,
			name: "menu"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 99
	},
	{
		icon: {
			paths: [
				"M0 416v192c0 17.672 14.328 32 32 32h960c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32h-960c-17.672 0-32 14.328-32 32z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus"
			],
			defaultCode: 60761,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 100,
			order: 3465,
			ligatures: "minus",
			prevSize: 32,
			code: 60761,
			name: "minus"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 100
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM832 576h-640v-128h640v128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus-circle"
			],
			defaultCode: 60767,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 101,
			order: 3464,
			ligatures: "minus-circle",
			prevSize: 32,
			name: "minus-circle",
			code: 60767
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 101
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM256 448h512v128h-512z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus-circle-o"
			],
			defaultCode: 60768,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 102,
			order: 3463,
			ligatures: "minus-circle-o",
			prevSize: 32,
			code: 60768,
			name: "minus-circle-o"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 102
	},
	{
		icon: {
			paths: [
				"M64 448h896v128h-896v-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"minus3"
			],
			defaultCode: 60766,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 103,
			order: 3462,
			ligatures: "minus-thin, minus3",
			prevSize: 32,
			code: 60766,
			name: "minus3"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 103
	},
	{
		icon: {
			paths: [
				"M736 0h-448c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 48h256v32h-256v-32zM512 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM768 768h-512v-640h512v640z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"mobile"
			],
			defaultCode: 60021,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 104,
			order: 3461,
			ligatures: "mobile",
			prevSize: 32,
			code: 60021,
			name: "mobile"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 104
	},
	{
		icon: {
			paths: [
				"M640 793.6v-230.059l102.4-102.4v434.859h-614.4v-614.4h434.859l-102.4 102.4h-230.059v409.6zM896 128v333.141l-128.341-128.341-383.659 384.341-76.459-74.411 383.659-386.389-128.341-128.341z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"Artboard 12"
			],
			defaultCode: 61125,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3460,
			id: 105,
			name: "new-window",
			prevSize: 32,
			code: 61125,
			ligatures: "new-window"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 105
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576 832h-128v-128h128v128zM576 576h-128v-384h128v384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"notification-circle"
			],
			defaultCode: 60751,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 106,
			order: 3459,
			ligatures: "notification-circle",
			prevSize: 32,
			code: 60751,
			name: "notification-circle"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 106
	},
	{
		icon: {
			paths: [
				"M512 192c-282.77 0-512 229.228-512 512h64c0-116.418 51.806-220.726 133.622-291.148l195.322 244.15c-5.75 14.554-8.944 30.398-8.944 46.998 0 70.694 57.308 128 128 128 70.694 0 128-57.306 128-128s-57.306-128-128-128c-16.6 0-32.444 3.194-46.998 8.946l-241.044-192.84c63.056-45.376 140.426-72.108 224.042-72.108 212.076 0 384 171.92 384 383.998h192c0-282.768-229.23-511.996-512-511.996z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"meter-slow",
				"gauge",
				"dashboard",
				"speedometer",
				"performance"
			],
			defaultCode: 60381,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 107,
			order: 3458,
			prevSize: 32,
			code: 60381,
			ligatures: "odometer",
			name: "odometer"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 107
	},
	{
		icon: {
			paths: [
				"M975.296 499.21c0 9.593-6.395 19.186-31.977 28.779-31.977 12.791-70.349 6.395-108.721-9.593v-223.838c15.988 15.988 35.175 31.977 51.163 51.163 60.756 67.151 92.733 124.71 89.535 153.489zM121.513 160.255c-31.977-9.593-47.965-22.384-54.361-25.582 9.593-6.395 35.175-25.582 102.326-38.372 67.151-15.988 156.687-25.582 249.42-25.582s179.071 9.593 249.42 22.384c67.151 12.791 92.733 31.977 102.326 38.372-9.593 6.395-35.175 25.582-102.326 38.372-67.151 15.988-156.687 22.384-249.42 22.384-15.988 0-31.977 0-47.965 0v211.048c0 25.582-22.384 47.965-47.965 47.965-19.186 0-31.977-9.593-41.57-22.384v67.151c0 51.163-35.175 92.733-76.745 92.733s-76.745-41.57-76.745-92.733v-335.757zM920.936 313.744c-31.977-35.175-63.954-63.954-86.338-83.14v-83.14c0-3.198 0-9.593 0-12.791 0-44.768-44.768-76.745-137.501-99.128-73.547-19.186-172.675-28.779-278.199-28.779s-204.652 9.593-281.397 28.779c-92.733 22.384-137.501 54.361-137.501 99.128 0 6.395 0 9.593 3.198 12.791v738.666c0 54.361 185.466 131.105 415.7 131.105s415.7-76.745 415.7-131.105v-265.408c-143.896-41.57-287.792-195.059-345.351-259.013 0 0-3.198 0-3.198 0-25.582 0-44.768-19.186-44.768-44.768s19.186-44.768 44.768-44.768c25.582 0 44.768 19.186 44.768 44.768 0 0 0 0 0 0s0 3.198 0 3.198 0 6.395-3.198 9.593c12.791 15.988 31.977 35.175 57.558 60.756s57.558 57.558 92.733 86.338c86.338 70.349 159.884 105.524 227.036 105.524 19.186 0 41.57-3.198 57.558-9.593 0 0 0 0 0 0 44.768-15.988 57.558-44.768 60.756-67.151 6.395-44.768-28.779-108.721-102.326-191.861z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"paint-can"
			],
			defaultCode: 59686,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 108,
			order: 3457,
			ligatures: "paint-can",
			prevSize: 32,
			code: 59686,
			name: "paint-can"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 108
	},
	{
		icon: {
			paths: [
				"M864.626 473.162c-65.754-183.44-205.11-348.15-352.626-473.162-147.516 125.012-286.87 289.722-352.626 473.162-40.664 113.436-44.682 236.562 12.584 345.4 65.846 125.14 198.632 205.438 340.042 205.438s274.196-80.298 340.040-205.44c57.27-108.838 53.25-231.962 12.586-345.398zM738.764 758.956c-43.802 83.252-132.812 137.044-226.764 137.044-55.12 0-108.524-18.536-152.112-50.652 13.242 1.724 26.632 2.652 40.112 2.652 117.426 0 228.668-67.214 283.402-171.242 44.878-85.292 40.978-173.848 23.882-244.338 14.558 28.15 26.906 56.198 36.848 83.932 22.606 63.062 40.024 156.34-5.368 242.604z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"droplet",
				"color",
				"water"
			],
			defaultCode: 59700,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 109,
			order: 3456,
			prevSize: 32,
			code: 59700,
			ligatures: "paint-drop",
			name: "paint-drop"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 109
	},
	{
		icon: {
			paths: [
				"M128 128h320v768h-320zM576 128h320v768h-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"pause",
				"player"
			],
			defaultCode: 60803,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 110,
			order: 3455,
			prevSize: 32,
			code: 60803,
			ligatures: "pause",
			name: "pause"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 110
	},
	{
		icon: {
			paths: [
				"M752.64 215.68v-96.64h-481.28v96.64h96.64l16 240-112.64 112.64h176.64l44.8 316.8 19.2 19.84 19.2-19.84 44.8-316.8h176.64l-112.64-112.64 16-240h96.64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"pin_1"
			],
			defaultCode: 61581,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3454,
			id: 111,
			name: "pin",
			prevSize: 32,
			code: 61581,
			ligatures: "pin"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 111
	},
	{
		icon: {
			paths: [
				"M534.4 149.12l-67.84 68.48 67.84 67.84-158.72 181.12h-158.080l124.16 128-192 256v28.16h27.52l256-192 128 124.16v-163.2l181.12-158.080 64 67.84 68.48-67.84zM548.48 526.080l-26.24 141.44-165.76-165.76 139.52-28.16 140.16-138.88 52.48 52.48z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"pin_2"
			],
			defaultCode: 61582,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3453,
			id: 112,
			name: "pin2",
			prevSize: 32,
			code: 61582,
			ligatures: "pin-angle, pin2"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 112
	},
	{
		icon: {
			paths: [
				"M192 128l640 384-640 384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"play",
				"player"
			],
			defaultCode: 60802,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 113,
			order: 3452,
			prevSize: 32,
			code: 60802,
			ligatures: "play",
			name: "play"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 113
	},
	{
		icon: {
			paths: [
				"M960 448h-384v-384h-128v384h-384v128h384v384h128v-384h384z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"plus"
			],
			defaultCode: 60765,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 114,
			order: 3451,
			ligatures: "plus",
			prevSize: 32,
			code: 60765,
			name: "plus"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 114
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM576 576v256h-128v-256h-256v-128h256v-256h128v256h256v128h-256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"plus-circle",
				"add",
				"sum"
			],
			defaultCode: 60759,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 115,
			order: 3450,
			prevSize: 32,
			code: 60759,
			ligatures: "plus-circle2, add5",
			name: "plus-circle"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 115
	},
	{
		icon: {
			paths: [
				"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 896c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM768 576h-192v192h-128v-192h-192v-128h192v-192h128v192h192z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"plus-circle",
				"add",
				"sum"
			],
			defaultCode: 60758,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 116,
			order: 3449,
			prevSize: 32,
			code: 60758,
			ligatures: "plus-circle-o",
			name: "plus-circle-o"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 116
	},
	{
		icon: {
			paths: [
				"M256 64h512v128h-512v-128zM960 256h-896c-35.2 0-64 28.8-64 64v320c0 35.2 28.794 64 64 64h192v256h512v-256h192c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM128 448c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64zM704 896h-384v-320h384v320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"printer"
			],
			defaultCode: 60006,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 117,
			order: 3448,
			ligatures: "printer",
			prevSize: 32,
			code: 60006,
			name: "printer"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 117
	},
	{
		icon: {
			paths: [
				"M320 64h-256v256h256v-256zM384 0v0 384h-384v-384h384zM128 128h128v128h-128zM960 64h-256v256h256v-256zM1024 0v0 384h-384v-384h384zM768 128h128v128h-128zM320 704h-256v256h256v-256zM384 640v0 384h-384v-384h384zM128 768h128v128h-128zM448 0h64v64h-64zM512 64h64v64h-64zM448 128h64v64h-64zM512 192h64v64h-64zM448 256h64v64h-64zM512 320h64v64h-64zM448 384h64v64h-64zM448 512h64v64h-64zM512 576h64v64h-64zM448 640h64v64h-64zM512 704h64v64h-64zM448 768h64v64h-64zM512 832h64v64h-64zM448 896h64v64h-64zM512 960h64v64h-64zM960 512h64v64h-64zM64 512h64v64h-64zM128 448h64v64h-64zM0 448h64v64h-64zM256 448h64v64h-64zM320 512h64v64h-64zM384 448h64v64h-64zM576 512h64v64h-64zM640 448h64v64h-64zM704 512h64v64h-64zM768 448h64v64h-64zM832 512h64v64h-64zM896 448h64v64h-64zM960 640h64v64h-64zM576 640h64v64h-64zM640 576h64v64h-64zM704 640h64v64h-64zM832 640h64v64h-64zM896 576h64v64h-64zM960 768h64v64h-64zM576 768h64v64h-64zM640 704h64v64h-64zM768 704h64v64h-64zM832 768h64v64h-64zM896 704h64v64h-64zM960 896h64v64h-64zM640 832h64v64h-64zM704 896h64v64h-64zM768 832h64v64h-64zM832 896h64v64h-64zM640 960h64v64h-64zM768 960h64v64h-64zM896 960h64v64h-64z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"qrcode"
			],
			defaultCode: 59896,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 118,
			order: 3447,
			prevSize: 32,
			code: 59896,
			ligatures: "qr-code",
			name: "qr-code"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 118
	},
	{
		icon: {
			paths: [
				"M889.68 166.32c-93.608-102.216-228.154-166.32-377.68-166.32-282.77 0-512 229.23-512 512h96c0-229.75 186.25-416 416-416 123.020 0 233.542 53.418 309.696 138.306l-149.696 149.694h352v-352l-134.32 134.32z",
				"M928 512c0 229.75-186.25 416-416 416-123.020 0-233.542-53.418-309.694-138.306l149.694-149.694h-352v352l134.32-134.32c93.608 102.216 228.154 166.32 377.68 166.32 282.77 0 512-229.23 512-512h-96z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"loop",
				"repeat",
				"player",
				"reload",
				"refresh",
				"update",
				"synchronize",
				"arrows"
			],
			defaultCode: 60839,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3446,
			id: 119,
			prevSize: 32,
			code: 60839,
			ligatures: "refresh",
			name: "refresh"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 119
	},
	{
		icon: {
			paths: [
				"M589.576 77.576c239.926 0 434.424 194.498 434.424 434.424s-194.498 434.424-434.424 434.424v-93.090c91.175 0 176.891-35.504 241.36-99.974s99.974-150.185 99.974-241.36c0-91.173-35.504-176.891-99.974-241.36s-150.185-99.974-241.36-99.974c-91.173 0-176.891 35.504-241.36 99.974-49.591 49.589-82.019 111.753-94.358 179.299h180.566l-217.212 248.242-217.212-248.242h159.583c30.12-210.523 211.14-372.364 429.993-372.364zM775.758 449.94v124.122h-248.242v-310.303h124.122v186.182z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"history",
				"time",
				"archive",
				"past"
			],
			defaultCode: 59980,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 120,
			order: 3445,
			prevSize: 32,
			code: 59980,
			ligatures: "reset-time",
			name: "reset-time"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 120
	},
	{
		icon: {
			paths: [
				"M128 576c0-247.422 200.576-448 448-448s448 200.578 448 448c0 173.374-98.492 323.73-242.566 398.208 106.62-65.99 178.566-190.926 178.566-334.208 0-212.078-157.596-384-352-384-174.412 0-319.154 138.392-347.086 320h123.086l-192 224-192-224h128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"rotate-ccw",
				"ccw",
				"arrow"
			],
			defaultCode: 60070,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 121,
			order: 3444,
			prevSize: 32,
			code: 60070,
			ligatures: "rotate-left",
			name: "rotate-left"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 121
	},
	{
		icon: {
			paths: [
				"M896 576c0-247.422-200.576-448-448-448s-448 200.578-448 448c0 173.374 98.492 323.73 242.566 398.208-106.62-65.99-178.566-190.926-178.566-334.208 0-212.078 157.596-384 352-384 174.412 0 319.154 138.392 347.086 320h-123.086l192 224 192-224h-128z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"rotate-cw",
				"cw",
				"arrow"
			],
			defaultCode: 60071,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 122,
			order: 3443,
			prevSize: 32,
			code: 60071,
			ligatures: "rotate-right",
			name: "rotate-right"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 122
	},
	{
		icon: {
			paths: [
				"M637.542 557.848c41.806-57.89 66.458-128.984 66.458-205.848 0-194.404-157.596-352-352-352s-352 157.596-352 352 157.596 352 352 352c76.864 0 147.958-24.652 205.848-66.458l338.152 386.458 128-128-386.458-338.152zM352 608c-141.384 0-256-114.616-256-256s114.616-256 256-256c141.382 0 256 114.616 256 256s-114.614 256-256 256z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"search"
			],
			defaultCode: 60208,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 123,
			order: 3442,
			ligatures: "search",
			prevSize: 32,
			code: 60208,
			name: "search"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 123
	},
	{
		icon: {
			paths: [
				"M879.326 195.908l-351.998-192c-4.774-2.606-10.048-3.908-15.322-3.908s-10.548 1.302-15.326 3.908l-352.004 192c-10.28 5.606-16.676 16.382-16.676 28.092v256c0 140.788 36.312 254.616 111.012 347.99 58.364 72.956 138.144 132.366 258.68 192.63 4.504 2.252 9.408 3.378 14.31 3.378s9.806-1.126 14.31-3.378c120.534-60.268 200.31-119.678 258.674-192.63 74.702-93.374 111.014-207.202 111.014-347.99l0.002-256c0-11.71-6.396-22.486-16.676-28.092zM800 480c0 60.998-7.508 114.184-22.954 162.598-14.868 46.606-36.792 87.632-67.022 125.422-44.742 55.928-106.512 103.48-198.022 152.008 0 0-0.002-0.002-0.002-0.002v-815.124l0.004-0.002 287.998 157.090-0.002 218.010z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"shield"
			],
			defaultCode: 60462,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 124,
			order: 3441,
			ligatures: "shield",
			prevSize: 32,
			code: 60462,
			name: "shield"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 124
	},
	{
		icon: {
			paths: [
				"M879.324 195.908l-351.996-192c-4.774-2.606-10.048-3.908-15.322-3.908-5.276 0-10.548 1.302-15.326 3.908l-352.004 192c-10.28 5.606-16.676 16.382-16.676 28.092v256c0 140.79 36.31 254.618 111.012 347.99 58.364 72.956 138.144 132.366 258.68 192.628 4.504 2.252 9.408 3.378 14.31 3.378s9.804-1.126 14.308-3.378c120.536-60.268 200.31-119.678 258.674-192.628 74.704-93.372 111.016-207.2 111.016-347.99l0.002-256c0-11.71-6.396-22.486-16.678-28.092zM416 722.912l-178.912-178.912 50.912-50.912 128 128 320-320 50.912 50.912-370.912 370.912z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"shield-check"
			],
			defaultCode: 60463,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 125,
			order: 3440,
			ligatures: "shield-check",
			prevSize: 32,
			code: 60463,
			name: "shield-check"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 125
	},
	{
		icon: {
			paths: [
				"M576 448h416l-160-160 192-192-96-96-192 192-160-160z",
				"M576 576v416l160-160 192 192 96-96-192-192 160-160z",
				"M448 575.996h-416l160 160-192 192 96 96 192-192 160 160z",
				"M448 448v-416l-160 160-192-192-96 96 192 192-160 160z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"shrink",
				"collapse",
				"minimize",
				"contract"
			],
			defaultCode: 60220,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3439,
			id: 126,
			prevSize: 32,
			code: 60220,
			ligatures: "shrink",
			name: "shrink"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 126
	},
	{
		icon: {
			paths: [
				"M375.467 238.933v750.933h-136.533v-750.933h-170.667l238.933-238.933 238.933 238.933zM648.533 785.067v-750.933h136.533v750.933h170.667l-238.933 238.933-238.933-238.933z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"sort"
			],
			defaultCode: 61000,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 127,
			order: 3438,
			ligatures: "sort",
			prevSize: 32,
			code: 61000,
			name: "sort"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 127
	},
	{
		icon: {
			paths: [
				"M669.088 0l-320 320h-192v384l512-512zM919.264 69.824l-884.352 884.352 69.824 69.824 282.176-282.176 282.176 282.176v-564.354l320-320z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"volume-mute",
				"volume",
				"audio",
				"speaker",
				"player"
			],
			defaultCode: 60836,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 128,
			order: 3437,
			prevSize: 32,
			code: 60836,
			ligatures: "sound-off",
			name: "sound-off"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 128
	},
	{
		icon: {
			paths: [
				"M831.462 877.178c-14.041 0-28.075-5.355-38.791-16.064-21.422-21.422-21.422-56.155 0-77.579 149.721-149.721 149.721-393.336 0-543.057-21.422-21.424-21.422-56.158 0-77.579 21.422-21.419 56.158-21.422 77.579 0 93.25 93.246 144.605 217.227 144.605 349.103 0 131.874-51.355 255.858-144.605 349.108-10.711 10.713-24.75 16.069-38.788 16.069v0zM636.594 773.738c-14.041 0-28.075-5.355-38.791-16.066-21.424-21.424-21.424-56.153 0-77.577 92.686-92.686 92.686-243.494 0-336.178-21.424-21.424-21.424-56.158 0-77.579s56.155-21.422 77.579 0c135.463 135.463 135.463 355.876 0 491.338-10.711 10.706-24.75 16.062-38.788 16.062z",
				"M484.578 1024c-9.518 0-18.871-3.714-25.867-10.713l-281.858-281.858h-131.138c-20.197 0-36.571-16.373-36.571-36.571v-365.714c0-20.197 16.375-36.571 36.571-36.571h131.138l281.858-281.86c10.462-10.462 26.19-13.589 39.856-7.927 13.666 5.659 22.576 18.997 22.576 33.787v950.855c0 14.793-8.91 28.128-22.576 33.787-4.523 1.874-9.278 2.784-13.989 2.784z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"volume-medium",
				"volume",
				"audio",
				"speaker",
				"player"
			],
			defaultCode: 60813,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 129,
			order: 3436,
			prevSize: 32,
			code: 60813,
			ligatures: "sound-on",
			name: "sound-on"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 129
	},
	{
		icon: {
			paths: [
				"M1024 512c-1.278-66.862-15.784-133.516-42.576-194.462-26.704-61-65.462-116.258-113.042-161.92-47.552-45.696-103.944-81.82-164.984-105.652-61.004-23.924-126.596-35.352-191.398-33.966-64.81 1.282-129.332 15.374-188.334 41.356-59.048 25.896-112.542 63.47-156.734 109.576-44.224 46.082-79.16 100.708-102.186 159.798-23.114 59.062-34.128 122.52-32.746 185.27 1.286 62.76 14.964 125.148 40.134 182.206 25.088 57.1 61.476 108.828 106.11 151.548 44.61 42.754 97.472 76.504 154.614 98.72 57.118 22.304 118.446 32.902 179.142 31.526 60.708-1.29 120.962-14.554 176.076-38.914 55.15-24.282 105.116-59.48 146.366-102.644 41.282-43.14 73.844-94.236 95.254-149.43 13.034-33.458 21.88-68.4 26.542-103.798 1.246 0.072 2.498 0.12 3.762 0.12 35.346 0 64-28.652 64-64 0-1.796-0.094-3.572-0.238-5.332h0.238zM922.306 681.948c-23.472 53.202-57.484 101.4-99.178 141.18-41.67 39.81-91 71.186-144.244 91.79-53.228 20.678-110.29 30.452-166.884 29.082-56.604-1.298-112.596-13.736-163.82-36.474-51.25-22.666-97.684-55.49-135.994-95.712-38.338-40.198-68.528-87.764-88.322-139.058-19.87-51.284-29.228-106.214-27.864-160.756 1.302-54.552 13.328-108.412 35.254-157.69 21.858-49.3 53.498-93.97 92.246-130.81 38.73-36.868 84.53-65.87 133.874-84.856 49.338-19.060 102.136-28.006 154.626-26.644 52.5 1.306 104.228 12.918 151.562 34.034 47.352 21.050 90.256 51.502 125.624 88.782 35.396 37.258 63.21 81.294 81.39 128.688 18.248 47.392 26.782 98.058 25.424 148.496h0.238c-0.144 1.76-0.238 3.536-0.238 5.332 0 33.012 24.992 60.174 57.086 63.624-6.224 34.822-16.53 68.818-30.78 100.992z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"spinner",
				"loading",
				"loading-wheel",
				"busy",
				"wait"
			],
			defaultCode: 60192,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 130,
			order: 3435,
			prevSize: 32,
			code: 60192,
			ligatures: "spinner",
			name: "spinner"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 130
	},
	{
		icon: {
			paths: [
				"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538zM512 753.498l-223.462 117.48 42.676-248.83-180.786-176.222 249.84-36.304 111.732-226.396 111.736 226.396 249.836 36.304-180.788 176.222 42.678 248.83-223.462-117.48z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"star-empty"
			],
			defaultCode: 60643,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 131,
			order: 3434,
			ligatures: "star-empty",
			prevSize: 32,
			code: 60643,
			name: "star-empty"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 131
	},
	{
		icon: {
			paths: [
				"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"star-full"
			],
			defaultCode: 60645,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 132,
			order: 3433,
			ligatures: "star-full",
			prevSize: 32,
			code: 60645,
			name: "star-full"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 132
	},
	{
		icon: {
			paths: [
				"M1024 397.050l-353.78-51.408-158.22-320.582-158.216 320.582-353.784 51.408 256 249.538-60.432 352.352 316.432-166.358 316.432 166.358-60.434-352.352 256.002-249.538zM512 753.498l-0.942 0.496 0.942-570.768 111.736 226.396 249.836 36.304-180.788 176.222 42.678 248.83-223.462-117.48z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"star-half"
			],
			defaultCode: 60644,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 133,
			order: 3432,
			ligatures: "star-half",
			prevSize: 32,
			code: 60644,
			name: "star-half"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 133
	},
	{
		icon: {
			paths: [
				"M544 193.212v-65.212h128v-64c0-35.346-28.654-64-64.002-64h-191.998c-35.346 0-64 28.654-64 64v64h128v65.212c-214.798 16.338-384 195.802-384 414.788 0 229.75 186.25 416 416 416s416-186.25 416-416c0-218.984-169.202-398.448-384-414.788zM738.274 834.274c-60.442 60.44-140.798 93.726-226.274 93.726s-165.834-33.286-226.274-93.726c-60.44-60.44-93.726-140.8-93.726-226.274s33.286-165.834 93.726-226.274c58.040-58.038 134.448-91.018 216.114-93.548l-21.678 314.020c-1.86 26.29 12.464 37.802 31.836 37.802s33.698-11.512 31.836-37.802l-21.676-314.022c81.666 2.532 158.076 35.512 216.116 93.55 60.44 60.44 93.726 140.8 93.726 226.274s-33.286 165.834-93.726 226.274z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"stopwatch",
				"time",
				"speed",
				"meter",
				"chronometer"
			],
			defaultCode: 59998,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 134,
			order: 3431,
			prevSize: 32,
			code: 59998,
			ligatures: "stopwatch",
			name: "stopwatch"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 134
	},
	{
		icon: {
			paths: [
				"M837.714 381.714c71.954 0 130.286 58.332 130.286 130.286s-58.332 130.286-130.286 130.286c-71.954 0-130.286-58.332-130.286-130.286s58.332-130.286 130.286-130.286zM512 381.714c71.954 0 130.286 58.332 130.286 130.286s-58.332 130.286-130.286 130.286c-71.954 0-130.286-58.332-130.286-130.286s58.332-130.286 130.286-130.286zM186.286 381.714c71.954 0 130.286 58.332 130.286 130.286s-58.332 130.286-130.286 130.286c-71.954 0-130.286-58.332-130.286-130.286s58.332-130.286 130.286-130.286z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"three-dots-horizontal"
			],
			defaultCode: 60519,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 135,
			order: 3430,
			ligatures: "three-dots-horizontal",
			prevSize: 32,
			code: 60519,
			name: "three-dots-horizontal"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 135
	},
	{
		icon: {
			paths: [
				"M374.856 169.144c0-75.741 61.401-137.144 137.144-137.144s137.144 61.401 137.144 137.144c0 75.741-61.401 137.144-137.144 137.144s-137.144-61.401-137.144-137.144zM374.856 512c0-75.741 61.401-137.144 137.144-137.144s137.144 61.401 137.144 137.144c0 75.741-61.401 137.144-137.144 137.144s-137.144-61.401-137.144-137.144zM374.856 854.856c0-75.741 61.401-137.144 137.144-137.144s137.144 61.401 137.144 137.144c0 75.741-61.401 137.144-137.144 137.144s-137.144-61.401-137.144-137.144z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"more",
				"dots",
				"menu"
			],
			defaultCode: 60505,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 136,
			order: 3429,
			prevSize: 32,
			code: 60505,
			ligatures: "three-dots-vertical",
			name: "three-dots-vertical"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 136
	},
	{
		icon: {
			paths: [
				"M1001.141 467.696c-19.321-103.047-45.727-236.366-64.405-326.532s-75.997-94.031-169.385-94.031c-155.044 9.223-300.151 35.192-438.773 76.259l13.7-3.482c-20.614 6.066-35.41 24.811-35.423 47.015v0.001c0 81.15 0 275.009 0 352.939-0.010 0.364-0.016 0.792-0.016 1.222 0 18.722 10.942 34.888 26.782 42.451l0.284 0.122c145.555 66.981 220.909 307.211 247.959 371.617s157.792 55.388 143.623-36.71c-7.084-50.88-18.033-113.353-25.117-201.587-5.153-51.524 3.864-84.37 28.338-82.439 29.374 3.368 63.414 5.289 97.904 5.289 17.895 0 35.669-0.517 53.309-1.538l-2.438 0.113c96.607-5.153 147.487-39.931 123.657-150.707z",
				"M255.332 525.017v-379.346c-1.001-10.898-10.096-19.365-21.17-19.365-0.483 0-0.962 0.016-1.436 0.047l0.065-0.003h-193.215c-0.411-0.028-0.889-0.044-1.372-0.044-11.074 0-20.169 8.469-21.163 19.282l-0.006 0.083v379.346c1.001 10.898 10.096 19.365 21.17 19.365 0.483 0 0.962-0.016 1.436-0.047l-0.065 0.003h193.215c0.411 0.028 0.889 0.044 1.372 0.044 11.074 0 20.169-8.469 21.163-19.282l0.006-0.083z"
			],
			attrs: [
				{
				},
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"thumbs-down"
			],
			defaultCode: 59656,
			grid: 32
		},
		attrs: [
			{
			},
			{
			}
		],
		properties: {
			order: 3428,
			id: 137,
			name: "thumbs-down",
			prevSize: 32,
			code: 59656
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 137
	},
	{
		icon: {
			paths: [
				"M879.48 405.486c-15.228-0.909-33.031-1.427-50.958-1.427-34.549 0-68.648 1.924-102.196 5.672l4.125-0.374c-23.87 0-33.548-30.967-28.386-81.934 7.742-89.031 18.064-151.61 25.16-202.577 14.838-92.256-115.482-107.74-143.869-36.774s-102.579 307.736-247.092 374.832c-16.15 7.697-27.113 23.892-27.113 42.646 0 0.43 0.006 0.86 0.017 1.287l-0.001-0.064c0 78.063 0 272.252 0 353.541 0.235 22.168 14.954 40.836 35.132 47.003l0.352 0.093c125.767 37.805 271.809 63.83 422.474 72.656l5.26 0.246c92.256 0 147.094-7.097 166.449-93.547s47.096-224.512 64.515-327.736-26.451-147.094-123.869-153.546z",
				"M233.686 482.259h-193.545c-0.429-0.030-0.931-0.047-1.438-0.047-11.222 0-20.475 8.426-21.778 19.297l-0.010 0.104v379.992c1.313 10.975 10.566 19.402 21.788 19.402 0.506 0 1.007-0.017 1.504-0.050l-0.068 0.004h193.545c0.429 0.030 0.931 0.047 1.438 0.047 11.222 0 20.475-8.426 21.778-19.297l0.010-0.104v-379.992c-1.313-10.975-10.566-19.402-21.788-19.402-0.506 0-1.007 0.017-1.504 0.050l0.068-0.004z"
			],
			attrs: [
				{
				},
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"thumbs-up"
			],
			defaultCode: 59651,
			grid: 32
		},
		attrs: [
			{
			},
			{
			}
		],
		properties: {
			order: 3427,
			id: 138,
			name: "thumbs-up",
			prevSize: 32,
			code: 59651
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 138
	},
	{
		icon: {
			paths: [
				"M202 1008h620l62-682h-744zM636 140v-124h-248v124h-310v186l62-62h744l62 62v-186h-310zM574 140h-124v-62h124v62z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"bin",
				"trashcan",
				"remove",
				"delete",
				"recycle",
				"dispose"
			],
			defaultCode: 60411,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 139,
			order: 3426,
			prevSize: 32,
			code: 60411,
			ligatures: "trash",
			name: "trash"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 139
	},
	{
		icon: {
			paths: [
				"M224 368l288 288 288-288h-576z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-down-small"
			],
			defaultCode: 60870,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 140,
			order: 3425,
			ligatures: "triangle-down",
			prevSize: 32,
			code: 60870,
			name: "triangle-down-small"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 140
	},
	{
		icon: {
			paths: [
				"M656 224l-288 288 288 288v-576z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-left-small"
			],
			defaultCode: 60871,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 141,
			order: 3424,
			ligatures: "triangle-left",
			prevSize: 32,
			code: 60871,
			name: "triangle-left-small"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 141
	},
	{
		icon: {
			paths: [
				"M368 800l288-288-288-288v576z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-right-small"
			],
			defaultCode: 60869,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 142,
			order: 3423,
			ligatures: "triangle-right",
			prevSize: 32,
			code: 60869,
			name: "triangle-right-small"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 142
	},
	{
		icon: {
			paths: [
				"M800 656l-288-288-288 288h576z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-up-small"
			],
			defaultCode: 60868,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 143,
			order: 3422,
			ligatures: "triangle-up",
			prevSize: 32,
			code: 60868,
			name: "triangle-up-small"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 143
	},
	{
		icon: {
			paths: [
				"M0 284.444l512 512 512-512h-1024z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-down"
			],
			defaultCode: 60873,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 144,
			order: 3421,
			ligatures: "triangle-down",
			prevSize: 32,
			name: "triangle-down",
			code: 60873
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 144
	},
	{
		icon: {
			paths: [
				"M760 16l-496 496 496 496v-992z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-left"
			],
			defaultCode: 60874,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 145,
			order: 3420,
			ligatures: "triangle-left",
			prevSize: 32,
			name: "triangle-left",
			code: 60874
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 145
	},
	{
		icon: {
			paths: [
				"M264 1008l496-496-496-496v992z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-right"
			],
			defaultCode: 60875,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 146,
			order: 3419,
			ligatures: "triangle-right",
			prevSize: 32,
			name: "triangle-right",
			code: 60875
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 146
	},
	{
		icon: {
			paths: [
				"M992 752l-480-480-480 480h960z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"triangle-up"
			],
			defaultCode: 60876,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 147,
			order: 3418,
			ligatures: "triangle-up",
			prevSize: 32,
			name: "triangle-up",
			code: 60876
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 147
	},
	{
		icon: {
			paths: [
				"M1004.308 542.77l-123.077-246.155h-184.615v-123.077c0-33.846-27.692-61.538-61.538-61.538h-553.847c-33.846 0-61.538 27.692-61.538 61.538v492.309l61.538 61.538h78.044c-10.479 18.108-16.506 39.113-16.506 61.538 0 67.973 55.104 123.077 123.077 123.077s123.077-55.104 123.077-123.077c0-22.425-6.027-43.431-16.506-61.538h340.707c-10.479 18.108-16.508 39.113-16.508 61.538 0 67.973 55.104 123.077 123.077 123.077s123.077-55.104 123.077-123.077c0-22.425-6.029-43.431-16.508-61.538h78.046v-184.615zM696.614 542.77v-184.615h127.565l92.308 184.615h-219.873z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"truck"
			],
			defaultCode: 60428,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 148,
			order: 3417,
			ligatures: "truck",
			prevSize: 32,
			code: 60428,
			name: "truck"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 148
	},
	{
		icon: {
			paths: [
				"M442.532 631.805c-12.884 0-25.764-4.914-35.593-14.743-92.090-92.092-92.090-241.936 0-334.028l185.856-185.856c44.613-44.611 103.924-69.179 167.013-69.179s122.402 24.568 167.015 69.177c92.088 92.092 92.088 241.936 0 334.028l-84.957 84.957c-19.658 19.658-51.527 19.658-71.187 0-19.656-19.656-19.656-51.529 0-71.187l84.957-84.957c52.837-52.839 52.837-138.815 0-191.654-25.596-25.596-59.629-39.692-95.828-39.692s-70.23 14.096-95.828 39.694l-185.856 185.854c-52.839 52.839-52.839 138.817 0 191.656 19.658 19.656 19.656 51.529 0 71.187-9.825 9.827-22.711 14.743-35.591 14.743z",
				"M264.192 996c-63.090 0-122.404-24.568-167.013-69.177-92.090-92.092-92.090-241.936 0-334.028l84.956-84.956c19.658-19.656 51.531-19.656 71.187 0 19.658 19.656 19.658 51.529 0 71.187l-84.956 84.956c-52.839 52.839-52.839 138.817 0 191.656 25.594 25.594 59.627 39.69 95.826 39.69s70.23-14.096 95.83-39.694l185.856-185.854c52.837-52.839 52.837-138.817 0-191.656-19.658-19.658-19.656-51.529 0-71.187 19.656-19.656 51.529-19.656 71.187 0.002 92.088 92.090 92.088 241.934 0.002 334.026l-185.858 185.856c-44.615 44.613-103.928 69.179-167.017 69.179z",
				"M914.688 821.76c-7.928 0-15.854-3.024-21.902-9.074l-123.904-123.904c-12.098-12.096-12.098-31.71 0-43.806 12.096-12.096 31.71-12.096 43.806 0l123.904 123.904c12.098 12.096 12.098 31.71 0 43.806-6.048 6.050-13.976 9.074-21.904 9.074z",
				"M976.64 635.904h-123.904c-17.108 0-30.976-13.868-30.976-30.976s13.868-30.976 30.976-30.976h123.904c17.108 0 30.976 13.868 30.976 30.976s-13.868 30.976-30.976 30.976z",
				"M728.832 883.712c-17.108 0-30.976-13.868-30.976-30.976v-123.902c0-17.108 13.868-30.976 30.976-30.976s30.976 13.868 30.976 30.976v123.902c0 17.108-13.868 30.976-30.976 30.976z",
				"M171.264 450.048h-123.904c-17.106 0-30.976-13.87-30.976-30.976s13.87-30.976 30.976-30.976h123.904c17.106 0 30.976 13.87 30.976 30.976s-13.868 30.976-30.976 30.976z",
				"M233.216 388.096c-7.928 0-15.854-3.024-21.902-9.074l-123.904-123.904c-12.098-12.096-12.098-31.71 0-43.806 12.096-12.098 31.71-12.098 43.806 0l123.904 123.904c12.098 12.096 12.098 31.71 0 43.806-6.048 6.050-13.976 9.074-21.904 9.074z",
				"M295.168 326.144c-17.106 0-30.976-13.87-30.976-30.976v-123.904c0-17.106 13.87-30.976 30.976-30.976s30.976 13.87 30.976 30.976v123.904c0 17.106-13.868 30.976-30.976 30.976z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"unlink",
				"link",
				"break"
			],
			defaultCode: 60567,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 149,
			order: 3416,
			prevSize: 32,
			code: 60567,
			ligatures: "unlink",
			name: "unlink"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 149
	},
	{
		icon: {
			paths: [
				"M809.6 16c109.399 0 198.4 89.001 198.4 198.4v198.4h-132.266v-198.4c0-36.467-29.667-66.134-66.134-66.134h-132.266c-36.467 0-66.134 29.667-66.134 66.134v198.4h16.534c27.28 0 49.6 22.32 49.6 49.6v496c0 27.28-22.32 49.6-49.6 49.6h-562.134c-27.28 0-49.6-22.32-49.6-49.6v-496c0-27.28 22.32-49.6 49.6-49.6h413.334v-198.4c0-109.399 89.001-198.4 198.4-198.4h132.266z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"unlocked",
				"lock-open"
			],
			defaultCode: 60241,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 150,
			order: 3415,
			prevSize: 32,
			code: 60241,
			ligatures: "unlocked",
			name: "unlocked"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 150
	},
	{
		icon: {
			paths: [
				"M582.681 691.589v-58.29c77.859-43.875 141.363-153.26 141.363-262.662 0-175.663 0-318.066-212.044-318.066s-212.044 142.403-212.044 318.066c0 109.401 63.505 218.787 141.363 262.662v58.29c-239.767 19.6-424.088 137.409-424.088 279.84h989.538c0-142.432-184.322-260.24-424.088-279.84z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"user"
			],
			defaultCode: 60148,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 151,
			order: 3414,
			ligatures: "user",
			prevSize: 32,
			code: 60148,
			name: "user"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 151
	},
	{
		icon: {
			width: 1024,
			paths: [
				"M388 729c0-146.508 92.878-271.721 222.844-319.881 15.771-35.396 25.156-74.753 25.156-114.119 0-154.087 0-279-186-279s-186 124.913-186 279c0 95.964 55.705 191.913 124 230.4v51.131c-210.318 17.193-372 120.532-372 245.47h384.89c-8.393-29.576-12.89-60.772-12.89-93z",
				"M729 450c-154.087 0-279 124.913-279 279s124.913 279 279 279c154.086 0 279-124.913 279-279s-124.913-279-279-279zM884 760h-124v124h-62v-124h-124v-62h124v-124h62v124h124v62z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"user-plus",
				"user",
				"user-add",
				"profile",
				"avatar",
				"person",
				"member"
			],
			defaultCode: 60150,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 152,
			order: 3413,
			prevSize: 32,
			code: 60150,
			ligatures: "user-add",
			name: "user-add"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 152
	},
	{
		icon: {
			paths: [
				"M676.667 733.795v-45.267c60.462-34.072 109.778-119.016 109.778-203.974 0-136.414 0-247-164.667-247s-164.667 110.586-164.667 247c0 84.957 49.316 169.901 109.778 203.974v45.267c-186.196 15.221-329.333 106.708-329.333 217.316h768.444c0-110.608-143.138-202.094-329.333-217.316z",
				"M298.616 754.993c47.436-31.003 106.416-54.576 171.346-68.966-12.911-15.252-24.621-32.266-34.728-50.618-26.085-47.371-39.873-99.536-39.873-150.853 0-73.793 0-143.492 26.244-200.483 25.477-55.321 71.294-89.62 136.555-102.478-14.506-65.592-53.122-108.706-155.938-108.706-164.667 0-164.667 110.586-164.667 247 0 84.957 49.316 169.901 109.778 203.974v45.267c-186.196 15.221-329.333 106.708-329.333 217.316h239.286c12.451-11.073 26.24-21.588 41.33-31.451z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"users",
				"group",
				"team",
				"members",
				"community",
				"collaborate"
			],
			defaultCode: 60149,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 153,
			order: 3412,
			prevSize: 32,
			code: 60149,
			ligatures: "users",
			name: "users"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 153
	},
	{
		icon: {
			paths: [
				"M512.004 561.434c81.775 0 155.925 33.265 209.633 86.972l-69.878 69.878c-35.804-35.804-85.24-57.982-139.755-57.982s-103.95 22.176-139.755 57.982l-69.878-69.878c53.707-53.707 127.858-86.972 209.633-86.972zM162.451 508.487c93.369-93.369 217.509-144.788 349.552-144.788s256.183 51.419 349.553 144.788l-69.911 69.91c-74.696-74.695-174.007-115.829-279.642-115.829s-204.946 41.135-279.64 115.832l-69.911-69.911zM781.406 220.368c82.417 34.86 156.424 84.755 219.967 148.299v0l-69.91 69.91c-112.041-112.041-261.011-173.746-419.462-173.746s-307.419 61.705-419.462 173.746l-69.911-69.911c63.545-63.543 137.552-113.438 219.968-148.298 85.353-36.101 175.993-54.407 269.402-54.407s184.048 18.307 269.402 54.407zM462.57 808.605c0-27.302 22.133-49.434 49.434-49.434s49.434 22.133 49.434 49.434c0 27.302-22.133 49.434-49.434 49.434s-49.434-22.133-49.434-49.434z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"connection",
				"wifi",
				"wave"
			],
			defaultCode: 59772,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3405,
			id: 154,
			prevSize: 32,
			code: 59772,
			ligatures: "wifi",
			name: "wifi"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 154
	},
	{
		icon: {
			paths: [
				"M388 202h-62v124h-124v62h124v124h62v-124h124v-62h-124zM633.619 556.415c40.5-56.081 64.381-124.953 64.381-199.415 0-188.329-152.671-341-341-341s-341 152.671-341 341 152.671 341 341 341c74.462 0 143.334-23.882 199.415-64.381l327.585 374.381 124-124-374.381-327.585zM357 605c-136.966 0-248-111.034-248-248s111.034-248 248-248 248 111.034 248 248-111.032 248-248 248z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"zoom-in",
				"magnifier",
				"magnifier-plus",
				"enlarge"
			],
			defaultCode: 60209,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 155,
			order: 3406,
			prevSize: 32,
			code: 60209,
			ligatures: "zoom-in",
			name: "zoom-in"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 155
	},
	{
		icon: {
			paths: [
				"M202 326h310v62h-310zM633.619 556.415c40.5-56.081 64.381-124.953 64.381-199.415 0-188.329-152.671-341-341-341s-341 152.671-341 341 152.671 341 341 341c74.462 0 143.334-23.882 199.415-64.381l327.585 374.381 124-124-374.381-327.585zM357 605c-136.966 0-248-111.034-248-248s111.034-248 248-248 248 111.034 248 248-111.032 248-248 248z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"zoom-out",
				"magnifier",
				"magnifier-minus",
				"reduce"
			],
			defaultCode: 60210,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 156,
			order: 3407,
			prevSize: 32,
			code: 60210,
			ligatures: "zoom-out",
			name: "zoom-out"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 156
	},
	{
		icon: {
			paths: [
				"M654.158 716.159l-80.158 80.16v-568.635l80.158 80.16c12.107 12.105 27.976 18.158 43.842 18.158s31.734-6.053 43.842-18.16c24.211-24.213 24.211-63.469 0-87.682l-185.999-185.999c-24.215-24.213-63.469-24.213-87.682 0l-185.999 185.999c-24.213 24.213-24.213 63.469 0 87.682s63.469 24.213 87.682 0l80.158-80.158v568.635l-80.16-80.16c-24.213-24.211-63.469-24.211-87.682 0-24.213 24.213-24.213 63.471 0 87.683l185.999 185.999c12.107 12.105 27.976 18.158 43.842 18.158s31.734-6.053 43.842-18.158l185.999-185.999c24.211-24.213 24.211-63.471 0-87.683-24.215-24.211-63.469-24.211-87.683 0z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"arrow-resize",
				"vertical"
			],
			defaultCode: 61060,
			grid: 32
		},
		attrs: [
		],
		properties: {
			id: 157,
			order: 3408,
			prevSize: 32,
			code: 61060,
			ligatures: "arrow-resize4, vertical",
			name: "arrows-up-down"
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 157
	},
	{
		icon: {
			paths: [
				"M510.455 17.595c-272.502 0-494.405 221.904-494.405 494.405s221.904 494.405 494.405 494.405c272.502 0 494.405-221.904 494.405-494.405 0-123.022-45.964-234.842-120.511-321.363l123.601-123.601h-299.733v299.733l106.606-106.606c56.779 68.174 91.156 155.66 91.156 251.837 0 219.006-176.518 395.524-395.524 395.524s-395.524-176.518-395.524-395.524c0-219.006 176.518-395.524 395.524-395.524v-98.881zM510.455 215.357c-81.886 0-148.321 66.436-148.321 148.321s66.436 148.321 148.321 148.321c81.886 0 148.321-66.436 148.321-148.321s-66.436-148.321-148.321-148.321zM510.455 610.882c-129.587 0-208.384 54.075-251.837 100.426 58.904 73.968 150.060 122.057 251.837 122.057s192.933-48.089 251.837-122.057c-43.455-46.351-122.25-100.426-251.837-100.426z"
			],
			attrs: [
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"Dealer Swap"
			],
			defaultCode: 59662,
			grid: 32
		},
		attrs: [
		],
		properties: {
			order: 3409,
			id: 158,
			name: "profile-ccw-circle-arrow",
			prevSize: 32,
			code: 59662
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 158
	},
	{
		icon: {
			paths: [
				"M960.578 16.002h-379.383c-26.083 0-62.504 15.081-80.967 33.544l-470.403 470.403c-18.431 18.431-18.431 48.623 0 67.056l407.171 407.171c18.431 18.431 48.623 18.431 67.056 0l470.403-470.403c18.431-18.431 33.544-54.884 33.544-80.967v-379.383c0-26.083-21.341-47.423-47.423-47.423zM723.463 395.382c-52.386 0-94.844-42.459-94.844-94.844s42.459-94.844 94.844-94.844 94.844 42.459 94.844 94.844-42.459 94.844-94.844 94.844z"
			],
			attrs: [
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"price tag"
			],
			defaultCode: 59663,
			grid: 32
		},
		attrs: [
			{
			}
		],
		properties: {
			order: 3410,
			id: 159,
			name: "price-tag",
			prevSize: 32,
			code: 59663
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 159
	},
	{
		icon: {
			paths: [
				"M898.265 362.478c3.322-8.307 4.984-14.952 4.984-23.259v0c1.662-26.582 1.662-39.873-29.904-39.873-29.904 0-59.81 4.984-86.392 18.274-29.904-6.646-59.81-11.63-91.376-11.63-81.406 0-157.829 24.921-219.302 69.776-23.259 1.662-48.18 3.322-71.439 6.646-29.904 3.322-54.825 23.259-63.132 49.841-6.646 13.291-9.968 26.582-9.968 41.534 0 18.274 9.968 29.904 23.259 36.551-18.274 33.228-31.565 68.116-38.211 106.328h-63.132v49.841c0 14.952-11.63 26.582-26.582 28.243h-117.957c-14.952-1.662-26.582-13.291-26.582-28.243v-99.683c-1.662-6.646-3.322-13.291-3.322-19.937l-4.984-56.487c0 0-6.646-66.455-6.646-154.508 0-41.534 14.952-53.164 36.551-73.101 3.322-3.322 8.307-6.646 11.63-11.63l33.228-31.565h-83.067c-24.921 0-49.841-23.259-49.841-38.211v-19.937c0 0 0-1.662 0-1.662 0-14.952 11.63-24.921 24.921-24.921h68.116c6.646 0 14.952 3.322 18.274 8.307 3.322 3.322 4.984 9.968 8.307 16.614 3.322 8.307 6.646 16.614 9.968 16.614h28.243c4.984-13.291 11.63-26.582 18.274-39.873 8.307-18.274 16.614-34.889 26.582-51.503 0 0 14.952-21.599 24.921-29.904 11.63-13.291 28.243-23.259 46.519-26.582 24.921-4.984 58.147-6.646 58.147-6.646l71.439-3.322h189.397l73.101 3.322c0 0 33.228 3.322 58.147 6.646 18.274 3.322 34.889 11.63 46.519 26.582 8.307 9.968 23.259 29.904 23.259 29.904 9.968 16.614 19.937 33.228 28.243 51.503 6.646 13.291 13.291 26.582 18.274 39.873h21.599c3.322 0 6.646-8.307 9.968-16.614 1.662-6.646 4.984-11.63 8.307-16.614 4.984-4.984 11.63-8.307 19.937-8.307h64.794c0 0 1.662 0 1.662 0 13.291 0 24.921 11.63 24.921 24.921v24.921c0 14.952-26.582 38.211-49.841 38.211h-76.424l33.228 29.904c4.984 4.984 9.968 8.307 13.291 13.291 21.599 18.274 34.889 31.565 34.889 71.439 0 26.582 0 51.503-1.662 73.101-21.599-19.937-41.534-34.889-63.132-48.18zM210.458 400.689c28.243 1.662 56.487-1.662 84.731-6.646v1.662c1.662 0 4.984-1.662 6.646-1.662 9.968-4.984 13.291-18.274 6.646-28.243-14.952-18.274-34.889-33.228-56.487-41.534-31.565-18.274-66.455-26.582-103.005-26.582-31.565 0-33.228 13.291-31.565 39.873 0 19.937 11.63 39.873 28.243 51.503 21.599 9.968 43.195 14.952 64.794 11.63zM153.971 533.6h76.424c24.921 0 28.243-4.984 28.243-13.291-1.662-6.646-3.322-11.63-6.646-18.274-3.322-4.984-8.307-9.968-14.952-13.291-8.307-3.322-16.614-4.984-24.921-4.984h-66.455c-11.63 0-18.274 1.662-18.274 13.291s6.646 36.551 26.582 36.551zM243.685 121.58c-11.63 16.614-19.937 34.889-28.243 54.825-11.63 29.904 8.307 41.534 19.937 41.534h176.106l98.021-1.662 98.021 1.662c0 0 166.138-1.662 177.767-1.662s33.228-8.307 19.937-39.873c-8.307-18.274-16.614-36.551-28.243-54.825-6.646-11.63-16.614-21.599-26.582-29.904-18.274-9.968-38.211-14.952-58.147-16.614-49.841-6.646-134.57-6.646-134.57-6.646h-93.036c0 0-84.731 0-136.233 4.984-19.937 1.662-39.873 6.646-58.147 16.614-9.968 9.968-19.937 19.937-26.582 31.565z",
				"M695.577 1005.429c171.121 0 309.015-139.556 309.015-312.337s-137.894-312.337-309.015-312.337-309.015 139.556-309.015 312.337c0 172.781 137.894 312.337 309.015 312.337zM640.753 492.065c26.582-9.968 54.825-13.291 84.731-13.291v0c29.904 1.662 58.147 8.307 86.392 21.599s51.503 31.565 71.439 53.164c19.937 21.599 33.228 46.519 43.195 74.762 9.968 26.582 13.291 54.825 11.63 84.731s-8.307 58.147-21.599 86.392c-9.968 19.937-21.599 36.551-34.889 53.164-13.291 14.952-28.243 28.243-46.519 39.873v0 0c-16.614 9.968-34.889 18.274-54.825 24.921s-38.211 8.307-59.81 9.968c-4.984 0-9.968-3.322-9.968-9.968 0-4.984 3.322-9.968 8.307-11.63 13.291-1.662 28.243-4.984 41.534-9.968s26.582-11.63 38.211-19.937v0 0c11.63-8.307 23.259-18.274 33.228-29.904s18.274-24.921 24.921-39.873c9.968-21.599 16.614-43.195 18.274-66.455v0 0c1.662-23.259 0-43.195-6.646-64.794v0 0c-6.646-19.937-14.952-38.211-28.243-54.825s-29.904-28.243-48.18-38.211c-16.614-8.307-34.889-13.291-54.825-13.291v0c-18.274-1.662-36.551 1.662-54.825 6.646s-34.889 14.952-51.503 26.582v0 0c-13.291 9.968-23.259 19.937-33.228 33.228l41.534 19.937c3.322 1.662 6.646 4.984 6.646 9.968 0 3.322-1.662 8.307-6.646 9.968l-127.926 56.487c-3.322 1.662-6.646 1.662-8.307 0-3.322-1.662-4.984-3.322-4.984-6.646l-36.551-136.233c-1.662-3.322 0-8.307 3.322-9.968 3.322-3.322 6.646-3.322 11.63-1.662l44.856 21.599c13.291-23.259 28.243-44.856 48.18-61.471 19.937-21.599 44.856-36.551 71.439-44.856z"
			],
			attrs: [
				{
				},
				{
				}
			],
			isMulticolor: false,
			isMulticolor2: false,
			tags: [
				"grounding"
			],
			grid: 32
		},
		attrs: [
			{
			},
			{
			}
		],
		properties: {
			order: 3411,
			id: 160,
			name: "grounding",
			prevSize: 32,
			code: 59664
		},
		setIdx: 0,
		setId: 51,
		iconIdx: 160
	}
];
var height = 1024;
var metadata = {
	name: "prism-icon-font",
	designer: ""
};
var preferences = {
	showGlyphs: true,
	showQuickUse: true,
	showQuickUse2: true,
	showSVGs: true,
	fontPref: {
		prefix: "prism-icon-",
		metadata: {
			fontFamily: "prism-icon-font",
			majorVersion: 1,
			minorVersion: 33,
			designer: ""
		},
		metrics: {
			emSize: 1024,
			baseline: 6.25,
			whitespace: 50
		},
		ie7: false,
		includeMetadata: true,
		embed: true,
		showSelector: true,
		showMetrics: true,
		showVersion: true,
		showMetadata: true,
		cssVars: true,
		autoHost: true,
		resetPoint: 58880,
		noie8: true,
		selector: "class",
		classSelector: ".icon",
		cssVarsFormat: "scss",
		postfix: "",
		hideFormats: true
	},
	imagePref: {
		prefix: "prism-icon-",
		png: true,
		useClassSelector: true,
		color: 4868682,
		bgColor: 16777215,
		classSelector: ".icon",
		height: 16,
		columns: 16,
		margin: 16,
		postfix: "",
		minifyJs: false,
		pdf: false,
		name: "prism-icons",
		addBgColor: false,
		sprite: false,
		overrideSize: true,
		xaml: false
	},
	historySize: 100,
	showCodes: true,
	gridSize: 16,
	quickUsageToken: {
		"Prism-UIONLY": false
	},
	showLiga: false,
	showGrid: true,
	fontUploadTime: "10/20/2021, 12:08:30 PM",
	fontUrlS3: "https://d1azc1qln24ryf.cloudfront.net/38428/Prism-UIONLY/style.css?ewxnph",
	fontCF: {
		url: "https://d1azc1qln24ryf.cloudfront.net/38428/Prism-UIONLY/style-cf.css?ewxnph",
		time: 1634746110844
	},
	fontUrlHash: "ewxnph",
	fontHostingName: "Prism-UIONLY"
};
var IconSelection = {
	IcoMoonType: IcoMoonType,
	icons: icons,
	height: height,
	metadata: metadata,
	preferences: preferences
};

/* eslint-disable react/jsx-filename-extension */
var IconNames = IconSelection.icons.map(function (i) {
  return i.properties.name;
});
function useIcon(glyph, color) {
  var selectedIcon = IconSelection.icons.find(function (i) {
    return i.properties.name === glyph;
  }) || false;
  if (!selectedIcon) return false;
  var isNull = !color;
  var isHex = color && color.includes('#');
  var fill = !isNull && isHex ? color : 'currentColor';
  var pathJsx = React.useMemo(function () {
    var icon = selectedIcon.icon;
    var paths = icon.paths;

    return paths.map(function (d) {
      return /*#__PURE__*/React.createElement("path", {
        d: d,
        key: d.slice(0, 40).trim(),
        fill: fill
      });
    }) || /*#__PURE__*/React.createElement("path", {
      fill: fill
    });
  });
  return {
    name: selectedIcon.properties.name,
    paths: selectedIcon.icon.paths,
    width: selectedIcon.icon.width,
    pathJsx: pathJsx
  };
}

var _excluded = ["glyph"],
    _excluded2 = ["title", "color", "height"];
function IconSvg(_ref) {
  var glyph = _ref.glyph,
      props = _objectWithoutProperties(_ref, _excluded);

  var icon = useIcon(glyph, props.color);
  if (!icon) return null;

  var title = props.title,
      color = props.color,
      height = props.height,
      htmlAttributes = _objectWithoutProperties(props, _excluded2);

  var svgProps = React.useMemo(function () {
    var iconWidth = icon.width || 1024;
    var floatWidth = iconWidth / 1024 * parseFloat(props.height, 10);
    var isHex = color && color.includes('#');
    var style = isHex ? _objectSpread2(_objectSpread2({}, htmlAttributes.style), {}, {
      color: color,
      fill: color
    }) : htmlAttributes.style;
    return _objectSpread2(_objectSpread2({}, htmlAttributes), {}, {
      width: "".concat(floatWidth, "px"),
      viewBox: props.viewBox || "0 0 ".concat(iconWidth, " 1024"),
      className: "icon prism-icon-svg prism-icon-".concat(glyph, " ").concat(props.className, " icon-").concat(color || 'default'),
      height: height,
      style: style
    });
  }, [props]);
  return /*#__PURE__*/React.createElement("svg", _extends({}, svgProps, {
    role: "figure",
    "aria-label": title || glyph,
    title: title || glyph
  }), icon.pathJsx);
}
IconSvg.propTypes = {
  glyph: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  xmlns: PropTypes.string,
  path: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string
};
IconSvg.defaultProps = {
  height: '16px',
  width: undefined,
  viewBox: null,
  xmlns: 'http://www.w3.org/2000/svg',
  path: null,
  className: '',
  title: '',
  glyph: null,
  color: null
};

var Icon = IconSvg;
Icon.SVG = IconSvg;

export { Icon, IconNames, IconSvg, Icon as default, useIcon };
//# sourceMappingURL=index.js.map
